const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  cartChange: "cart-change",
  cartAdd: "cart-add",
  quantityUpdate: "quantity-update",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  cartError: "cart-error",
  productState: "product-state",
};

function handleEventListeners(events = [], type = "add") {
  const evts = Array.isArray(events) ? events : [events];
  for (const evt of evts) {
    if (type === "add") {
      evt.el.addEventListener(evt.type, evt.callback);
    } else {
      evt.el.removeEventListener(evt.type, evt.callback);
    }
  }
}

async function updateCart(data) {
  const { type, source, items, submitter, sections, target, sections_url, reload } = data;

  const body = {};

  if (type === "add") {
    body.items = items;
  } else if (type === "update") {
    const updates = {};
    for (const item of items) {
      updates[item.id] = item.quantity;
    }
    body.updates = updates;
  }
  const product_ids = items.map((item) => {
    return item.product_id;
  });
  if (submitter) {
    submitter.classList.add("btn-elem--loading");
  }
  const critical_sections = ["header"];
  if (sections) {
    body.sections = [...critical_sections, ...sections].slice(0, 5).join(",");
  } else {
    body.sections = critical_sections;
  }
  if (sections_url) {
    body.sections_url = sections_url;
  }
  try {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    const response = await fetch(`/cart/${type}.js`, options);
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message);
    }
    if (reload) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("reloaded", "true");
      window.location.search = searchParams.toString();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      return;
    }
    const sections = {};
    for (const [key, value] of Object.entries(data.sections)) {
      const html = new DOMParser().parseFromString(value, "text/html");
      sections[key] = html;
    }
    publish(PUB_SUB_EVENTS.cartUpdate, {
      data: {
        type,
        source,
        response: data,
        sections,
        submitter,
        product_ids,
        target,
      },
    });
  } catch (error) {
    console.log(error);
    publish(PUB_SUB_EVENTS.cartError, {
      data: { message: error },
    });
  } finally {
    if (submitter) {
      submitter.classList.remove("btn-elem--loading");
    }
  }
}

window.theme = window.theme || {};
window.slate = window.slate || {};

class QuantityModule extends HTMLElement {
  constructor() {
    super();
    this.product_id = this.dataset.productId;
    this.section_id = this.dataset.sectionId;
    this.quantity = this.getCurrentQuantity;
    this.key = this.dataset.key || null;
  }

  parseEvent(details) {
    const { debounce, target } = details;

    const current_quantity = this.getCurrentQuantity;

    const quantity = current_quantity;

    const data = {
      target,
      section_id: this.section_id,
      product_id: this.product_id,
      quantity,
      upsell: this.upsell ? this.upsell : false,
    };

    if (debounce) {
      this.debounce(() => {
        publish(PUB_SUB_EVENTS.quantityUpdate, {
          data,
        });
      });
    } else {
      publish(PUB_SUB_EVENTS.quantityUpdate, {
        data,
      });
    }
  }

  get getCurrentQuantity() {
    return +this.querySelector('[name="quantity"]').value;
  }

  debounce(fn, wait = 500) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}
customElements.define("quantity-module", QuantityModule);

class QuantitySelector extends QuantityModule {
  constructor() {
    super();

    this.key = this.dataset.key || null;

    this.multiples = 1;
    this.apply_min = this.dataset.applyMinimum === "true" ? true : false;
    this.apply_debounce = this.dataset.debounce && this.dataset.debounce === "false" ? false : true;
    this.upsell = this.dataset.upsell && this.dataset.upsell === "true" ? true : false;

    this.decrease = this.querySelector(".quantity__button--minus");
    this.increase = this.querySelector(".quantity__button--plus");
    this.quantityInput = this.querySelector(".quantity__input");

    this.events = [
      {
        type: "click",
        el: this,
        callback: this.clickHandler.bind(this),
      },
      {
        type: "change",
        el: this,
        callback: this.changeHandler.bind(this),
      },
    ];
  }

  clickHandler(e) {
    if (e.target == this.decrease || e.target == this.increase) {
      this.handleQuantityChange(e);
    }
  }

  changeHandler(e) {
    this.quantity = this.quantityInput.value;
    this.handleQuantityChange(e);
  }

  connectedCallback() {
    handleEventListeners(this.events, "add");
  }

  disconnectedCallback() {
    handleEventListeners(this.events, "remove");
  }

  handleQuantityChange(e) {
    // this.quantity = +this.quantityInput.value;
    if (e.target == this.decrease) {
      if (this.apply_min) {
        if (this.quantity - this.multiples <= 0) return;
      } else {
        if (this.quantity - this.multiples < 0) return;
      }
      this.quantity = this.quantity - this.multiples;
    } else if (e.target == this.increase) {
      this.quantity = this.quantity + this.multiples;
    }
    this.quantity = +this.quantity;
    this.quantityInput.value = this.quantity;

    const details = {
      debounce: this.apply_debounce, // debounce based on el
      target: e.target,
    };

    this.parseEvent(details);
  }
}

customElements.define("quantity-selector", QuantitySelector);

class SiteSearch extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector("#site-search-dialog");
    this.search_button = this.querySelector('[data-action="open"]');
    this.close_button = this.querySelector('.site-search__close[data-action="close"]');
    this.input = this.querySelector('form input[type="search"]');
    this.results_container = this.querySelector(".site-search__results-container");

    this.search = {
      query: this.getAttribute("search-query"),
      type: this.dataset.searchType,
      limit: this.dataset.maxResults,
      scope: "each",
      fields: this.dataset.searchFields,
      unavailable: this.dataset.unavailableProducts,
    };

    this.events = [
      {
        el: this,
        type: "click",
        callback: this.clickHandler.bind(this),
      },
      {
        el: this.input,
        type: "input",
        callback: this.inputHandler.bind(this),
      },
      {
        el: document,
        type: "keydown",
        callback: this.keyboardHandler.bind(this),
      },
      {
        el: window,
        type: "pageshow",
        callback: this.historyRestoreHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    const header = document.querySelector('.site-header');
    if (header) {
      const inner = header.querySelector('.site-header__inner');
      const setMeasurements = () => {
        const rowGap = inner ? parseFloat(getComputedStyle(inner).rowGap) || 0 : 0;
        document.documentElement.style.setProperty(
          '--site-header-height',
          header.getBoundingClientRect().height + 'px'
        );
        document.documentElement.style.setProperty(
          '--site-search-bottom',
          (this.getBoundingClientRect().bottom + rowGap) + 'px'
        );
      };
      setMeasurements();
      new ResizeObserver(setMeasurements).observe(header);
    }
    if (this.dataset.animatePlaceholder) {
      this.animatePlaceholder();
    }
    handleEventListeners(this.events);
  }

  disconnectedCallback() {
    handleEventListeners(this.events, "remove");
  }

  historyRestoreHandler(e) {
    if (!e.persisted) return;

    this.input.value = "";
    this.setAttribute("search-query", "");
  }

  clickHandler(e) {
    if (this.search_button.contains(e.target)) {
      this.dialog.show();
      this.input.focus();
    }
    if (e.target.closest('[data-action="close"]')) {
      this.dialog.close();
    }
  }

  keyboardHandler(e) {
    if (e.key === "Escape") {
      this.dialog.close();
    }
  }
  inputHandler(e) {
    this.debounce(() => this.setSearchQuery(e));
  }

  setSearchQuery(e) {
    this.setAttribute("search-query", e.target.value);
  }

  attributeChangedCallback(name, prev, next) {
    if (prev === next) return;
    if (next === "") {
      this.querySelector("[data-results]").dataset.results = "false";
    } else {
      this.fetchSearchResults(next);
    }
  }

  static get observedAttributes() {
    return ["search-query"];
  }

  async fetchSearchResults(query) {
    this.results_container.classList.add("results--loading");
    const string = `/search/suggest?q=${query}&resources[type]=${this.search.type}&resources[limit]=${this.search.limit}&resources[limit_scope]=${this.search.scope}&resources[options][fields]=${this.search.fields}&resources[options][unavailable_products]=${this.search.unavailable}&section_id=site-predictive-search`;

    try {
      const response = await fetch(string);
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.text();
      const results = new DOMParser()
        .parseFromString(data, "text/html")
        .querySelector("#shopify-section-site-predictive-search");
      this.renderSearchResults(results);
    } catch (err) {
      console.log(err);
    } finally {
      this.results_container.classList.remove("results--loading");
    }
  }

  renderSearchResults(html) {
    const no_results = html.querySelector(".column--noresults");
    if (no_results) {
      this.querySelector(".column--noresults").innerHTML =
        html.querySelector(".column--noresults").innerHTML;
      this.querySelector("[data-results]").dataset.results = "none";
    } else {
      if (html.querySelector(".column--links")) {
        this.querySelector(".column--links").innerHTML =
          html.querySelector(".column--links").innerHTML;
      } else {
        this.querySelector(".column--links").innerHTML = "";
      }
      if (html.querySelector(".column--products")) {
        this.querySelector(".column--products").innerHTML =
          html.querySelector(".column--products").innerHTML;
      } else {
        this.querySelector(".column--products").innerHTML = "";
      }
      this.querySelector("[data-results]").dataset.results = "true";
    }
  }


  animatePlaceholder() {
    const placeholder_container = this.querySelector("[data-placeholder-strings]");

    if (placeholder_container) {
      const placeholder_values = placeholder_container.dataset.placeholderStrings.split("|||");
      if (placeholder_values.length > 1) {
        this.animation_string_index = 0;
        this.animation_value_index = placeholder_values[this.animation_string_index].length;
        this.delete = true;
        this.animation_speed = +this.dataset.animationSpeed || 100;
        this.delete_speed = +this.dataset.deleteSpeed || 50;
        this.animation_delay = +this.dataset.animationDelay || 1000;
        console.log(this.animation_speed, this.delete_speed, this.animation_delay);
        setTimeout(() => {
          this.typingEffect(placeholder_container, placeholder_values);
        }, this.animation_delay);
      }
    }
  }

  typingEffect(container, values) {
    const current_string = values[this.animation_string_index];
    let pause = false;
    if (this.delete && this.animation_value_index >= 0) {
      container.innerHTML = current_string.substr(0, this.animation_value_index);
      this.animation_value_index--;
    } else if (this.animation_value_index === -1) {
      this.animation_string_index + 1 >= values.length
        ? (this.animation_string_index = 0)
        : this.animation_string_index++;
      this.delete = !this.delete;
      this.animation_value_index = 0;
    } else if (this.animation_value_index < current_string.length) {
      container.innerHTML = current_string.substr(0, this.animation_value_index + 1);
      this.animation_value_index++;
    } else {
      pause = true;
      this.delete = !this.delete;
    }
    setTimeout(
      () => {
        this.typingEffect(container, values);
      },
      pause ? this.animation_delay : this.delete ? this.delete_speed : this.animation_speed,
    );
  }

  debounce(fn, wait = 500) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}
customElements.define("site-search", SiteSearch);

class SearchHistory extends HTMLElement {
  constructor() {
    super();

    this.search_history = localStorage.getItem("search-history")
      ? JSON.parse(localStorage.getItem("search-history"))
      : [];
  }

  connectedCallback() {
    if (this.search_history.length > 0) {
      this.renderSearchHistory();
    }
    const query = new URLSearchParams(window.location.search).get("q");
    if (!query) return;

    const ind = this.search_history.findIndex((value) => value.query === query);
    if (ind === -1) {
      this.storeQuery(query);
    } else if (ind > 0) {
      this.search_history.unshift(this.search_history.splice(ind, 1)[0]);
      localStorage.setItem("search-history", JSON.stringify(this.search_history));
    }
  }
  async storeQuery(q) {
    const string = `/search/suggest.json?q=${q}&resources[type]=product&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,tag`;

    try {
      const response = await fetch(string);
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.resources?.results?.products?.length > 0) {
        this.search_history.unshift({
          query: q,
          products: data.resources.results.products,
        });
        if (this.search_history.length >= +this.dataset.maxProducts - 1) {
          this.search_history = this.search_history.splice(0, +this.dataset.maxProducts);
        }
      }
    } catch (err) {
      console.log(err);
    }

    localStorage.setItem("search-history", JSON.stringify(this.search_history));
  }
  renderSearchHistory() {
    const container = this.querySelector(".site-predictive-search__list");
    for (const item of this.search_history) {
      const li = document.createElement("li");
      li.classList.add("site-predictive-search__list-item");
      const link = document.createElement("a");
      link.href = `/search?q=${item.query}&type=product`;
      link.classList.add("search-history__item");
      const img_grid = document.createElement("div");
      img_grid.classList.add("search-history__images");
      for (const prod of item.products) {
        const img = document.createElement("img");
        img.classList.add("search-history__image");
        img.src = prod.image + "&width=300";
        img_grid.appendChild(img);
      }
      const title = document.createElement("span");
      title.innerText = item.query;

      link.appendChild(img_grid);
      link.appendChild(title);
      li.appendChild(link);
      container.appendChild(li);
    }
    this.classList.add("search-history--loaded");
  }
}
customElements.define("search-history", SearchHistory);

/* ================ VENDORS ================ */
/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!(function (a) {
  (a.fn.equalHeights = function () {
    var b = 0,
      c = a(this);
    return (
      c.each(function () {
        var c = a(this).innerHeight();
        c > b && (b = c);
      }),
      c.css("height", b)
    );
  }),
    a("[data-equal]").each(function () {
      var b = a(this),
        c = b.data("equal");
      b.find(c).equalHeights();
    });
})(jQuery);

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!(function (a, b, c) {
  var d = window.matchMedia;
  "undefined" != typeof module && module.exports
    ? (module.exports = c(d))
    : "function" == typeof define && define.amd
      ? define(function () {
          return (b[a] = c(d));
        })
      : (b[a] = c(d));
})("enquire", this, function (a) {
  "use strict";
  function b(a, b) {
    var c,
      d = 0,
      e = a.length;
    for (d; e > d && ((c = b(a[d], d)), c !== !1); d++);
  }
  function c(a) {
    return "[object Array]" === Object.prototype.toString.apply(a);
  }
  function d(a) {
    return "function" == typeof a;
  }
  function e(a) {
    (this.options = a), !a.deferSetup && this.setup();
  }
  function f(b, c) {
    (this.query = b), (this.isUnconditional = c), (this.handlers = []), (this.mql = a(b));
    var d = this;
    (this.listener = function (a) {
      (d.mql = a), d.assess();
    }),
      this.mql.addListener(this.listener);
  }
  function g() {
    if (!a) throw new Error("matchMedia not present, legacy browsers require a polyfill");
    (this.queries = {}), (this.browserIsIncapable = !a("only all").matches);
  }
  return (
    (e.prototype = {
      setup: function () {
        this.options.setup && this.options.setup(), (this.initialised = !0);
      },
      on: function () {
        !this.initialised && this.setup(), this.options.match && this.options.match();
      },
      off: function () {
        this.options.unmatch && this.options.unmatch();
      },
      destroy: function () {
        this.options.destroy ? this.options.destroy() : this.off();
      },
      equals: function (a) {
        return this.options === a || this.options.match === a;
      },
    }),
    (f.prototype = {
      addHandler: function (a) {
        var b = new e(a);
        this.handlers.push(b), this.matches() && b.on();
      },
      removeHandler: function (a) {
        var c = this.handlers;
        b(c, function (b, d) {
          return b.equals(a) ? (b.destroy(), !c.splice(d, 1)) : void 0;
        });
      },
      matches: function () {
        return this.mql.matches || this.isUnconditional;
      },
      clear: function () {
        b(this.handlers, function (a) {
          a.destroy();
        }),
          this.mql.removeListener(this.listener),
          (this.handlers.length = 0);
      },
      assess: function () {
        var a = this.matches() ? "on" : "off";
        b(this.handlers, function (b) {
          b[a]();
        });
      },
    }),
    (g.prototype = {
      register: function (a, e, g) {
        var h = this.queries,
          i = g && this.browserIsIncapable;
        return (
          h[a] || (h[a] = new f(a, i)),
          d(e) && (e = { match: e }),
          c(e) || (e = [e]),
          b(e, function (b) {
            d(b) && (b = { match: b }), h[a].addHandler(b);
          }),
          this
        );
      },
      unregister: function (a, b) {
        var c = this.queries[a];
        return c && (b ? c.removeHandler(b) : (c.clear(), delete this.queries[a])), this;
      },
    }),
    new g()
  );
});

/*! Magnific Popup - v1.0.0 - 2015-03-30
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2015 Dmitry Semenov; */
!(function (a) {
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : a("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto);
})(function (a) {
  var b,
    c,
    d,
    e,
    f,
    g,
    h = "Close",
    i = "BeforeClose",
    j = "AfterClose",
    k = "BeforeAppend",
    l = "MarkupParse",
    m = "Open",
    n = "Change",
    o = "mfp",
    p = "." + o,
    q = "mfp-ready",
    r = "mfp-removing",
    s = "mfp-prevent-close",
    t = function () {},
    u = !!window.jQuery,
    v = a(window),
    w = function (a, c) {
      b.ev.on(o + a + p, c);
    },
    x = function (b, c, d, e) {
      var f = document.createElement("div");
      return (
        (f.className = "mfp-" + b),
        d && (f.innerHTML = d),
        e ? c && c.appendChild(f) : ((f = a(f)), c && f.appendTo(c)),
        f
      );
    },
    y = function (c, d) {
      b.ev.triggerHandler(o + c, d),
        b.st.callbacks &&
          ((c = c.charAt(0).toLowerCase() + c.slice(1)),
          b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]));
    },
    z = function (c) {
      return (
        (c === g && b.currTemplate.closeBtn) ||
          ((b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose))),
          (g = c)),
        b.currTemplate.closeBtn
      );
    },
    A = function () {
      a.magnificPopup.instance || ((b = new t()), b.init(), (a.magnificPopup.instance = b));
    },
    B = function () {
      var a = document.createElement("p").style,
        b = ["ms", "O", "Moz", "Webkit"];
      if (void 0 !== a.transition) return !0;
      for (; b.length; ) if (b.pop() + "Transition" in a) return !0;
      return !1;
    };
  (t.prototype = {
    constructor: t,
    init: function () {
      var c = navigator.appVersion;
      (b.isIE7 = -1 !== c.indexOf("MSIE 7.")),
        (b.isIE8 = -1 !== c.indexOf("MSIE 8.")),
        (b.isLowIE = b.isIE7 || b.isIE8),
        (b.isAndroid = /android/gi.test(c)),
        (b.isIOS = /iphone|ipad|ipod/gi.test(c)),
        (b.supportsTransition = B()),
        (b.probablyMobile =
          b.isAndroid ||
          b.isIOS ||
          /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
            navigator.userAgent,
          )),
        (d = a(document)),
        (b.popupsCache = {});
    },
    open: function (c) {
      var e;
      if (c.isObj === !1) {
        (b.items = c.items.toArray()), (b.index = 0);
        var g,
          h = c.items;
        for (e = 0; e < h.length; e++)
          if (((g = h[e]), g.parsed && (g = g.el[0]), g === c.el[0])) {
            b.index = e;
            break;
          }
      } else (b.items = a.isArray(c.items) ? c.items : [c.items]), (b.index = c.index || 0);
      if (b.isOpen) return void b.updateItemHTML();
      (b.types = []),
        (f = ""),
        (b.ev = c.mainEl && c.mainEl.length ? c.mainEl.eq(0) : d),
        c.key
          ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}),
            (b.currTemplate = b.popupsCache[c.key]))
          : (b.currTemplate = {}),
        (b.st = a.extend(!0, {}, a.magnificPopup.defaults, c)),
        (b.fixedContentPos =
          "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos),
        b.st.modal &&
          ((b.st.closeOnContentClick = !1),
          (b.st.closeOnBgClick = !1),
          (b.st.showCloseBtn = !1),
          (b.st.enableEscapeKey = !1)),
        b.bgOverlay ||
          ((b.bgOverlay = x("bg").on("click" + p, function () {
            b.close();
          })),
          (b.wrap = x("wrap")
            .attr("tabindex", -1)
            .on("click" + p, function (a) {
              b._checkIfClose(a.target) && b.close();
            })),
          (b.container = x("container", b.wrap))),
        (b.contentContainer = x("content")),
        b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));
      var i = a.magnificPopup.modules;
      for (e = 0; e < i.length; e++) {
        var j = i[e];
        (j = j.charAt(0).toUpperCase() + j.slice(1)), b["init" + j].call(b);
      }
      y("BeforeOpen"),
        b.st.showCloseBtn &&
          (b.st.closeBtnInside
            ? (w(l, function (a, b, c, d) {
                c.close_replaceWith = z(d.type);
              }),
              (f += " mfp-close-btn-in"))
            : b.wrap.append(z())),
        b.st.alignTop && (f += " mfp-align-top"),
        b.wrap.css(
          b.fixedContentPos
            ? { overflow: b.st.overflowY, overflowX: "hidden", overflowY: b.st.overflowY }
            : { top: v.scrollTop(), position: "absolute" },
        ),
        (b.st.fixedBgPos === !1 || ("auto" === b.st.fixedBgPos && !b.fixedContentPos)) &&
          b.bgOverlay.css({ height: d.height(), position: "absolute" }),
        b.st.enableEscapeKey &&
          d.on("keyup" + p, function (a) {
            27 === a.keyCode && b.close();
          }),
        v.on("resize" + p, function () {
          b.updateSize();
        }),
        b.st.closeOnContentClick || (f += " mfp-auto-cursor"),
        f && b.wrap.addClass(f);
      var k = (b.wH = v.height()),
        n = {};
      if (b.fixedContentPos && b._hasScrollBar(k)) {
        var o = b._getScrollbarSize();
        o && (n.marginRight = o);
      }
      b.fixedContentPos &&
        (b.isIE7 ? a("body, html").css("overflow", "hidden") : (n.overflow = "hidden"));
      var r = b.st.mainClass;
      return (
        b.isIE7 && (r += " mfp-ie7"),
        r && b._addClassToMFP(r),
        b.updateItemHTML(),
        y("BuildControls"),
        a("html").css(n),
        b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)),
        (b._lastFocusedEl = document.activeElement),
        setTimeout(function () {
          b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q),
            d.on("focusin" + p, b._onFocusIn);
        }, 16),
        (b.isOpen = !0),
        b.updateSize(k),
        y(m),
        c
      );
    },
    close: function () {
      b.isOpen &&
        (y(i),
        (b.isOpen = !1),
        b.st.removalDelay && !b.isLowIE && b.supportsTransition
          ? (b._addClassToMFP(r),
            setTimeout(function () {
              b._close();
            }, b.st.removalDelay))
          : b._close());
    },
    _close: function () {
      y(h);
      var c = r + " " + q + " ";
      if (
        (b.bgOverlay.detach(),
        b.wrap.detach(),
        b.container.empty(),
        b.st.mainClass && (c += b.st.mainClass + " "),
        b._removeClassFromMFP(c),
        b.fixedContentPos)
      ) {
        var e = { marginRight: "" };
        b.isIE7 ? a("body, html").css("overflow", "") : (e.overflow = ""), a("html").css(e);
      }
      d.off("keyup" + p + " focusin" + p),
        b.ev.off(p),
        b.wrap.attr("class", "mfp-wrap").removeAttr("style"),
        b.bgOverlay.attr("class", "mfp-bg"),
        b.container.attr("class", "mfp-container"),
        !b.st.showCloseBtn ||
          (b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0) ||
          (b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach()),
        b._lastFocusedEl && a(b._lastFocusedEl).focus(),
        (b.currItem = null),
        (b.content = null),
        (b.currTemplate = null),
        (b.prevHeight = 0),
        y(j);
    },
    updateSize: function (a) {
      if (b.isIOS) {
        var c = document.documentElement.clientWidth / window.innerWidth,
          d = window.innerHeight * c;
        b.wrap.css("height", d), (b.wH = d);
      } else b.wH = a || v.height();
      b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize");
    },
    updateItemHTML: function () {
      var c = b.items[b.index];
      b.contentContainer.detach(),
        b.content && b.content.detach(),
        c.parsed || (c = b.parseEl(b.index));
      var d = c.type;
      if (
        (y("BeforeChange", [b.currItem ? b.currItem.type : "", d]),
        (b.currItem = c),
        !b.currTemplate[d])
      ) {
        var f = b.st[d] ? b.st[d].markup : !1;
        y("FirstMarkupParse", f), (b.currTemplate[d] = f ? a(f) : !0);
      }
      e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");
      var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
      b.appendContent(g, d),
        (c.preloaded = !0),
        y(n, c),
        (e = c.type),
        b.container.prepend(b.contentContainer),
        y("AfterChange");
    },
    appendContent: function (a, c) {
      (b.content = a),
        a
          ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0
            ? b.content.find(".mfp-close").length || b.content.append(z())
            : (b.content = a)
          : (b.content = ""),
        y(k),
        b.container.addClass("mfp-" + c + "-holder"),
        b.contentContainer.append(b.content);
    },
    parseEl: function (c) {
      var d,
        e = b.items[c];
      if ((e.tagName ? (e = { el: a(e) }) : ((d = e.type), (e = { data: e, src: e.src })), e.el)) {
        for (var f = b.types, g = 0; g < f.length; g++)
          if (e.el.hasClass("mfp-" + f[g])) {
            d = f[g];
            break;
          }
        (e.src = e.el.attr("data-mfp-src")), e.src || (e.src = e.el.attr("href"));
      }
      return (
        (e.type = d || b.st.type || "inline"),
        (e.index = c),
        (e.parsed = !0),
        (b.items[c] = e),
        y("ElementParse", e),
        b.items[c]
      );
    },
    addGroup: function (a, c) {
      var d = function (d) {
        (d.mfpEl = this), b._openClick(d, a, c);
      };
      c || (c = {});
      var e = "click.magnificPopup";
      (c.mainEl = a),
        c.items
          ? ((c.isObj = !0), a.off(e).on(e, d))
          : ((c.isObj = !1),
            c.delegate ? a.off(e).on(e, c.delegate, d) : ((c.items = a), a.off(e).on(e, d)));
    },
    _openClick: function (c, d, e) {
      var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
      if (f || (2 !== c.which && !c.ctrlKey && !c.metaKey)) {
        var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
        if (g)
          if (a.isFunction(g)) {
            if (!g.call(b)) return !0;
          } else if (v.width() < g) return !0;
        c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()),
          (e.el = a(c.mfpEl)),
          e.delegate && (e.items = d.find(e.delegate)),
          b.open(e);
      }
    },
    updateStatus: function (a, d) {
      if (b.preloader) {
        c !== a && b.container.removeClass("mfp-s-" + c),
          d || "loading" !== a || (d = b.st.tLoading);
        var e = { status: a, text: d };
        y("UpdateStatus", e),
          (a = e.status),
          (d = e.text),
          b.preloader.html(d),
          b.preloader.find("a").on("click", function (a) {
            a.stopImmediatePropagation();
          }),
          b.container.addClass("mfp-s-" + a),
          (c = a);
      }
    },
    _checkIfClose: function (c) {
      if (!a(c).hasClass(s)) {
        var d = b.st.closeOnContentClick,
          e = b.st.closeOnBgClick;
        if (d && e) return !0;
        if (!b.content || a(c).hasClass("mfp-close") || (b.preloader && c === b.preloader[0]))
          return !0;
        if (c === b.content[0] || a.contains(b.content[0], c)) {
          if (d) return !0;
        } else if (e && a.contains(document, c)) return !0;
        return !1;
      }
    },
    _addClassToMFP: function (a) {
      b.bgOverlay.addClass(a), b.wrap.addClass(a);
    },
    _removeClassFromMFP: function (a) {
      this.bgOverlay.removeClass(a), b.wrap.removeClass(a);
    },
    _hasScrollBar: function (a) {
      return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height());
    },
    _setFocus: function () {
      (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus();
    },
    _onFocusIn: function (c) {
      return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target)
        ? void 0
        : (b._setFocus(), !1);
    },
    _parseMarkup: function (b, c, d) {
      var e;
      d.data && (c = a.extend(d.data, c)),
        y(l, [b, c, d]),
        a.each(c, function (a, c) {
          if (void 0 === c || c === !1) return !0;
          if (((e = a.split("_")), e.length > 1)) {
            var d = b.find(p + "-" + e[0]);
            if (d.length > 0) {
              var f = e[1];
              "replaceWith" === f
                ? d[0] !== c[0] && d.replaceWith(c)
                : "img" === f
                  ? d.is("img")
                    ? d.attr("src", c)
                    : d.replaceWith('<img src="' + c + '" class="' + d.attr("class") + '" />')
                  : d.attr(e[1], c);
            }
          } else b.find(p + "-" + a).html(c);
        });
    },
    _getScrollbarSize: function () {
      if (void 0 === b.scrollbarSize) {
        var a = document.createElement("div");
        (a.style.cssText =
          "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
          document.body.appendChild(a),
          (b.scrollbarSize = a.offsetWidth - a.clientWidth),
          document.body.removeChild(a);
      }
      return b.scrollbarSize;
    },
  }),
    (a.magnificPopup = {
      instance: null,
      proto: t.prototype,
      modules: [],
      open: function (b, c) {
        return (
          A(),
          (b = b ? a.extend(!0, {}, b) : {}),
          (b.isObj = !0),
          (b.index = c || 0),
          this.instance.open(b)
        );
      },
      close: function () {
        return a.magnificPopup.instance && a.magnificPopup.instance.close();
      },
      registerModule: function (b, c) {
        c.options && (a.magnificPopup.defaults[b] = c.options),
          a.extend(this.proto, c.proto),
          this.modules.push(b);
      },
      defaults: {
        disableOn: 0,
        key: null,
        midClick: !1,
        mainClass: "",
        preloader: !0,
        focus: "",
        closeOnContentClick: !1,
        closeOnBgClick: !0,
        closeBtnInside: !0,
        showCloseBtn: !0,
        enableEscapeKey: !0,
        modal: !1,
        alignTop: !1,
        removalDelay: 0,
        prependTo: null,
        fixedContentPos: "auto",
        fixedBgPos: "auto",
        overflowY: "auto",
        closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
        tClose: "Close (Esc)",
        tLoading: "Loading...",
      },
    }),
    (a.fn.magnificPopup = function (c) {
      A();
      var d = a(this);
      if ("string" == typeof c)
        if ("open" === c) {
          var e,
            f = u ? d.data("magnificPopup") : d[0].magnificPopup,
            g = parseInt(arguments[1], 10) || 0;
          f.items
            ? (e = f.items[g])
            : ((e = d), f.delegate && (e = e.find(f.delegate)), (e = e.eq(g))),
            b._openClick({ mfpEl: e }, d, f);
        } else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
      else
        (c = a.extend(!0, {}, c)),
          u ? d.data("magnificPopup", c) : (d[0].magnificPopup = c),
          b.addGroup(d, c);
      return d;
    });
  var C,
    D,
    E,
    F = "inline",
    G = function () {
      E && (D.after(E.addClass(C)).detach(), (E = null));
    };
  a.magnificPopup.registerModule(F, {
    options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" },
    proto: {
      initInline: function () {
        b.types.push(F),
          w(h + "." + F, function () {
            G();
          });
      },
      getInline: function (c, d) {
        if ((G(), c.src)) {
          var e = b.st.inline,
            f = a(c.src);
          if (f.length) {
            var g = f[0].parentNode;
            g &&
              g.tagName &&
              (D || ((C = e.hiddenClass), (D = x(C)), (C = "mfp-" + C)),
              (E = f.after(D).detach().removeClass(C))),
              b.updateStatus("ready");
          } else b.updateStatus("error", e.tNotFound), (f = a("<div>"));
          return (c.inlineElement = f), f;
        }
        return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d;
      },
    },
  });
  var H,
    I = "ajax",
    J = function () {
      H && a(document.body).removeClass(H);
    },
    K = function () {
      J(), b.req && b.req.abort();
    };
  a.magnificPopup.registerModule(I, {
    options: {
      settings: null,
      cursor: "mfp-ajax-cur",
      tError: '<a href="%url%">The content</a> could not be loaded.',
    },
    proto: {
      initAjax: function () {
        b.types.push(I), (H = b.st.ajax.cursor), w(h + "." + I, K), w("BeforeChange." + I, K);
      },
      getAjax: function (c) {
        H && a(document.body).addClass(H), b.updateStatus("loading");
        var d = a.extend(
          {
            url: c.src,
            success: function (d, e, f) {
              var g = { data: d, xhr: f };
              y("ParseAjax", g),
                b.appendContent(a(g.data), I),
                (c.finished = !0),
                J(),
                b._setFocus(),
                setTimeout(function () {
                  b.wrap.addClass(q);
                }, 16),
                b.updateStatus("ready"),
                y("AjaxContentAdded");
            },
            error: function () {
              J(),
                (c.finished = c.loadError = !0),
                b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src));
            },
          },
          b.st.ajax.settings,
        );
        return (b.req = a.ajax(d)), "";
      },
    },
  });
  var L,
    M = function (c) {
      if (c.data && void 0 !== c.data.title) return c.data.title;
      var d = b.st.image.titleSrc;
      if (d) {
        if (a.isFunction(d)) return d.call(b, c);
        if (c.el) return c.el.attr(d) || "";
      }
      return "";
    };
  a.magnificPopup.registerModule("image", {
    options: {
      markup:
        '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
      cursor: "mfp-zoom-out-cur",
      titleSrc: "title",
      verticalFit: !0,
      tError: '<a href="%url%">The image</a> could not be loaded.',
    },
    proto: {
      initImage: function () {
        var c = b.st.image,
          d = ".image";
        b.types.push("image"),
          w(m + d, function () {
            "image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor);
          }),
          w(h + d, function () {
            c.cursor && a(document.body).removeClass(c.cursor), v.off("resize" + p);
          }),
          w("Resize" + d, b.resizeImage),
          b.isLowIE && w("AfterChange", b.resizeImage);
      },
      resizeImage: function () {
        var a = b.currItem;
        if (a && a.img && b.st.image.verticalFit) {
          var c = 0;
          b.isLowIE &&
            (c =
              parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)),
            a.img.css("max-height", b.wH - c);
        }
      },
      _onImageHasSize: function (a) {
        a.img &&
          ((a.hasSize = !0),
          L && clearInterval(L),
          (a.isCheckingImgSize = !1),
          y("ImageHasSize", a),
          a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), (a.imgHidden = !1)));
      },
      findImageSize: function (a) {
        var c = 0,
          d = a.img[0],
          e = function (f) {
            L && clearInterval(L),
              (L = setInterval(function () {
                return d.naturalWidth > 0
                  ? void b._onImageHasSize(a)
                  : (c > 200 && clearInterval(L),
                    c++,
                    void (3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)));
              }, f));
          };
        e(1);
      },
      getImage: function (c, d) {
        var e = 0,
          f = function () {
            c &&
              (c.img[0].complete
                ? (c.img.off(".mfploader"),
                  c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")),
                  (c.hasSize = !0),
                  (c.loaded = !0),
                  y("ImageLoadComplete"))
                : (e++, 200 > e ? setTimeout(f, 100) : g()));
          },
          g = function () {
            c &&
              (c.img.off(".mfploader"),
              c === b.currItem &&
                (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))),
              (c.hasSize = !0),
              (c.loaded = !0),
              (c.loadError = !0));
          },
          h = b.st.image,
          i = d.find(".mfp-img");
        if (i.length) {
          var j = document.createElement("img");
          (j.className = "mfp-img"),
            c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")),
            (c.img = a(j).on("load.mfploader", f).on("error.mfploader", g)),
            (j.src = c.src),
            i.is("img") && (c.img = c.img.clone()),
            (j = c.img[0]),
            j.naturalWidth > 0 ? (c.hasSize = !0) : j.width || (c.hasSize = !1);
        }
        return (
          b._parseMarkup(d, { title: M(c), img_replaceWith: c.img }, c),
          b.resizeImage(),
          c.hasSize
            ? (L && clearInterval(L),
              c.loadError
                ? (d.addClass("mfp-loading"),
                  b.updateStatus("error", h.tError.replace("%url%", c.src)))
                : (d.removeClass("mfp-loading"), b.updateStatus("ready")),
              d)
            : (b.updateStatus("loading"),
              (c.loading = !0),
              c.hasSize || ((c.imgHidden = !0), d.addClass("mfp-loading"), b.findImageSize(c)),
              d)
        );
      },
    },
  });
  var N,
    O = function () {
      return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform), N;
    };
  a.magnificPopup.registerModule("zoom", {
    options: {
      enabled: !1,
      easing: "ease-in-out",
      duration: 300,
      opener: function (a) {
        return a.is("img") ? a : a.find("img");
      },
    },
    proto: {
      initZoom: function () {
        var a,
          c = b.st.zoom,
          d = ".zoom";
        if (c.enabled && b.supportsTransition) {
          var e,
            f,
            g = c.duration,
            j = function (a) {
              var b = a
                  .clone()
                  .removeAttr("style")
                  .removeAttr("class")
                  .addClass("mfp-animated-image"),
                d = "all " + c.duration / 1e3 + "s " + c.easing,
                e = {
                  position: "fixed",
                  zIndex: 9999,
                  left: 0,
                  top: 0,
                  "-webkit-backface-visibility": "hidden",
                },
                f = "transition";
              return (e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d), b.css(e), b;
            },
            k = function () {
              b.content.css("visibility", "visible");
            };
          w("BuildControls" + d, function () {
            if (b._allowZoom()) {
              if (
                (clearTimeout(e),
                b.content.css("visibility", "hidden"),
                (a = b._getItemToZoom()),
                !a)
              )
                return void k();
              (f = j(a)),
                f.css(b._getOffset()),
                b.wrap.append(f),
                (e = setTimeout(function () {
                  f.css(b._getOffset(!0)),
                    (e = setTimeout(function () {
                      k(),
                        setTimeout(function () {
                          f.remove(), (a = f = null), y("ZoomAnimationEnded");
                        }, 16);
                    }, g));
                }, 16));
            }
          }),
            w(i + d, function () {
              if (b._allowZoom()) {
                if ((clearTimeout(e), (b.st.removalDelay = g), !a)) {
                  if (((a = b._getItemToZoom()), !a)) return;
                  f = j(a);
                }
                f.css(b._getOffset(!0)),
                  b.wrap.append(f),
                  b.content.css("visibility", "hidden"),
                  setTimeout(function () {
                    f.css(b._getOffset());
                  }, 16);
              }
            }),
            w(h + d, function () {
              b._allowZoom() && (k(), f && f.remove(), (a = null));
            });
        }
      },
      _allowZoom: function () {
        return "image" === b.currItem.type;
      },
      _getItemToZoom: function () {
        return b.currItem.hasSize ? b.currItem.img : !1;
      },
      _getOffset: function (c) {
        var d;
        d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
        var e = d.offset(),
          f = parseInt(d.css("padding-top"), 10),
          g = parseInt(d.css("padding-bottom"), 10);
        e.top -= a(window).scrollTop() - f;
        var h = { width: d.width(), height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f };
        return (
          O()
            ? (h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)")
            : ((h.left = e.left), (h.top = e.top)),
          h
        );
      },
    },
  });
  var P = "iframe",
    Q = "//about:blank",
    R = function (a) {
      if (b.currTemplate[P]) {
        var c = b.currTemplate[P].find("iframe");
        c.length && (a || (c[0].src = Q), b.isIE8 && c.css("display", a ? "block" : "none"));
      }
    };
  a.magnificPopup.registerModule(P, {
    options: {
      markup:
        '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
      srcAction: "iframe_src",
      patterns: {
        youtube: { index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1" },
        vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" },
        gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
      },
    },
    proto: {
      initIframe: function () {
        b.types.push(P),
          w("BeforeChange", function (a, b, c) {
            b !== c && (b === P ? R() : c === P && R(!0));
          }),
          w(h + "." + P, function () {
            R();
          });
      },
      getIframe: function (c, d) {
        var e = c.src,
          f = b.st.iframe;
        a.each(f.patterns, function () {
          return e.indexOf(this.index) > -1
            ? (this.id &&
                (e =
                  "string" == typeof this.id
                    ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length)
                    : this.id.call(this, e)),
              (e = this.src.replace("%id%", e)),
              !1)
            : void 0;
        });
        var g = {};
        return (
          f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d
        );
      },
    },
  });
  var S = function (a) {
      var c = b.items.length;
      return a > c - 1 ? a - c : 0 > a ? c + a : a;
    },
    T = function (a, b, c) {
      return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c);
    };
  a.magnificPopup.registerModule("gallery", {
    options: {
      enabled: !1,
      arrowMarkup:
        '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      preload: [0, 2],
      navigateByImgClick: !0,
      arrows: !0,
      tPrev: "Previous (Left arrow key)",
      tNext: "Next (Right arrow key)",
      tCounter: "%curr% of %total%",
    },
    proto: {
      initGallery: function () {
        var c = b.st.gallery,
          e = ".mfp-gallery",
          g = Boolean(a.fn.mfpFastClick);
        return (
          (b.direction = !0),
          c && c.enabled
            ? ((f += " mfp-gallery"),
              w(m + e, function () {
                c.navigateByImgClick &&
                  b.wrap.on("click" + e, ".mfp-img", function () {
                    return b.items.length > 1 ? (b.next(), !1) : void 0;
                  }),
                  d.on("keydown" + e, function (a) {
                    37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next();
                  });
              }),
              w("UpdateStatus" + e, function (a, c) {
                c.text && (c.text = T(c.text, b.currItem.index, b.items.length));
              }),
              w(l + e, function (a, d, e, f) {
                var g = b.items.length;
                e.counter = g > 1 ? T(c.tCounter, f.index, g) : "";
              }),
              w("BuildControls" + e, function () {
                if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                  var d = c.arrowMarkup,
                    e = (b.arrowLeft = a(
                      d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left"),
                    ).addClass(s)),
                    f = (b.arrowRight = a(
                      d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right"),
                    ).addClass(s)),
                    h = g ? "mfpFastClick" : "click";
                  e[h](function () {
                    b.prev();
                  }),
                    f[h](function () {
                      b.next();
                    }),
                    b.isIE7 &&
                      (x("b", e[0], !1, !0),
                      x("a", e[0], !1, !0),
                      x("b", f[0], !1, !0),
                      x("a", f[0], !1, !0)),
                    b.container.append(e.add(f));
                }
              }),
              w(n + e, function () {
                b._preloadTimeout && clearTimeout(b._preloadTimeout),
                  (b._preloadTimeout = setTimeout(function () {
                    b.preloadNearbyImages(), (b._preloadTimeout = null);
                  }, 16));
              }),
              void w(h + e, function () {
                d.off(e),
                  b.wrap.off("click" + e),
                  b.arrowLeft && g && b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(),
                  (b.arrowRight = b.arrowLeft = null);
              }))
            : !1
        );
      },
      next: function () {
        (b.direction = !0), (b.index = S(b.index + 1)), b.updateItemHTML();
      },
      prev: function () {
        (b.direction = !1), (b.index = S(b.index - 1)), b.updateItemHTML();
      },
      goTo: function (a) {
        (b.direction = a >= b.index), (b.index = a), b.updateItemHTML();
      },
      preloadNearbyImages: function () {
        var a,
          c = b.st.gallery.preload,
          d = Math.min(c[0], b.items.length),
          e = Math.min(c[1], b.items.length);
        for (a = 1; a <= (b.direction ? e : d); a++) b._preloadItem(b.index + a);
        for (a = 1; a <= (b.direction ? d : e); a++) b._preloadItem(b.index - a);
      },
      _preloadItem: function (c) {
        if (((c = S(c)), !b.items[c].preloaded)) {
          var d = b.items[c];
          d.parsed || (d = b.parseEl(c)),
            y("LazyLoad", d),
            "image" === d.type &&
              (d.img = a('<img class="mfp-img" />')
                .on("load.mfploader", function () {
                  d.hasSize = !0;
                })
                .on("error.mfploader", function () {
                  (d.hasSize = !0), (d.loadError = !0), y("LazyLoadError", d);
                })
                .attr("src", d.src)),
            (d.preloaded = !0);
        }
      },
    },
  });
  var U = "retina";
  a.magnificPopup.registerModule(U, {
    options: {
      replaceSrc: function (a) {
        return a.src.replace(/\.\w+$/, function (a) {
          return "@2x" + a;
        });
      },
      ratio: 1,
    },
    proto: {
      initRetina: function () {
        if (window.devicePixelRatio > 1) {
          var a = b.st.retina,
            c = a.ratio;
          (c = isNaN(c) ? c() : c),
            c > 1 &&
              (w("ImageHasSize." + U, function (a, b) {
                b.img.css({ "max-width": b.img[0].naturalWidth / c, width: "100%" });
              }),
              w("ElementParse." + U, function (b, d) {
                d.src = a.replaceSrc(d, c);
              }));
        }
      },
    },
  }),
    (function () {
      var b = 1e3,
        c = "ontouchstart" in window,
        d = function () {
          v.off("touchmove" + f + " touchend" + f);
        },
        e = "mfpFastClick",
        f = "." + e;
      (a.fn.mfpFastClick = function (e) {
        return a(this).each(function () {
          var g,
            h = a(this);
          if (c) {
            var i, j, k, l, m, n;
            h.on("touchstart" + f, function (a) {
              (l = !1),
                (n = 1),
                (m = a.originalEvent ? a.originalEvent.touches[0] : a.touches[0]),
                (j = m.clientX),
                (k = m.clientY),
                v
                  .on("touchmove" + f, function (a) {
                    (m = a.originalEvent ? a.originalEvent.touches : a.touches),
                      (n = m.length),
                      (m = m[0]),
                      (Math.abs(m.clientX - j) > 10 || Math.abs(m.clientY - k) > 10) &&
                        ((l = !0), d());
                  })
                  .on("touchend" + f, function (a) {
                    d(),
                      l ||
                        n > 1 ||
                        ((g = !0),
                        a.preventDefault(),
                        clearTimeout(i),
                        (i = setTimeout(function () {
                          g = !1;
                        }, b)),
                        e());
                  });
            });
          }
          h.on("click" + f, function () {
            g || e();
          });
        });
      }),
        (a.fn.destroyMfpFastClick = function () {
          a(this).off("touchstart" + f + " click" + f),
            c && v.off("touchmove" + f + " touchend" + f);
        });
    })(),
    A();
});
/*
 * ScrollToFixed
 * https://github.com/bigspotteddog/ScrollToFixed
 *
 * Copyright (c) 2011 Joseph Cava-Lynch
 * MIT license
 */
(function (a) {
  a.isScrollToFixed = function (b) {
    return !!a(b).data("ScrollToFixed");
  };
  a.ScrollToFixed = function (d, i) {
    var l = this;
    l.$el = a(d);
    l.el = d;
    l.$el.data("ScrollToFixed", l);
    var c = false;
    var G = l.$el;
    var H;
    var E;
    var e;
    var y;
    var D = 0;
    var q = 0;
    var j = -1;
    var f = -1;
    var t = null;
    var z;
    var g;
    function u() {
      G.trigger("preUnfixed.ScrollToFixed");
      k();
      G.trigger("unfixed.ScrollToFixed");
      f = -1;
      D = G.offset().top;
      q = G.offset().left;
      if (l.options.offsets) {
        q += G.offset().left - G.position().left;
      }
      if (j == -1) {
        j = q;
      }
      H = G.css("position");
      c = true;
      if (l.options.bottom != -1) {
        G.trigger("preFixed.ScrollToFixed");
        w();
        G.trigger("fixed.ScrollToFixed");
      }
    }
    function n() {
      var I = l.options.limit;
      if (!I) {
        return 0;
      }
      if (typeof I === "function") {
        return I.apply(G);
      }
      return I;
    }
    function p() {
      return H === "fixed";
    }
    function x() {
      return H === "absolute";
    }
    function h() {
      return !(p() || x());
    }
    function w() {
      if (!p()) {
        t.css({
          display: G.css("display"),
          width: G.outerWidth(true),
          height: G.outerHeight(true),
          float: G.css("float"),
        });
        cssOptions = {
          "z-index": l.options.zIndex,
          position: "fixed",
          top: l.options.bottom == -1 ? s() : "",
          bottom: l.options.bottom == -1 ? "" : l.options.bottom,
          "margin-left": "0px",
        };
        if (!l.options.dontSetWidth) {
          cssOptions.width = G.width();
        }
        G.css(cssOptions);
        G.addClass(l.options.baseClassName);
        if (l.options.className) {
          G.addClass(l.options.className);
        }
        H = "fixed";
      }
    }
    function b() {
      var J = n();
      var I = q;
      if (l.options.removeOffsets) {
        I = "";
        J = J - D;
      }
      cssOptions = { position: "absolute", top: J, left: I, "margin-left": "0px", bottom: "" };
      if (!l.options.dontSetWidth) {
        cssOptions.width = G.width();
      }
      G.css(cssOptions);
      H = "absolute";
    }
    function k() {
      if (!h()) {
        f = -1;
        t.css("display", "none");
        G.css({ "z-index": y, width: "", position: E, left: "", top: e, "margin-left": "" });
        G.removeClass("scroll-to-fixed-fixed");
        if (l.options.className) {
          G.removeClass(l.options.className);
        }
        H = null;
      }
    }
    function v(I) {
      if (I != f) {
        G.css("left", q - I);
        f = I;
      }
    }
    function s() {
      var I = l.options.marginTop;
      if (!I) {
        return 0;
      }
      if (typeof I === "function") {
        return I.apply(G);
      }
      return I;
    }
    function A() {
      if (!a.isScrollToFixed(G)) {
        return;
      }
      var K = c;
      if (!c) {
        u();
      } else {
        if (h()) {
          D = G.offset().top;
          q = G.offset().left;
        }
      }
      var I = a(window).scrollLeft();
      var L = a(window).scrollTop();
      var J = n();
      if (l.options.minWidth && a(window).width() < l.options.minWidth) {
        if (!h() || !K) {
          o();
          G.trigger("preUnfixed.ScrollToFixed");
          k();
          G.trigger("unfixed.ScrollToFixed");
        }
      } else {
        if (l.options.maxWidth && a(window).width() > l.options.maxWidth) {
          if (!h() || !K) {
            o();
            G.trigger("preUnfixed.ScrollToFixed");
            k();
            G.trigger("unfixed.ScrollToFixed");
          }
        } else {
          if (l.options.bottom == -1) {
            if (J > 0 && L >= J - s()) {
              if (!x() || !K) {
                o();
                G.trigger("preAbsolute.ScrollToFixed");
                b();
                G.trigger("unfixed.ScrollToFixed");
              }
            } else {
              if (L >= D - s()) {
                if (!p() || !K) {
                  o();
                  G.trigger("preFixed.ScrollToFixed");
                  w();
                  f = -1;
                  G.trigger("fixed.ScrollToFixed");
                }
                v(I);
              } else {
                if (!h() || !K) {
                  o();
                  G.trigger("preUnfixed.ScrollToFixed");
                  k();
                  G.trigger("unfixed.ScrollToFixed");
                }
              }
            }
          } else {
            if (J > 0) {
              if (L + a(window).height() - G.outerHeight(true) >= J - (s() || -m())) {
                if (p()) {
                  o();
                  G.trigger("preUnfixed.ScrollToFixed");
                  if (E === "absolute") {
                    b();
                  } else {
                    k();
                  }
                  G.trigger("unfixed.ScrollToFixed");
                }
              } else {
                if (!p()) {
                  o();
                  G.trigger("preFixed.ScrollToFixed");
                  w();
                }
                v(I);
                G.trigger("fixed.ScrollToFixed");
              }
            } else {
              v(I);
            }
          }
        }
      }
    }
    function m() {
      if (!l.options.bottom) {
        return 0;
      }
      return l.options.bottom;
    }
    function o() {
      var I = G.css("position");
      if (I == "absolute") {
        G.trigger("postAbsolute.ScrollToFixed");
      } else {
        if (I == "fixed") {
          G.trigger("postFixed.ScrollToFixed");
        } else {
          G.trigger("postUnfixed.ScrollToFixed");
        }
      }
    }
    var C = function (I) {
      if (G.is(":visible")) {
        c = false;
        A();
      }
    };
    var F = function (I) {
      !!window.requestAnimationFrame ? requestAnimationFrame(A) : A();
    };
    var B = function () {
      var J = document.body;
      if (document.createElement && J && J.appendChild && J.removeChild) {
        var L = document.createElement("div");
        if (!L.getBoundingClientRect) {
          return null;
        }
        L.innerHTML = "x";
        L.style.cssText = "position:fixed;top:100px;";
        J.appendChild(L);
        var M = J.style.height,
          N = J.scrollTop;
        J.style.height = "3000px";
        J.scrollTop = 500;
        var I = L.getBoundingClientRect().top;
        J.style.height = M;
        var K = I === 100;
        J.removeChild(L);
        J.scrollTop = N;
        return K;
      }
      return null;
    };
    var r = function (I) {
      I = I || window.event;
      if (I.preventDefault) {
        I.preventDefault();
      }
      I.returnValue = false;
    };
    l.init = function () {
      l.options = a.extend({}, a.ScrollToFixed.defaultOptions, i);
      y = G.css("z-index");
      l.$el.css("z-index", l.options.zIndex);
      t = a("<div />");
      H = G.css("position");
      E = G.css("position");
      e = G.css("top");
      if (h()) {
        l.$el.after(t);
      }
      a(window).bind("resize.ScrollToFixed", C);
      a(window).bind("scroll.ScrollToFixed", F);
      if ("ontouchmove" in window) {
        a(window).bind("touchmove.ScrollToFixed", A);
      }
      if (l.options.preFixed) {
        G.bind("preFixed.ScrollToFixed", l.options.preFixed);
      }
      if (l.options.postFixed) {
        G.bind("postFixed.ScrollToFixed", l.options.postFixed);
      }
      if (l.options.preUnfixed) {
        G.bind("preUnfixed.ScrollToFixed", l.options.preUnfixed);
      }
      if (l.options.postUnfixed) {
        G.bind("postUnfixed.ScrollToFixed", l.options.postUnfixed);
      }
      if (l.options.preAbsolute) {
        G.bind("preAbsolute.ScrollToFixed", l.options.preAbsolute);
      }
      if (l.options.postAbsolute) {
        G.bind("postAbsolute.ScrollToFixed", l.options.postAbsolute);
      }
      if (l.options.fixed) {
        G.bind("fixed.ScrollToFixed", l.options.fixed);
      }
      if (l.options.unfixed) {
        G.bind("unfixed.ScrollToFixed", l.options.unfixed);
      }
      if (l.options.spacerClass) {
        t.addClass(l.options.spacerClass);
      }
      G.bind("resize.ScrollToFixed", function () {
        t.height(G.height());
      });
      G.bind("scroll.ScrollToFixed", function () {
        G.trigger("preUnfixed.ScrollToFixed");
        k();
        G.trigger("unfixed.ScrollToFixed");
        A();
      });
      G.bind("detach.ScrollToFixed", function (I) {
        r(I);
        G.trigger("preUnfixed.ScrollToFixed");
        k();
        G.trigger("unfixed.ScrollToFixed");
        a(window).unbind("resize.ScrollToFixed", C);
        a(window).unbind("scroll.ScrollToFixed", F);
        G.unbind(".ScrollToFixed");
        t.remove();
        l.$el.removeData("ScrollToFixed");
      });
      C();
    };
    l.init();
  };
  a.ScrollToFixed.defaultOptions = {
    marginTop: 0,
    limit: 0,
    bottom: -1,
    zIndex: 1000,
    baseClassName: "scroll-to-fixed-fixed",
  };
  a.fn.scrollToFixed = function (b) {
    return this.each(function () {
      new a.ScrollToFixed(this, b);
    });
  };
})(jQuery);

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
!(function (a) {
  a.fn.prepareTransition = function () {
    return this.each(function () {
      var b = a(this);
      b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
        b.removeClass("is-transitioning");
      });
      var c = [
        "transition-duration",
        "-moz-transition-duration",
        "-webkit-transition-duration",
        "-o-transition-duration",
      ];
      var d = 0;
      a.each(c, function (a, c) {
        d = parseFloat(b.css(c)) || d;
      });
      if (d != 0) {
        b.addClass("is-transitioning");
        b[0].offsetWidth;
      }
    });
  };
})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e, r, a) {
  var n = new RegExp("(" + r + "=).*?(&|$)"),
    c = e;
  return (c =
    e.search(n) >= 0
      ? e.replace(n, "$1" + a + "$2")
      : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a);
}

/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
(function () {
  function n(n, t) {
    for (var r = -1, e = t.length, u = n.length; ++r < e; ) n[u + r] = t[r];
    return n;
  }
  function t(n, t, r) {
    for (var e = -1, u = n.length; ++e < u; ) {
      var o = n[e],
        i = t(o);
      if (null != i && (c === an ? i === i : r(i, c)))
        var c = i,
          f = o;
    }
    return f;
  }
  function r(n, t, r) {
    var e;
    return (
      r(n, function (n, r, u) {
        return t(n, r, u) ? ((e = n), false) : void 0;
      }),
      e
    );
  }
  function e(n, t, r, e, u) {
    return (
      u(n, function (n, u, o) {
        r = e ? ((e = false), n) : t(r, n, u, o);
      }),
      r
    );
  }
  function u(n, t) {
    return O(t, function (t) {
      return n[t];
    });
  }
  function o(n) {
    return n && n.Object === Object ? n : null;
  }
  function i(n) {
    return vn[n];
  }
  function c(n) {
    var t = false;
    if (null != n && typeof n.toString != "function")
      try {
        t = !!(n + "");
      } catch (r) {}
    return t;
  }
  function f(n, t) {
    return (
      (n = typeof n == "number" || hn.test(n) ? +n : -1),
      n > -1 && 0 == n % 1 && (null == t ? 9007199254740991 : t) > n
    );
  }
  function a(n) {
    if (Y(n) && !Pn(n)) {
      if (n instanceof l) return n;
      if (En.call(n, "__wrapped__")) {
        var t = new l(n.__wrapped__, n.__chain__);
        return (t.__actions__ = N(n.__actions__)), t;
      }
    }
    return new l(n);
  }
  function l(n, t) {
    (this.__wrapped__ = n), (this.__actions__ = []), (this.__chain__ = !!t);
  }
  function p(n, t, r, e) {
    var u;
    return (
      (u = n === an) || ((u = xn[r]), (u = (n === u || (n !== n && u !== u)) && !En.call(e, r))),
      u ? t : n
    );
  }
  function s(n) {
    return X(n) ? Fn(n) : {};
  }
  function h(n, t, r) {
    if (typeof n != "function") throw new TypeError("Expected a function");
    return setTimeout(function () {
      n.apply(an, r);
    }, t);
  }
  function v(n, t) {
    var r = true;
    return (
      $n(n, function (n, e, u) {
        return (r = !!t(n, e, u));
      }),
      r
    );
  }
  function y(n, t) {
    var r = [];
    return (
      $n(n, function (n, e, u) {
        t(n, e, u) && r.push(n);
      }),
      r
    );
  }
  function _(t, r, e, u) {
    u || (u = []);
    for (var o = -1, i = t.length; ++o < i; ) {
      var c = t[o];
      r > 0 && Y(c) && L(c) && (e || Pn(c) || K(c))
        ? r > 1
          ? _(c, r - 1, e, u)
          : n(u, c)
        : e || (u[u.length] = c);
    }
    return u;
  }
  function g(n, t) {
    return n && qn(n, t, en);
  }
  function b(n, t) {
    return y(t, function (t) {
      return Q(n[t]);
    });
  }
  function j(n, t, r, e, u) {
    return n === t
      ? true
      : null == n || null == t || (!X(n) && !Y(t))
        ? n !== n && t !== t
        : m(n, t, j, r, e, u);
  }
  function m(n, t, r, e, u, o) {
    var i = Pn(n),
      f = Pn(t),
      a = "[object Array]",
      l = "[object Array]";
    i || ((a = kn.call(n)), "[object Arguments]" == a && (a = "[object Object]")),
      f || ((l = kn.call(t)), "[object Arguments]" == l && (l = "[object Object]"));
    var p = "[object Object]" == a && !c(n),
      f = "[object Object]" == l && !c(t);
    return !(l = a == l) || i || p
      ? 2 & u ||
        ((a = p && En.call(n, "__wrapped__")), (f = f && En.call(t, "__wrapped__")), !a && !f)
        ? l
          ? (o || (o = []),
            (a = J(o, function (t) {
              return t[0] === n;
            })) && a[1]
              ? a[1] == t
              : (o.push([n, t]), (t = (i ? I : q)(n, t, r, e, u, o)), o.pop(), t))
          : false
        : r(a ? n.value() : n, f ? t.value() : t, e, u, o)
      : $(n, t, a);
  }
  function d(n) {
    var t = typeof n;
    return "function" == t ? n : null == n ? cn : ("object" == t ? x : A)(n);
  }
  function w(n) {
    n = null == n ? n : Object(n);
    var t,
      r = [];
    for (t in n) r.push(t);
    return r;
  }
  function O(n, t) {
    var r = -1,
      e = L(n) ? Array(n.length) : [];
    return (
      $n(n, function (n, u, o) {
        e[++r] = t(n, u, o);
      }),
      e
    );
  }
  function x(n) {
    var t = en(n);
    return function (r) {
      var e = t.length;
      if (null == r) return !e;
      for (r = Object(r); e--; ) {
        var u = t[e];
        if (!(u in r && j(n[u], r[u], an, 3))) return false;
      }
      return true;
    };
  }
  function E(n, t) {
    return (
      (n = Object(n)),
      P(
        t,
        function (t, r) {
          return r in n && (t[r] = n[r]), t;
        },
        {},
      )
    );
  }
  function A(n) {
    return function (t) {
      return null == t ? an : t[n];
    };
  }
  function k(n, t, r) {
    var e = -1,
      u = n.length;
    for (
      0 > t && (t = -t > u ? 0 : u + t),
        r = r > u ? u : r,
        0 > r && (r += u),
        u = t > r ? 0 : (r - t) >>> 0,
        t >>>= 0,
        r = Array(u);
      ++e < u;

    )
      r[e] = n[e + t];
    return r;
  }
  function N(n) {
    return k(n, 0, n.length);
  }
  function S(n, t) {
    var r;
    return (
      $n(n, function (n, e, u) {
        return (r = t(n, e, u)), !r;
      }),
      !!r
    );
  }
  function T(t, r) {
    return P(
      r,
      function (t, r) {
        return r.func.apply(r.thisArg, n([t], r.args));
      },
      t,
    );
  }
  function F(n, t, r, e) {
    r || (r = {});
    for (var u = -1, o = t.length; ++u < o; ) {
      var i = t[u],
        c = e ? e(r[i], n[i], i, r, n) : n[i],
        f = r,
        a = f[i];
      (En.call(f, i) && (a === c || (a !== a && c !== c)) && (c !== an || i in f)) || (f[i] = c);
    }
    return r;
  }
  function R(n) {
    return V(function (t, r) {
      var e = -1,
        u = r.length,
        o = u > 1 ? r[u - 1] : an,
        o = typeof o == "function" ? (u--, o) : an;
      for (t = Object(t); ++e < u; ) {
        var i = r[e];
        i && n(t, i, e, o);
      }
      return t;
    });
  }
  function B(n) {
    return function () {
      var t = arguments,
        r = s(n.prototype),
        t = n.apply(r, t);
      return X(t) ? t : r;
    };
  }
  function D(n, t, r) {
    function e() {
      for (
        var o = -1,
          i = arguments.length,
          c = -1,
          f = r.length,
          a = Array(f + i),
          l = this && this !== wn && this instanceof e ? u : n;
        ++c < f;

      )
        a[c] = r[c];
      for (; i--; ) a[c++] = arguments[++o];
      return l.apply(t, a);
    }
    if (typeof n != "function") throw new TypeError("Expected a function");
    var u = B(n);
    return e;
  }
  function I(n, t, r, e, u, o) {
    var i = -1,
      c = 1 & u,
      f = n.length,
      a = t.length;
    if (f != a && !(2 & u && a > f)) return false;
    for (a = true; ++i < f; ) {
      var l = n[i],
        p = t[i];
      if (void 0 !== an) {
        a = false;
        break;
      }
      if (c) {
        if (
          !S(t, function (n) {
            return l === n || r(l, n, e, u, o);
          })
        ) {
          a = false;
          break;
        }
      } else if (l !== p && !r(l, p, e, u, o)) {
        a = false;
        break;
      }
    }
    return a;
  }
  function $(n, t, r) {
    switch (r) {
      case "[object Boolean]":
      case "[object Date]":
        return +n == +t;
      case "[object Error]":
        return n.name == t.name && n.message == t.message;
      case "[object Number]":
        return n != +n ? t != +t : n == +t;
      case "[object RegExp]":
      case "[object String]":
        return n == t + "";
    }
    return false;
  }
  function q(n, t, r, e, u, o) {
    var i = 2 & u,
      c = en(n),
      f = c.length,
      a = en(t).length;
    if (f != a && !i) return false;
    for (var l = f; l--; ) {
      var p = c[l];
      if (!(i ? p in t : En.call(t, p))) return false;
    }
    for (a = true; ++l < f; ) {
      var p = c[l],
        s = n[p],
        h = t[p];
      if (void 0 !== an || (s !== h && !r(s, h, e, u, o))) {
        a = false;
        break;
      }
      i || (i = "constructor" == p);
    }
    return (
      a &&
        !i &&
        ((r = n.constructor),
        (e = t.constructor),
        r != e &&
          "constructor" in n &&
          "constructor" in t &&
          !(typeof r == "function" && r instanceof r && typeof e == "function" && e instanceof e) &&
          (a = false)),
      a
    );
  }
  function z(n) {
    var t = n ? n.length : an;
    if (W(t) && (Pn(n) || nn(n) || K(n))) {
      n = String;
      for (var r = -1, e = Array(t); ++r < t; ) e[r] = n(r);
      t = e;
    } else t = null;
    return t;
  }
  function C(n) {
    var t = n && n.constructor,
      t = (Q(t) && t.prototype) || xn;
    return n === t;
  }
  function G(n) {
    return n ? n[0] : an;
  }
  function J(n, t) {
    return r(n, d(t), $n);
  }
  function M(n, t) {
    return $n(n, typeof t == "function" ? t : cn);
  }
  function P(n, t, r) {
    return e(n, d(t), r, 3 > arguments.length, $n);
  }
  function U(n, t) {
    var r;
    if (typeof t != "function") throw new TypeError("Expected a function");
    return (
      (n = Un(n)),
      function () {
        return 0 < --n && (r = t.apply(this, arguments)), 1 >= n && (t = an), r;
      }
    );
  }
  function V(n) {
    var t;
    if (typeof n != "function") throw new TypeError("Expected a function");
    return (
      (t = In(t === an ? n.length - 1 : Un(t), 0)),
      function () {
        for (var r = arguments, e = -1, u = In(r.length - t, 0), o = Array(u); ++e < u; )
          o[e] = r[t + e];
        for (u = Array(t + 1), e = -1; ++e < t; ) u[e] = r[e];
        return (u[t] = o), n.apply(this, u);
      }
    );
  }
  function H(n, t) {
    return n > t;
  }
  function K(n) {
    return (
      Y(n) &&
      L(n) &&
      En.call(n, "callee") &&
      (!Rn.call(n, "callee") || "[object Arguments]" == kn.call(n))
    );
  }
  function L(n) {
    return null != n && !(typeof n == "function" && Q(n)) && W(zn(n));
  }
  function Q(n) {
    return (
      (n = X(n) ? kn.call(n) : ""), "[object Function]" == n || "[object GeneratorFunction]" == n
    );
  }
  function W(n) {
    return typeof n == "number" && n > -1 && 0 == n % 1 && 9007199254740991 >= n;
  }
  function X(n) {
    var t = typeof n;
    return !!n && ("object" == t || "function" == t);
  }
  function Y(n) {
    return !!n && typeof n == "object";
  }
  function Z(n) {
    return typeof n == "number" || (Y(n) && "[object Number]" == kn.call(n));
  }
  function nn(n) {
    return typeof n == "string" || (!Pn(n) && Y(n) && "[object String]" == kn.call(n));
  }
  function tn(n, t) {
    return t > n;
  }
  function rn(n) {
    return typeof n == "string" ? n : null == n ? "" : n + "";
  }
  function en(n) {
    var t = C(n);
    if (!t && !L(n)) return Dn(Object(n));
    var r,
      e = z(n),
      u = !!e,
      e = e || [],
      o = e.length;
    for (r in n)
      !En.call(n, r) || (u && ("length" == r || f(r, o))) || (t && "constructor" == r) || e.push(r);
    return e;
  }
  function un(n) {
    for (
      var t = -1, r = C(n), e = w(n), u = e.length, o = z(n), i = !!o, o = o || [], c = o.length;
      ++t < u;

    ) {
      var a = e[t];
      (i && ("length" == a || f(a, c))) ||
        ("constructor" == a && (r || !En.call(n, a))) ||
        o.push(a);
    }
    return o;
  }
  function on(n) {
    return n ? u(n, en(n)) : [];
  }
  function cn(n) {
    return n;
  }
  function fn(t, r, e) {
    var u = en(r),
      o = b(r, u);
    null != e ||
      (X(r) && (o.length || !u.length)) ||
      ((e = r), (r = t), (t = this), (o = b(r, en(r))));
    var i = X(e) && "chain" in e ? e.chain : true,
      c = Q(t);
    return (
      $n(o, function (e) {
        var u = r[e];
        (t[e] = u),
          c &&
            (t.prototype[e] = function () {
              var r = this.__chain__;
              if (i || r) {
                var e = t(this.__wrapped__);
                return (
                  (e.__actions__ = N(this.__actions__)).push({
                    func: u,
                    args: arguments,
                    thisArg: t,
                  }),
                  (e.__chain__ = r),
                  e
                );
              }
              return u.apply(t, n([this.value()], arguments));
            });
      }),
      t
    );
  }
  var an,
    ln = 1 / 0,
    pn = /[&<>"'`]/g,
    sn = RegExp(pn.source),
    hn = /^(?:0|[1-9]\d*)$/,
    vn = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;" },
    yn = { function: true, object: true },
    _n = yn[typeof exports] && exports && !exports.nodeType ? exports : an,
    gn = yn[typeof module] && module && !module.nodeType ? module : an,
    bn = gn && gn.exports === _n ? _n : an,
    jn = o(yn[typeof self] && self),
    mn = o(yn[typeof window] && window),
    dn = o(yn[typeof this] && this),
    wn =
      o(_n && gn && typeof global == "object" && global) ||
      (mn !== (dn && dn.window) && mn) ||
      jn ||
      dn ||
      Function("return this")(),
    On = Array.prototype,
    xn = Object.prototype,
    En = xn.hasOwnProperty,
    An = 0,
    kn = xn.toString,
    Nn = wn._,
    Sn = wn.Reflect,
    Tn = Sn ? Sn.f : an,
    Fn = Object.create,
    Rn = xn.propertyIsEnumerable,
    Bn = wn.isFinite,
    Dn = Object.keys,
    In = Math.max,
    $n = (function (n, t) {
      return function (r, e) {
        if (null == r) return r;
        if (!L(r)) return n(r, e);
        for (
          var u = r.length, o = t ? u : -1, i = Object(r);
          (t ? o-- : ++o < u) && false !== e(i[o], o, i);

        );
        return r;
      };
    })(g),
    qn = (function (n) {
      return function (t, r, e) {
        var u = -1,
          o = Object(t);
        e = e(t);
        for (var i = e.length; i--; ) {
          var c = e[n ? i : ++u];
          if (false === r(o[c], c, o)) break;
        }
        return t;
      };
    })();
  Tn &&
    !Rn.call({ valueOf: 1 }, "valueOf") &&
    (w = function (n) {
      n = Tn(n);
      for (var t, r = []; !(t = n.next()).done; ) r.push(t.value);
      return r;
    });
  var zn = A("length"),
    Cn = V(function (t, r) {
      return Pn(t) || (t = null == t ? [] : [Object(t)]), _(r, 1), n(N(t), on);
    }),
    Gn = V(function (n, t, r) {
      return D(n, t, r);
    }),
    Jn = V(function (n, t) {
      return h(n, 1, t);
    }),
    Mn = V(function (n, t, r) {
      return h(n, Vn(t) || 0, r);
    }),
    Pn = Array.isArray,
    Un = Number,
    Vn = Number,
    Hn = R(function (n, t) {
      F(t, en(t), n);
    }),
    Kn = R(function (n, t) {
      F(t, un(t), n);
    }),
    Ln = R(function (n, t, r, e) {
      F(t, un(t), n, e);
    }),
    Qn = V(function (n) {
      return n.push(an, p), Ln.apply(an, n);
    }),
    Wn = V(function (n, t) {
      return null == n ? {} : E(n, _(t, 1));
    }),
    Xn = d;
  (l.prototype = s(a.prototype)),
    (l.prototype.constructor = l),
    (a.assignIn = Kn),
    (a.before = U),
    (a.bind = Gn),
    (a.chain = function (n) {
      return (n = a(n)), (n.__chain__ = true), n;
    }),
    (a.compact = function (n) {
      return y(n, Boolean);
    }),
    (a.concat = Cn),
    (a.create = function (n, t) {
      var r = s(n);
      return t ? Hn(r, t) : r;
    }),
    (a.defaults = Qn),
    (a.defer = Jn),
    (a.delay = Mn),
    (a.filter = function (n, t) {
      return y(n, d(t));
    }),
    (a.flatten = function (n) {
      return n && n.length ? _(n, 1) : [];
    }),
    (a.flattenDeep = function (n) {
      return n && n.length ? _(n, ln) : [];
    }),
    (a.iteratee = Xn),
    (a.keys = en),
    (a.map = function (n, t) {
      return O(n, d(t));
    }),
    (a.matches = function (n) {
      return x(Hn({}, n));
    }),
    (a.mixin = fn),
    (a.negate = function (n) {
      if (typeof n != "function") throw new TypeError("Expected a function");
      return function () {
        return !n.apply(this, arguments);
      };
    }),
    (a.once = function (n) {
      return U(2, n);
    }),
    (a.pick = Wn),
    (a.slice = function (n, t, r) {
      var e = n ? n.length : 0;
      return (r = r === an ? e : +r), e ? k(n, null == t ? 0 : +t, r) : [];
    }),
    (a.sortBy = function (n, t) {
      var r = 0;
      return (
        (t = d(t)),
        O(
          O(n, function (n, e, u) {
            return { c: n, b: r++, a: t(n, e, u) };
          }).sort(function (n, t) {
            var r;
            n: {
              r = n.a;
              var e = t.a;
              if (r !== e) {
                var u = null === r,
                  o = r === an,
                  i = r === r,
                  c = null === e,
                  f = e === an,
                  a = e === e;
                if ((r > e && !c) || !i || (u && !f && a) || (o && a)) {
                  r = 1;
                  break n;
                }
                if ((e > r && !u) || !a || (c && !o && i) || (f && i)) {
                  r = -1;
                  break n;
                }
              }
              r = 0;
            }
            return r || n.b - t.b;
          }),
          A("c"),
        )
      );
    }),
    (a.tap = function (n, t) {
      return t(n), n;
    }),
    (a.thru = function (n, t) {
      return t(n);
    }),
    (a.toArray = function (n) {
      return L(n) ? (n.length ? N(n) : []) : on(n);
    }),
    (a.values = on),
    (a.extend = Kn),
    fn(a, a),
    (a.clone = function (n) {
      return X(n) ? (Pn(n) ? N(n) : F(n, en(n))) : n;
    }),
    (a.escape = function (n) {
      return (n = rn(n)) && sn.test(n) ? n.replace(pn, i) : n;
    }),
    (a.every = function (n, t, r) {
      return (t = r ? an : t), v(n, d(t));
    }),
    (a.find = J),
    (a.forEach = M),
    (a.has = function (n, t) {
      return null != n && En.call(n, t);
    }),
    (a.head = G),
    (a.identity = cn),
    (a.indexOf = function (n, t, r) {
      var e = n ? n.length : 0;
      (r = typeof r == "number" ? (0 > r ? In(e + r, 0) : r) : 0), (r = (r || 0) - 1);
      for (var u = t === t; ++r < e; ) {
        var o = n[r];
        if (u ? o === t : o !== o) return r;
      }
      return -1;
    }),
    (a.isArguments = K),
    (a.isArray = Pn),
    (a.isBoolean = function (n) {
      return true === n || false === n || (Y(n) && "[object Boolean]" == kn.call(n));
    }),
    (a.isDate = function (n) {
      return Y(n) && "[object Date]" == kn.call(n);
    }),
    (a.isEmpty = function (n) {
      if (L(n) && (Pn(n) || nn(n) || Q(n.splice) || K(n))) return !n.length;
      for (var t in n) if (En.call(n, t)) return false;
      return true;
    }),
    (a.isEqual = function (n, t) {
      return j(n, t);
    }),
    (a.isFinite = function (n) {
      return typeof n == "number" && Bn(n);
    }),
    (a.isFunction = Q),
    (a.isNaN = function (n) {
      return Z(n) && n != +n;
    }),
    (a.isNull = function (n) {
      return null === n;
    }),
    (a.isNumber = Z),
    (a.isObject = X),
    (a.isRegExp = function (n) {
      return X(n) && "[object RegExp]" == kn.call(n);
    }),
    (a.isString = nn),
    (a.isUndefined = function (n) {
      return n === an;
    }),
    (a.last = function (n) {
      var t = n ? n.length : 0;
      return t ? n[t - 1] : an;
    }),
    (a.max = function (n) {
      return n && n.length ? t(n, cn, H) : an;
    }),
    (a.min = function (n) {
      return n && n.length ? t(n, cn, tn) : an;
    }),
    (a.noConflict = function () {
      return wn._ === this && (wn._ = Nn), this;
    }),
    (a.noop = function () {}),
    (a.reduce = P),
    (a.result = function (n, t, r) {
      return (t = null == n ? an : n[t]), t === an && (t = r), Q(t) ? t.call(n) : t;
    }),
    (a.size = function (n) {
      return null == n ? 0 : ((n = L(n) ? n : en(n)), n.length);
    }),
    (a.some = function (n, t, r) {
      return (t = r ? an : t), S(n, d(t));
    }),
    (a.uniqueId = function (n) {
      var t = ++An;
      return rn(n) + t;
    }),
    (a.each = M),
    (a.first = G),
    fn(
      a,
      (function () {
        var n = {};
        return (
          g(a, function (t, r) {
            En.call(a.prototype, r) || (n[r] = t);
          }),
          n
        );
      })(),
      { chain: false },
    ),
    (a.VERSION = "4.5.1"),
    $n("pop join replace reverse split push shift sort splice unshift".split(" "), function (n) {
      var t = (/^(?:replace|split)$/.test(n) ? String.prototype : On)[n],
        r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru",
        e = /^(?:pop|join|replace|shift)$/.test(n);
      a.prototype[n] = function () {
        var n = arguments;
        return e && !this.__chain__
          ? t.apply(this.value(), n)
          : this[r](function (r) {
              return t.apply(r, n);
            });
      };
    }),
    (a.prototype.toJSON =
      a.prototype.valueOf =
      a.prototype.value =
        function () {
          return T(this.__wrapped__, this.__actions__);
        }),
    ((mn || jn || {})._ = a),
    typeof define == "function" && typeof define.amd == "object" && define.amd
      ? define(function () {
          return a;
        })
      : _n && gn
        ? (bn && ((gn.exports = a)._ = a), (_n._ = a))
        : (wn._ = a);
}).call(this);
/*
 * Debounce function
 * based on unminified version from http://davidwalsh.name/javascript-debounce-function
 */
theme.debounce = function (n, t, u) {
  var e;
  return function () {
    var a = this,
      r = arguments,
      i = function () {
        (e = null), u || n.apply(a, r);
      },
      o = u && !e;
    clearTimeout(e), (e = setTimeout(i, t)), o && n.apply(a, r);
  };
};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this),
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = "${{amount}}";

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[.@]/,
    );

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or media changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),

        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        },
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateMedia(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant media changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantMediaChange
     */
    _updateMedia: function (variant) {
      var variantMedia = variant.featured_media || {};
      var currentVariantMedia = this.currentVariant.featured_media || {};

      var isMatchingPreviewImage = false;

      if (variantMedia.preview_image && currentVariantMedia.preview_image) {
        isMatchingPreviewImage =
          variantMedia.preview_image.src === currentVariantMedia.preview_image.src;
      }

      if (!variant.featured_media || isMatchingPreviewImage) return;

      this.$container.trigger({
        type: "variantMediaChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant SKU changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState(
        {
          path: newurl,
        },
        "",
        newurl,
      );
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },
  });

  return Variants;
})();

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  },
};

/* ================ GLOBAL ================ */
theme.LibraryLoader = (function () {
  var types = {
    link: "link",
    script: "script",
  };

  var status = {
    requested: "requested",
    loaded: "loaded",
  };

  var cloudCdn = "https://cdn.shopify.com/shopifycloud/";

  var libraries = {
    youtubeSdk: {
      tagId: "youtube-sdk",
      src: "https://www.youtube.com/iframe_api",
      type: types.script,
    },
    plyrShopifyStyles: {
      tagId: "plyr-shopify-styles",
      src: cloudCdn + "shopify-plyr/v1.0/shopify-plyr.css",
      type: types.link,
    },
    modelViewerUiStyles: {
      tagId: "shopify-model-viewer-ui-styles",
      src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
      type: types.link,
    },
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function () {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement("script");
    tag.src = library.src;
    tag.addEventListener("load", function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement("link");
    tag.href = library.src;
    tag.rel = "stylesheet";
    tag.type = "text/css";
    tag.addEventListener("load", function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load,
  };
})();

/* ================ MODULES ================ */
/*!
handlebars v1.3.0

Copyright (C) 2011 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
var Handlebars = (function () {
  var e = (function () {
    "use strict";
    function t(e) {
      this.string = e;
    }
    var e;
    t.prototype.toString = function () {
      return "" + this.string;
    };
    e = t;
    return e;
  })();
  var t = (function (e) {
    "use strict";
    function o(e) {
      return r[e] || "&";
    }
    function u(e, t) {
      for (var n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
          e[n] = t[n];
        }
      }
    }
    function c(e) {
      if (e instanceof n) {
        return e.toString();
      } else if (!e && e !== 0) {
        return "";
      }
      e = "" + e;
      if (!s.test(e)) {
        return e;
      }
      return e.replace(i, o);
    }
    function h(e) {
      if (!e && e !== 0) {
        return true;
      } else if (l(e) && e.length === 0) {
        return true;
      } else {
        return false;
      }
    }
    var t = {};
    var n = e;
    var r = { "&": "&", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;" };
    var i = /[&<>"'`]/g;
    var s = /[&<>"'`]/;
    t.extend = u;
    var a = Object.prototype.toString;
    t.toString = a;
    var f = function (e) {
      return typeof e === "function";
    };
    if (f(/x/)) {
      f = function (e) {
        return typeof e === "function" && a.call(e) === "[object Function]";
      };
    }
    var f;
    t.isFunction = f;
    var l =
      Array.isArray ||
      function (e) {
        return e && typeof e === "object" ? a.call(e) === "[object Array]" : false;
      };
    t.isArray = l;
    t.escapeExpression = c;
    t.isEmpty = h;
    return t;
  })(e);
  var n = (function () {
    "use strict";
    function n(e, n) {
      var r;
      if (n && n.firstLine) {
        r = n.firstLine;
        e += " - " + r + ":" + n.firstColumn;
      }
      var i = Error.prototype.constructor.call(this, e);
      for (var s = 0; s < t.length; s++) {
        this[t[s]] = i[t[s]];
      }
      if (r) {
        this.lineNumber = r;
        this.column = n.firstColumn;
      }
    }
    var e;
    var t = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
    n.prototype = new Error();
    e = n;
    return e;
  })();
  var r = (function (e, t) {
    "use strict";
    function h(e, t) {
      this.helpers = e || {};
      this.partials = t || {};
      p(this);
    }
    function p(e) {
      e.registerHelper("helperMissing", function (e) {
        if (arguments.length === 2) {
          return undefined;
        } else {
          throw new i("Missing helper: '" + e + "'");
        }
      });
      e.registerHelper("blockHelperMissing", function (t, n) {
        var r = n.inverse || function () {},
          i = n.fn;
        if (f(t)) {
          t = t.call(this);
        }
        if (t === true) {
          return i(this);
        } else if (t === false || t == null) {
          return r(this);
        } else if (a(t)) {
          if (t.length > 0) {
            return e.helpers.each(t, n);
          } else {
            return r(this);
          }
        } else {
          return i(t);
        }
      });
      e.registerHelper("each", function (e, t) {
        var n = t.fn,
          r = t.inverse;
        var i = 0,
          s = "",
          o;
        if (f(e)) {
          e = e.call(this);
        }
        if (t.data) {
          o = m(t.data);
        }
        if (e && typeof e === "object") {
          if (a(e)) {
            for (var u = e.length; i < u; i++) {
              if (o) {
                o.index = i;
                o.first = i === 0;
                o.last = i === e.length - 1;
              }
              s = s + n(e[i], { data: o });
            }
          } else {
            for (var l in e) {
              if (e.hasOwnProperty(l)) {
                if (o) {
                  o.key = l;
                  o.index = i;
                  o.first = i === 0;
                }
                s = s + n(e[l], { data: o });
                i++;
              }
            }
          }
        }
        if (i === 0) {
          s = r(this);
        }
        return s;
      });
      e.registerHelper("if", function (e, t) {
        if (f(e)) {
          e = e.call(this);
        }
        if ((!t.hash.includeZero && !e) || r.isEmpty(e)) {
          return t.inverse(this);
        } else {
          return t.fn(this);
        }
      });
      e.registerHelper("unless", function (t, n) {
        return e.helpers["if"].call(this, t, { fn: n.inverse, inverse: n.fn, hash: n.hash });
      });
      e.registerHelper("with", function (e, t) {
        if (f(e)) {
          e = e.call(this);
        }
        if (!r.isEmpty(e)) return t.fn(e);
      });
      e.registerHelper("log", function (t, n) {
        var r = n.data && n.data.level != null ? parseInt(n.data.level, 10) : 1;
        e.log(r, t);
      });
    }
    function v(e, t) {
      d.log(e, t);
    }
    var n = {};
    var r = e;
    var i = t;
    var s = "1.3.0";
    n.VERSION = s;
    var o = 4;
    n.COMPILER_REVISION = o;
    var u = { 1: "<= 1.0.rc.2", 2: "== 1.0.0-rc.3", 3: "== 1.0.0-rc.4", 4: ">= 1.0.0" };
    n.REVISION_CHANGES = u;
    var a = r.isArray,
      f = r.isFunction,
      l = r.toString,
      c = "[object Object]";
    n.HandlebarsEnvironment = h;
    h.prototype = {
      constructor: h,
      logger: d,
      log: v,
      registerHelper: function (e, t, n) {
        if (l.call(e) === c) {
          if (n || t) {
            throw new i("Arg not supported with multiple helpers");
          }
          r.extend(this.helpers, e);
        } else {
          if (n) {
            t.not = n;
          }
          this.helpers[e] = t;
        }
      },
      registerPartial: function (e, t) {
        if (l.call(e) === c) {
          r.extend(this.partials, e);
        } else {
          this.partials[e] = t;
        }
      },
    };
    var d = {
      methodMap: { 0: "debug", 1: "info", 2: "warn", 3: "error" },
      DEBUG: 0,
      INFO: 1,
      WARN: 2,
      ERROR: 3,
      level: 3,
      log: function (e, t) {
        if (d.level <= e) {
          var n = d.methodMap[e];
          if (typeof console !== "undefined" && console[n]) {
            console[n].call(console, t);
          }
        }
      },
    };
    n.logger = d;
    n.log = v;
    var m = function (e) {
      var t = {};
      r.extend(t, e);
      return t;
    };
    n.createFrame = m;
    return n;
  })(t, n);
  var i = (function (e, t, n) {
    "use strict";
    function a(e) {
      var t = (e && e[0]) || 1,
        n = o;
      if (t !== n) {
        if (t < n) {
          var r = u[n],
            i = u[t];
          throw new s(
            "Template was precompiled with an older version of Handlebars than the current runtime. " +
              "Please update your precompiler to a newer version (" +
              r +
              ") or downgrade your runtime to an older version (" +
              i +
              ").",
          );
        } else {
          throw new s(
            "Template was precompiled with a newer version of Handlebars than the current runtime. " +
              "Please update your runtime to a newer version (" +
              e[1] +
              ").",
          );
        }
      }
    }
    function f(e, t) {
      if (!t) {
        throw new s("No environment passed to template");
      }
      var n = function (e, n, r, i, o, u) {
        var a = t.VM.invokePartial.apply(this, arguments);
        if (a != null) {
          return a;
        }
        if (t.compile) {
          var f = { helpers: i, partials: o, data: u };
          o[n] = t.compile(e, { data: u !== undefined }, t);
          return o[n](r, f);
        } else {
          throw new s(
            "The partial " + n + " could not be compiled when running in runtime-only mode",
          );
        }
      };
      var r = {
        escapeExpression: i.escapeExpression,
        invokePartial: n,
        programs: [],
        program: function (e, t, n) {
          var r = this.programs[e];
          if (n) {
            r = c(e, t, n);
          } else if (!r) {
            r = this.programs[e] = c(e, t);
          }
          return r;
        },
        merge: function (e, t) {
          var n = e || t;
          if (e && t && e !== t) {
            n = {};
            i.extend(n, t);
            i.extend(n, e);
          }
          return n;
        },
        programWithDepth: t.VM.programWithDepth,
        noop: t.VM.noop,
        compilerInfo: null,
      };
      return function (n, i) {
        i = i || {};
        var s = i.partial ? i : t,
          o,
          u;
        if (!i.partial) {
          o = i.helpers;
          u = i.partials;
        }
        var a = e.call(r, s, n, o, u, i.data);
        if (!i.partial) {
          t.VM.checkRevision(r.compilerInfo);
        }
        return a;
      };
    }
    function l(e, t, n) {
      var r = Array.prototype.slice.call(arguments, 3);
      var i = function (e, i) {
        i = i || {};
        return t.apply(this, [e, i.data || n].concat(r));
      };
      i.program = e;
      i.depth = r.length;
      return i;
    }
    function c(e, t, n) {
      var r = function (e, r) {
        r = r || {};
        return t(e, r.data || n);
      };
      r.program = e;
      r.depth = 0;
      return r;
    }
    function h(e, t, n, r, i, o) {
      var u = { partial: true, helpers: r, partials: i, data: o };
      if (e === undefined) {
        throw new s("The partial " + t + " could not be found");
      } else if (e instanceof Function) {
        return e(n, u);
      }
    }
    function p() {
      return "";
    }
    var r = {};
    var i = e;
    var s = t;
    var o = n.COMPILER_REVISION;
    var u = n.REVISION_CHANGES;
    r.checkRevision = a;
    r.template = f;
    r.programWithDepth = l;
    r.program = c;
    r.invokePartial = h;
    r.noop = p;
    return r;
  })(t, n, r);
  var s = (function (e, t, n, r, i) {
    "use strict";
    var s;
    var o = e;
    var u = t;
    var a = n;
    var f = r;
    var l = i;
    var c = function () {
      var e = new o.HandlebarsEnvironment();
      f.extend(e, o);
      e.SafeString = u;
      e.Exception = a;
      e.Utils = f;
      e.VM = l;
      e.template = function (t) {
        return l.template(t, e);
      };
      return e;
    };
    var h = c();
    h.create = c;
    s = h;
    return s;
  })(r, e, n, t, i);
  var o = (function (e) {
    "use strict";
    function r(e) {
      e = e || {};
      this.firstLine = e.first_line;
      this.firstColumn = e.first_column;
      this.lastColumn = e.last_column;
      this.lastLine = e.last_line;
    }
    var t;
    var n = e;
    var i = {
      ProgramNode: function (e, t, n, s) {
        var o, u;
        if (arguments.length === 3) {
          s = n;
          n = null;
        } else if (arguments.length === 2) {
          s = t;
          t = null;
        }
        r.call(this, s);
        this.type = "program";
        this.statements = e;
        this.strip = {};
        if (n) {
          u = n[0];
          if (u) {
            o = {
              first_line: u.firstLine,
              last_line: u.lastLine,
              last_column: u.lastColumn,
              first_column: u.firstColumn,
            };
            this.inverse = new i.ProgramNode(n, t, o);
          } else {
            this.inverse = new i.ProgramNode(n, t);
          }
          this.strip.right = t.left;
        } else if (t) {
          this.strip.left = t.right;
        }
      },
      MustacheNode: function (e, t, n, s, o) {
        r.call(this, o);
        this.type = "mustache";
        this.strip = s;
        if (n != null && n.charAt) {
          var u = n.charAt(3) || n.charAt(2);
          this.escaped = u !== "{" && u !== "&";
        } else {
          this.escaped = !!n;
        }
        if (e instanceof i.SexprNode) {
          this.sexpr = e;
        } else {
          this.sexpr = new i.SexprNode(e, t);
        }
        this.sexpr.isRoot = true;
        this.id = this.sexpr.id;
        this.params = this.sexpr.params;
        this.hash = this.sexpr.hash;
        this.eligibleHelper = this.sexpr.eligibleHelper;
        this.isHelper = this.sexpr.isHelper;
      },
      SexprNode: function (e, t, n) {
        r.call(this, n);
        this.type = "sexpr";
        this.hash = t;
        var i = (this.id = e[0]);
        var s = (this.params = e.slice(1));
        var o = (this.eligibleHelper = i.isSimple);
        this.isHelper = o && (s.length || t);
      },
      PartialNode: function (e, t, n, i) {
        r.call(this, i);
        this.type = "partial";
        this.partialName = e;
        this.context = t;
        this.strip = n;
      },
      BlockNode: function (e, t, i, s, o) {
        r.call(this, o);
        if (e.sexpr.id.original !== s.path.original) {
          throw new n(e.sexpr.id.original + " doesn't match " + s.path.original, this);
        }
        this.type = "block";
        this.mustache = e;
        this.program = t;
        this.inverse = i;
        this.strip = { left: e.strip.left, right: s.strip.right };
        (t || i).strip.left = e.strip.right;
        (i || t).strip.right = s.strip.left;
        if (i && !t) {
          this.isInverse = true;
        }
      },
      ContentNode: function (e, t) {
        r.call(this, t);
        this.type = "content";
        this.string = e;
      },
      HashNode: function (e, t) {
        r.call(this, t);
        this.type = "hash";
        this.pairs = e;
      },
      IdNode: function (e, t) {
        r.call(this, t);
        this.type = "ID";
        var i = "",
          s = [],
          o = 0;
        for (var u = 0, a = e.length; u < a; u++) {
          var f = e[u].part;
          i += (e[u].separator || "") + f;
          if (f === ".." || f === "." || f === "this") {
            if (s.length > 0) {
              throw new n("Invalid path: " + i, this);
            } else if (f === "..") {
              o++;
            } else {
              this.isScoped = true;
            }
          } else {
            s.push(f);
          }
        }
        this.original = i;
        this.parts = s;
        this.string = s.join(".");
        this.depth = o;
        this.isSimple = e.length === 1 && !this.isScoped && o === 0;
        this.stringModeValue = this.string;
      },
      PartialNameNode: function (e, t) {
        r.call(this, t);
        this.type = "PARTIAL_NAME";
        this.name = e.original;
      },
      DataNode: function (e, t) {
        r.call(this, t);
        this.type = "DATA";
        this.id = e;
      },
      StringNode: function (e, t) {
        r.call(this, t);
        this.type = "STRING";
        this.original = this.string = this.stringModeValue = e;
      },
      IntegerNode: function (e, t) {
        r.call(this, t);
        this.type = "INTEGER";
        this.original = this.integer = e;
        this.stringModeValue = Number(e);
      },
      BooleanNode: function (e, t) {
        r.call(this, t);
        this.type = "BOOLEAN";
        this.bool = e;
        this.stringModeValue = e === "true";
      },
      CommentNode: function (e, t) {
        r.call(this, t);
        this.type = "comment";
        this.comment = e;
      },
    };
    t = i;
    return t;
  })(n);
  var u = (function () {
    "use strict";
    var e;
    var t = (function () {
      function t(e, t) {
        return { left: e.charAt(2) === "~", right: t.charAt(0) === "~" || t.charAt(1) === "~" };
      }
      function r() {
        this.yy = {};
      }
      var e = {
        trace: function () {},
        yy: {},
        symbols_: {
          error: 2,
          root: 3,
          statements: 4,
          EOF: 5,
          program: 6,
          simpleInverse: 7,
          statement: 8,
          openInverse: 9,
          closeBlock: 10,
          openBlock: 11,
          mustache: 12,
          partial: 13,
          CONTENT: 14,
          COMMENT: 15,
          OPEN_BLOCK: 16,
          sexpr: 17,
          CLOSE: 18,
          OPEN_INVERSE: 19,
          OPEN_ENDBLOCK: 20,
          path: 21,
          OPEN: 22,
          OPEN_UNESCAPED: 23,
          CLOSE_UNESCAPED: 24,
          OPEN_PARTIAL: 25,
          partialName: 26,
          partial_option0: 27,
          sexpr_repetition0: 28,
          sexpr_option0: 29,
          dataName: 30,
          param: 31,
          STRING: 32,
          INTEGER: 33,
          BOOLEAN: 34,
          OPEN_SEXPR: 35,
          CLOSE_SEXPR: 36,
          hash: 37,
          hash_repetition_plus0: 38,
          hashSegment: 39,
          ID: 40,
          EQUALS: 41,
          DATA: 42,
          pathSegments: 43,
          SEP: 44,
          $accept: 0,
          $end: 1,
        },
        terminals_: {
          2: "error",
          5: "EOF",
          14: "CONTENT",
          15: "COMMENT",
          16: "OPEN_BLOCK",
          18: "CLOSE",
          19: "OPEN_INVERSE",
          20: "OPEN_ENDBLOCK",
          22: "OPEN",
          23: "OPEN_UNESCAPED",
          24: "CLOSE_UNESCAPED",
          25: "OPEN_PARTIAL",
          32: "STRING",
          33: "INTEGER",
          34: "BOOLEAN",
          35: "OPEN_SEXPR",
          36: "CLOSE_SEXPR",
          40: "ID",
          41: "EQUALS",
          42: "DATA",
          44: "SEP",
        },
        productions_: [
          0,
          [3, 2],
          [3, 1],
          [6, 2],
          [6, 3],
          [6, 2],
          [6, 1],
          [6, 1],
          [6, 0],
          [4, 1],
          [4, 2],
          [8, 3],
          [8, 3],
          [8, 1],
          [8, 1],
          [8, 1],
          [8, 1],
          [11, 3],
          [9, 3],
          [10, 3],
          [12, 3],
          [12, 3],
          [13, 4],
          [7, 2],
          [17, 3],
          [17, 1],
          [31, 1],
          [31, 1],
          [31, 1],
          [31, 1],
          [31, 1],
          [31, 3],
          [37, 1],
          [39, 3],
          [26, 1],
          [26, 1],
          [26, 1],
          [30, 2],
          [21, 1],
          [43, 3],
          [43, 1],
          [27, 0],
          [27, 1],
          [28, 0],
          [28, 2],
          [29, 0],
          [29, 1],
          [38, 1],
          [38, 2],
        ],
        performAction: function (n, r, i, s, o, u, a) {
          var f = u.length - 1;
          switch (o) {
            case 1:
              return new s.ProgramNode(u[f - 1], this._$);
              break;
            case 2:
              return new s.ProgramNode([], this._$);
              break;
            case 3:
              this.$ = new s.ProgramNode([], u[f - 1], u[f], this._$);
              break;
            case 4:
              this.$ = new s.ProgramNode(u[f - 2], u[f - 1], u[f], this._$);
              break;
            case 5:
              this.$ = new s.ProgramNode(u[f - 1], u[f], [], this._$);
              break;
            case 6:
              this.$ = new s.ProgramNode(u[f], this._$);
              break;
            case 7:
              this.$ = new s.ProgramNode([], this._$);
              break;
            case 8:
              this.$ = new s.ProgramNode([], this._$);
              break;
            case 9:
              this.$ = [u[f]];
              break;
            case 10:
              u[f - 1].push(u[f]);
              this.$ = u[f - 1];
              break;
            case 11:
              this.$ = new s.BlockNode(u[f - 2], u[f - 1].inverse, u[f - 1], u[f], this._$);
              break;
            case 12:
              this.$ = new s.BlockNode(u[f - 2], u[f - 1], u[f - 1].inverse, u[f], this._$);
              break;
            case 13:
              this.$ = u[f];
              break;
            case 14:
              this.$ = u[f];
              break;
            case 15:
              this.$ = new s.ContentNode(u[f], this._$);
              break;
            case 16:
              this.$ = new s.CommentNode(u[f], this._$);
              break;
            case 17:
              this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$);
              break;
            case 18:
              this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$);
              break;
            case 19:
              this.$ = { path: u[f - 1], strip: t(u[f - 2], u[f]) };
              break;
            case 20:
              this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$);
              break;
            case 21:
              this.$ = new s.MustacheNode(u[f - 1], null, u[f - 2], t(u[f - 2], u[f]), this._$);
              break;
            case 22:
              this.$ = new s.PartialNode(u[f - 2], u[f - 1], t(u[f - 3], u[f]), this._$);
              break;
            case 23:
              this.$ = t(u[f - 1], u[f]);
              break;
            case 24:
              this.$ = new s.SexprNode([u[f - 2]].concat(u[f - 1]), u[f], this._$);
              break;
            case 25:
              this.$ = new s.SexprNode([u[f]], null, this._$);
              break;
            case 26:
              this.$ = u[f];
              break;
            case 27:
              this.$ = new s.StringNode(u[f], this._$);
              break;
            case 28:
              this.$ = new s.IntegerNode(u[f], this._$);
              break;
            case 29:
              this.$ = new s.BooleanNode(u[f], this._$);
              break;
            case 30:
              this.$ = u[f];
              break;
            case 31:
              u[f - 1].isHelper = true;
              this.$ = u[f - 1];
              break;
            case 32:
              this.$ = new s.HashNode(u[f], this._$);
              break;
            case 33:
              this.$ = [u[f - 2], u[f]];
              break;
            case 34:
              this.$ = new s.PartialNameNode(u[f], this._$);
              break;
            case 35:
              this.$ = new s.PartialNameNode(new s.StringNode(u[f], this._$), this._$);
              break;
            case 36:
              this.$ = new s.PartialNameNode(new s.IntegerNode(u[f], this._$));
              break;
            case 37:
              this.$ = new s.DataNode(u[f], this._$);
              break;
            case 38:
              this.$ = new s.IdNode(u[f], this._$);
              break;
            case 39:
              u[f - 2].push({ part: u[f], separator: u[f - 1] });
              this.$ = u[f - 2];
              break;
            case 40:
              this.$ = [{ part: u[f] }];
              break;
            case 43:
              this.$ = [];
              break;
            case 44:
              u[f - 1].push(u[f]);
              break;
            case 47:
              this.$ = [u[f]];
              break;
            case 48:
              u[f - 1].push(u[f]);
              break;
          }
        },
        table: [
          {
            3: 1,
            4: 2,
            5: [1, 3],
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15],
          },
          { 1: [3] },
          {
            5: [1, 16],
            8: 17,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15],
          },
          { 1: [2, 2] },
          {
            5: [2, 9],
            14: [2, 9],
            15: [2, 9],
            16: [2, 9],
            19: [2, 9],
            20: [2, 9],
            22: [2, 9],
            23: [2, 9],
            25: [2, 9],
          },
          {
            4: 20,
            6: 18,
            7: 19,
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 21],
            20: [2, 8],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15],
          },
          {
            4: 20,
            6: 22,
            7: 19,
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 21],
            20: [2, 8],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15],
          },
          {
            5: [2, 13],
            14: [2, 13],
            15: [2, 13],
            16: [2, 13],
            19: [2, 13],
            20: [2, 13],
            22: [2, 13],
            23: [2, 13],
            25: [2, 13],
          },
          {
            5: [2, 14],
            14: [2, 14],
            15: [2, 14],
            16: [2, 14],
            19: [2, 14],
            20: [2, 14],
            22: [2, 14],
            23: [2, 14],
            25: [2, 14],
          },
          {
            5: [2, 15],
            14: [2, 15],
            15: [2, 15],
            16: [2, 15],
            19: [2, 15],
            20: [2, 15],
            22: [2, 15],
            23: [2, 15],
            25: [2, 15],
          },
          {
            5: [2, 16],
            14: [2, 16],
            15: [2, 16],
            16: [2, 16],
            19: [2, 16],
            20: [2, 16],
            22: [2, 16],
            23: [2, 16],
            25: [2, 16],
          },
          { 17: 23, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 17: 29, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 17: 30, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 17: 31, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 21: 33, 26: 32, 32: [1, 34], 33: [1, 35], 40: [1, 28], 43: 26 },
          { 1: [2, 1] },
          {
            5: [2, 10],
            14: [2, 10],
            15: [2, 10],
            16: [2, 10],
            19: [2, 10],
            20: [2, 10],
            22: [2, 10],
            23: [2, 10],
            25: [2, 10],
          },
          { 10: 36, 20: [1, 37] },
          {
            4: 38,
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            20: [2, 7],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15],
          },
          {
            7: 39,
            8: 17,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 21],
            20: [2, 6],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15],
          },
          { 17: 23, 18: [1, 40], 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 10: 41, 20: [1, 37] },
          { 18: [1, 42] },
          {
            18: [2, 43],
            24: [2, 43],
            28: 43,
            32: [2, 43],
            33: [2, 43],
            34: [2, 43],
            35: [2, 43],
            36: [2, 43],
            40: [2, 43],
            42: [2, 43],
          },
          { 18: [2, 25], 24: [2, 25], 36: [2, 25] },
          {
            18: [2, 38],
            24: [2, 38],
            32: [2, 38],
            33: [2, 38],
            34: [2, 38],
            35: [2, 38],
            36: [2, 38],
            40: [2, 38],
            42: [2, 38],
            44: [1, 44],
          },
          { 21: 45, 40: [1, 28], 43: 26 },
          {
            18: [2, 40],
            24: [2, 40],
            32: [2, 40],
            33: [2, 40],
            34: [2, 40],
            35: [2, 40],
            36: [2, 40],
            40: [2, 40],
            42: [2, 40],
            44: [2, 40],
          },
          { 18: [1, 46] },
          { 18: [1, 47] },
          { 24: [1, 48] },
          { 18: [2, 41], 21: 50, 27: 49, 40: [1, 28], 43: 26 },
          { 18: [2, 34], 40: [2, 34] },
          { 18: [2, 35], 40: [2, 35] },
          { 18: [2, 36], 40: [2, 36] },
          {
            5: [2, 11],
            14: [2, 11],
            15: [2, 11],
            16: [2, 11],
            19: [2, 11],
            20: [2, 11],
            22: [2, 11],
            23: [2, 11],
            25: [2, 11],
          },
          { 21: 51, 40: [1, 28], 43: 26 },
          {
            8: 17,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            20: [2, 3],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15],
          },
          {
            4: 52,
            8: 4,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            20: [2, 5],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15],
          },
          {
            14: [2, 23],
            15: [2, 23],
            16: [2, 23],
            19: [2, 23],
            20: [2, 23],
            22: [2, 23],
            23: [2, 23],
            25: [2, 23],
          },
          {
            5: [2, 12],
            14: [2, 12],
            15: [2, 12],
            16: [2, 12],
            19: [2, 12],
            20: [2, 12],
            22: [2, 12],
            23: [2, 12],
            25: [2, 12],
          },
          {
            14: [2, 18],
            15: [2, 18],
            16: [2, 18],
            19: [2, 18],
            20: [2, 18],
            22: [2, 18],
            23: [2, 18],
            25: [2, 18],
          },
          {
            18: [2, 45],
            21: 56,
            24: [2, 45],
            29: 53,
            30: 60,
            31: 54,
            32: [1, 57],
            33: [1, 58],
            34: [1, 59],
            35: [1, 61],
            36: [2, 45],
            37: 55,
            38: 62,
            39: 63,
            40: [1, 64],
            42: [1, 27],
            43: 26,
          },
          { 40: [1, 65] },
          {
            18: [2, 37],
            24: [2, 37],
            32: [2, 37],
            33: [2, 37],
            34: [2, 37],
            35: [2, 37],
            36: [2, 37],
            40: [2, 37],
            42: [2, 37],
          },
          {
            14: [2, 17],
            15: [2, 17],
            16: [2, 17],
            19: [2, 17],
            20: [2, 17],
            22: [2, 17],
            23: [2, 17],
            25: [2, 17],
          },
          {
            5: [2, 20],
            14: [2, 20],
            15: [2, 20],
            16: [2, 20],
            19: [2, 20],
            20: [2, 20],
            22: [2, 20],
            23: [2, 20],
            25: [2, 20],
          },
          {
            5: [2, 21],
            14: [2, 21],
            15: [2, 21],
            16: [2, 21],
            19: [2, 21],
            20: [2, 21],
            22: [2, 21],
            23: [2, 21],
            25: [2, 21],
          },
          { 18: [1, 66] },
          { 18: [2, 42] },
          { 18: [1, 67] },
          {
            8: 17,
            9: 5,
            11: 6,
            12: 7,
            13: 8,
            14: [1, 9],
            15: [1, 10],
            16: [1, 12],
            19: [1, 11],
            20: [2, 4],
            22: [1, 13],
            23: [1, 14],
            25: [1, 15],
          },
          { 18: [2, 24], 24: [2, 24], 36: [2, 24] },
          {
            18: [2, 44],
            24: [2, 44],
            32: [2, 44],
            33: [2, 44],
            34: [2, 44],
            35: [2, 44],
            36: [2, 44],
            40: [2, 44],
            42: [2, 44],
          },
          { 18: [2, 46], 24: [2, 46], 36: [2, 46] },
          {
            18: [2, 26],
            24: [2, 26],
            32: [2, 26],
            33: [2, 26],
            34: [2, 26],
            35: [2, 26],
            36: [2, 26],
            40: [2, 26],
            42: [2, 26],
          },
          {
            18: [2, 27],
            24: [2, 27],
            32: [2, 27],
            33: [2, 27],
            34: [2, 27],
            35: [2, 27],
            36: [2, 27],
            40: [2, 27],
            42: [2, 27],
          },
          {
            18: [2, 28],
            24: [2, 28],
            32: [2, 28],
            33: [2, 28],
            34: [2, 28],
            35: [2, 28],
            36: [2, 28],
            40: [2, 28],
            42: [2, 28],
          },
          {
            18: [2, 29],
            24: [2, 29],
            32: [2, 29],
            33: [2, 29],
            34: [2, 29],
            35: [2, 29],
            36: [2, 29],
            40: [2, 29],
            42: [2, 29],
          },
          {
            18: [2, 30],
            24: [2, 30],
            32: [2, 30],
            33: [2, 30],
            34: [2, 30],
            35: [2, 30],
            36: [2, 30],
            40: [2, 30],
            42: [2, 30],
          },
          { 17: 68, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
          { 18: [2, 32], 24: [2, 32], 36: [2, 32], 39: 69, 40: [1, 70] },
          { 18: [2, 47], 24: [2, 47], 36: [2, 47], 40: [2, 47] },
          {
            18: [2, 40],
            24: [2, 40],
            32: [2, 40],
            33: [2, 40],
            34: [2, 40],
            35: [2, 40],
            36: [2, 40],
            40: [2, 40],
            41: [1, 71],
            42: [2, 40],
            44: [2, 40],
          },
          {
            18: [2, 39],
            24: [2, 39],
            32: [2, 39],
            33: [2, 39],
            34: [2, 39],
            35: [2, 39],
            36: [2, 39],
            40: [2, 39],
            42: [2, 39],
            44: [2, 39],
          },
          {
            5: [2, 22],
            14: [2, 22],
            15: [2, 22],
            16: [2, 22],
            19: [2, 22],
            20: [2, 22],
            22: [2, 22],
            23: [2, 22],
            25: [2, 22],
          },
          {
            5: [2, 19],
            14: [2, 19],
            15: [2, 19],
            16: [2, 19],
            19: [2, 19],
            20: [2, 19],
            22: [2, 19],
            23: [2, 19],
            25: [2, 19],
          },
          { 36: [1, 72] },
          { 18: [2, 48], 24: [2, 48], 36: [2, 48], 40: [2, 48] },
          { 41: [1, 71] },
          {
            21: 56,
            30: 60,
            31: 73,
            32: [1, 57],
            33: [1, 58],
            34: [1, 59],
            35: [1, 61],
            40: [1, 28],
            42: [1, 27],
            43: 26,
          },
          {
            18: [2, 31],
            24: [2, 31],
            32: [2, 31],
            33: [2, 31],
            34: [2, 31],
            35: [2, 31],
            36: [2, 31],
            40: [2, 31],
            42: [2, 31],
          },
          { 18: [2, 33], 24: [2, 33], 36: [2, 33], 40: [2, 33] },
        ],
        defaultActions: { 3: [2, 2], 16: [2, 1], 50: [2, 42] },
        parseError: function (t, n) {
          throw new Error(t);
        },
        parse: function (t) {
          function v(e) {
            r.length = r.length - 2 * e;
            i.length = i.length - e;
            s.length = s.length - e;
          }
          function m() {
            var e;
            e = n.lexer.lex() || 1;
            if (typeof e !== "number") {
              e = n.symbols_[e] || e;
            }
            return e;
          }
          var n = this,
            r = [0],
            i = [null],
            s = [],
            o = this.table,
            u = "",
            a = 0,
            f = 0,
            l = 0,
            c = 2,
            h = 1;
          this.lexer.setInput(t);
          this.lexer.yy = this.yy;
          this.yy.lexer = this.lexer;
          this.yy.parser = this;
          if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
          var p = this.lexer.yylloc;
          s.push(p);
          var d = this.lexer.options && this.lexer.options.ranges;
          if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
          var g,
            y,
            b,
            w,
            E,
            S,
            x = {},
            T,
            N,
            C,
            k;
          while (true) {
            b = r[r.length - 1];
            if (this.defaultActions[b]) {
              w = this.defaultActions[b];
            } else {
              if (g === null || typeof g == "undefined") {
                g = m();
              }
              w = o[b] && o[b][g];
            }
            if (typeof w === "undefined" || !w.length || !w[0]) {
              var L = "";
              if (!l) {
                k = [];
                for (T in o[b])
                  if (this.terminals_[T] && T > 2) {
                    k.push("'" + this.terminals_[T] + "'");
                  }
                if (this.lexer.showPosition) {
                  L =
                    "Parse error on line " +
                    (a + 1) +
                    ":\n" +
                    this.lexer.showPosition() +
                    "\nExpecting " +
                    k.join(", ") +
                    ", got '" +
                    (this.terminals_[g] || g) +
                    "'";
                } else {
                  L =
                    "Parse error on line " +
                    (a + 1) +
                    ": Unexpected " +
                    (g == 1 ? "end of input" : "'" + (this.terminals_[g] || g) + "'");
                }
                this.parseError(L, {
                  text: this.lexer.match,
                  token: this.terminals_[g] || g,
                  line: this.lexer.yylineno,
                  loc: p,
                  expected: k,
                });
              }
            }
            if (w[0] instanceof Array && w.length > 1) {
              throw new Error(
                "Parse Error: multiple actions possible at state: " + b + ", token: " + g,
              );
            }
            switch (w[0]) {
              case 1:
                r.push(g);
                i.push(this.lexer.yytext);
                s.push(this.lexer.yylloc);
                r.push(w[1]);
                g = null;
                if (!y) {
                  f = this.lexer.yyleng;
                  u = this.lexer.yytext;
                  a = this.lexer.yylineno;
                  p = this.lexer.yylloc;
                  if (l > 0) l--;
                } else {
                  g = y;
                  y = null;
                }
                break;
              case 2:
                N = this.productions_[w[1]][1];
                x.$ = i[i.length - N];
                x._$ = {
                  first_line: s[s.length - (N || 1)].first_line,
                  last_line: s[s.length - 1].last_line,
                  first_column: s[s.length - (N || 1)].first_column,
                  last_column: s[s.length - 1].last_column,
                };
                if (d) {
                  x._$.range = [s[s.length - (N || 1)].range[0], s[s.length - 1].range[1]];
                }
                S = this.performAction.call(x, u, f, a, this.yy, w[1], i, s);
                if (typeof S !== "undefined") {
                  return S;
                }
                if (N) {
                  r = r.slice(0, -1 * N * 2);
                  i = i.slice(0, -1 * N);
                  s = s.slice(0, -1 * N);
                }
                r.push(this.productions_[w[1]][0]);
                i.push(x.$);
                s.push(x._$);
                C = o[r[r.length - 2]][r[r.length - 1]];
                r.push(C);
                break;
              case 3:
                return true;
            }
          }
          return true;
        },
      };
      var n = (function () {
        var e = {
          EOF: 1,
          parseError: function (t, n) {
            if (this.yy.parser) {
              this.yy.parser.parseError(t, n);
            } else {
              throw new Error(t);
            }
          },
          setInput: function (e) {
            this._input = e;
            this._more = this._less = this.done = false;
            this.yylineno = this.yyleng = 0;
            this.yytext = this.matched = this.match = "";
            this.conditionStack = ["INITIAL"];
            this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 };
            if (this.options.ranges) this.yylloc.range = [0, 0];
            this.offset = 0;
            return this;
          },
          input: function () {
            var e = this._input[0];
            this.yytext += e;
            this.yyleng++;
            this.offset++;
            this.match += e;
            this.matched += e;
            var t = e.match(/(?:\r\n?|\n).*/g);
            if (t) {
              this.yylineno++;
              this.yylloc.last_line++;
            } else {
              this.yylloc.last_column++;
            }
            if (this.options.ranges) this.yylloc.range[1]++;
            this._input = this._input.slice(1);
            return e;
          },
          unput: function (e) {
            var t = e.length;
            var n = e.split(/(?:\r\n?|\n)/g);
            this._input = e + this._input;
            this.yytext = this.yytext.substr(0, this.yytext.length - t - 1);
            this.offset -= t;
            var r = this.match.split(/(?:\r\n?|\n)/g);
            this.match = this.match.substr(0, this.match.length - 1);
            this.matched = this.matched.substr(0, this.matched.length - 1);
            if (n.length - 1) this.yylineno -= n.length - 1;
            var i = this.yylloc.range;
            this.yylloc = {
              first_line: this.yylloc.first_line,
              last_line: this.yylineno + 1,
              first_column: this.yylloc.first_column,
              last_column: n
                ? (n.length === r.length ? this.yylloc.first_column : 0) +
                  r[r.length - n.length].length -
                  n[0].length
                : this.yylloc.first_column - t,
            };
            if (this.options.ranges) {
              this.yylloc.range = [i[0], i[0] + this.yyleng - t];
            }
            return this;
          },
          more: function () {
            this._more = true;
            return this;
          },
          less: function (e) {
            this.unput(this.match.slice(e));
          },
          pastInput: function () {
            var e = this.matched.substr(0, this.matched.length - this.match.length);
            return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "");
          },
          upcomingInput: function () {
            var e = this.match;
            if (e.length < 20) {
              e += this._input.substr(0, 20 - e.length);
            }
            return (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "");
          },
          showPosition: function () {
            var e = this.pastInput();
            var t = new Array(e.length + 1).join("-");
            return e + this.upcomingInput() + "\n" + t + "^";
          },
          next: function () {
            if (this.done) {
              return this.EOF;
            }
            if (!this._input) this.done = true;
            var e, t, n, r, i, s;
            if (!this._more) {
              this.yytext = "";
              this.match = "";
            }
            var o = this._currentRules();
            for (var u = 0; u < o.length; u++) {
              n = this._input.match(this.rules[o[u]]);
              if (n && (!t || n[0].length > t[0].length)) {
                t = n;
                r = u;
                if (!this.options.flex) break;
              }
            }
            if (t) {
              s = t[0].match(/(?:\r\n?|\n).*/g);
              if (s) this.yylineno += s.length;
              this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: s
                  ? s[s.length - 1].length - s[s.length - 1].match(/\r?\n?/)[0].length
                  : this.yylloc.last_column + t[0].length,
              };
              this.yytext += t[0];
              this.match += t[0];
              this.matches = t;
              this.yyleng = this.yytext.length;
              if (this.options.ranges) {
                this.yylloc.range = [this.offset, (this.offset += this.yyleng)];
              }
              this._more = false;
              this._input = this._input.slice(t[0].length);
              this.matched += t[0];
              e = this.performAction.call(
                this,
                this.yy,
                this,
                o[r],
                this.conditionStack[this.conditionStack.length - 1],
              );
              if (this.done && this._input) this.done = false;
              if (e) return e;
              else return;
            }
            if (this._input === "") {
              return this.EOF;
            } else {
              return this.parseError(
                "Lexical error on line " +
                  (this.yylineno + 1) +
                  ". Unrecognized text.\n" +
                  this.showPosition(),
                { text: "", token: null, line: this.yylineno },
              );
            }
          },
          lex: function () {
            var t = this.next();
            if (typeof t !== "undefined") {
              return t;
            } else {
              return this.lex();
            }
          },
          begin: function (t) {
            this.conditionStack.push(t);
          },
          popState: function () {
            return this.conditionStack.pop();
          },
          _currentRules: function () {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
          },
          topState: function () {
            return this.conditionStack[this.conditionStack.length - 2];
          },
          pushState: function (t) {
            this.begin(t);
          },
        };
        e.options = {};
        e.performAction = function (t, n, r, i) {
          function s(e, t) {
            return (n.yytext = n.yytext.substr(e, n.yyleng - t));
          }
          var o = i;
          switch (r) {
            case 0:
              if (n.yytext.slice(-2) === "\\\\") {
                s(0, 1);
                this.begin("mu");
              } else if (n.yytext.slice(-1) === "\\") {
                s(0, 1);
                this.begin("emu");
              } else {
                this.begin("mu");
              }
              if (n.yytext) return 14;
              break;
            case 1:
              return 14;
              break;
            case 2:
              this.popState();
              return 14;
              break;
            case 3:
              s(0, 4);
              this.popState();
              return 15;
              break;
            case 4:
              return 35;
              break;
            case 5:
              return 36;
              break;
            case 6:
              return 25;
              break;
            case 7:
              return 16;
              break;
            case 8:
              return 20;
              break;
            case 9:
              return 19;
              break;
            case 10:
              return 19;
              break;
            case 11:
              return 23;
              break;
            case 12:
              return 22;
              break;
            case 13:
              this.popState();
              this.begin("com");
              break;
            case 14:
              s(3, 5);
              this.popState();
              return 15;
              break;
            case 15:
              return 22;
              break;
            case 16:
              return 41;
              break;
            case 17:
              return 40;
              break;
            case 18:
              return 40;
              break;
            case 19:
              return 44;
              break;
            case 20:
              break;
            case 21:
              this.popState();
              return 24;
              break;
            case 22:
              this.popState();
              return 18;
              break;
            case 23:
              n.yytext = s(1, 2).replace(/\\"/g, '"');
              return 32;
              break;
            case 24:
              n.yytext = s(1, 2).replace(/\\'/g, "'");
              return 32;
              break;
            case 25:
              return 42;
              break;
            case 26:
              return 34;
              break;
            case 27:
              return 34;
              break;
            case 28:
              return 33;
              break;
            case 29:
              return 40;
              break;
            case 30:
              n.yytext = s(1, 2);
              return 40;
              break;
            case 31:
              return "INVALID";
              break;
            case 32:
              return 5;
              break;
          }
        };
        e.rules = [
          /^(?:[^\x00]*?(?=(\{\{)))/,
          /^(?:[^\x00]+)/,
          /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
          /^(?:[\s\S]*?--\}\})/,
          /^(?:\()/,
          /^(?:\))/,
          /^(?:\{\{(~)?>)/,
          /^(?:\{\{(~)?#)/,
          /^(?:\{\{(~)?\/)/,
          /^(?:\{\{(~)?\^)/,
          /^(?:\{\{(~)?\s*else\b)/,
          /^(?:\{\{(~)?\{)/,
          /^(?:\{\{(~)?&)/,
          /^(?:\{\{!--)/,
          /^(?:\{\{![\s\S]*?\}\})/,
          /^(?:\{\{(~)?)/,
          /^(?:=)/,
          /^(?:\.\.)/,
          /^(?:\.(?=([=~}\s\/.)])))/,
          /^(?:[\/.])/,
          /^(?:\s+)/,
          /^(?:\}(~)?\}\})/,
          /^(?:(~)?\}\})/,
          /^(?:"(\\["]|[^"])*")/,
          /^(?:'(\\[']|[^'])*')/,
          /^(?:@)/,
          /^(?:true(?=([~}\s)])))/,
          /^(?:false(?=([~}\s)])))/,
          /^(?:-?[0-9]+(?=([~}\s)])))/,
          /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/,
          /^(?:\[[^\]]*\])/,
          /^(?:.)/,
          /^(?:$)/,
        ];
        e.conditions = {
          mu: {
            rules: [
              4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,
              27, 28, 29, 30, 31, 32,
            ],
            inclusive: false,
          },
          emu: { rules: [2], inclusive: false },
          com: { rules: [3], inclusive: false },
          INITIAL: { rules: [0, 1, 32], inclusive: true },
        };
        return e;
      })();
      e.lexer = n;
      r.prototype = e;
      e.Parser = r;
      return new r();
    })();
    e = t;
    return e;
  })();
  var a = (function (e, t) {
    "use strict";
    function s(e) {
      if (e.constructor === i.ProgramNode) {
        return e;
      }
      r.yy = i;
      return r.parse(e);
    }
    var n = {};
    var r = e;
    var i = t;
    n.parser = r;
    n.parse = s;
    return n;
  })(u, o);
  var f = (function (e) {
    "use strict";
    function r() {}
    function i(e, t, r) {
      if (e == null || (typeof e !== "string" && e.constructor !== r.AST.ProgramNode)) {
        throw new n(
          "You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + e,
        );
      }
      t = t || {};
      if (!("data" in t)) {
        t.data = true;
      }
      var i = r.parse(e);
      var s = new r.Compiler().compile(i, t);
      return new r.JavaScriptCompiler().compile(s, t);
    }
    function s(e, t, r) {
      function s() {
        var n = r.parse(e);
        var i = new r.Compiler().compile(n, t);
        var s = new r.JavaScriptCompiler().compile(i, t, undefined, true);
        return r.template(s);
      }
      if (e == null || (typeof e !== "string" && e.constructor !== r.AST.ProgramNode)) {
        throw new n(
          "You must pass a string or Handlebars AST to Handlebars.compile. You passed " + e,
        );
      }
      t = t || {};
      if (!("data" in t)) {
        t.data = true;
      }
      var i;
      return function (e, t) {
        if (!i) {
          i = s();
        }
        return i.call(this, e, t);
      };
    }
    var t = {};
    var n = e;
    t.Compiler = r;
    r.prototype = {
      compiler: r,
      disassemble: function () {
        var e = this.opcodes,
          t,
          n = [],
          r,
          i;
        for (var s = 0, o = e.length; s < o; s++) {
          t = e[s];
          if (t.opcode === "DECLARE") {
            n.push("DECLARE " + t.name + "=" + t.value);
          } else {
            r = [];
            for (var u = 0; u < t.args.length; u++) {
              i = t.args[u];
              if (typeof i === "string") {
                i = '"' + i.replace("\n", "\\n") + '"';
              }
              r.push(i);
            }
            n.push(t.opcode + " " + r.join(" "));
          }
        }
        return n.join("\n");
      },
      equals: function (e) {
        var t = this.opcodes.length;
        if (e.opcodes.length !== t) {
          return false;
        }
        for (var n = 0; n < t; n++) {
          var r = this.opcodes[n],
            i = e.opcodes[n];
          if (r.opcode !== i.opcode || r.args.length !== i.args.length) {
            return false;
          }
          for (var s = 0; s < r.args.length; s++) {
            if (r.args[s] !== i.args[s]) {
              return false;
            }
          }
        }
        t = this.children.length;
        if (e.children.length !== t) {
          return false;
        }
        for (n = 0; n < t; n++) {
          if (!this.children[n].equals(e.children[n])) {
            return false;
          }
        }
        return true;
      },
      guid: 0,
      compile: function (e, t) {
        this.opcodes = [];
        this.children = [];
        this.depths = { list: [] };
        this.options = t;
        var n = this.options.knownHelpers;
        this.options.knownHelpers = {
          helperMissing: true,
          blockHelperMissing: true,
          each: true,
          if: true,
          unless: true,
          with: true,
          log: true,
        };
        if (n) {
          for (var r in n) {
            this.options.knownHelpers[r] = n[r];
          }
        }
        return this.accept(e);
      },
      accept: function (e) {
        var t = e.strip || {},
          n;
        if (t.left) {
          this.opcode("strip");
        }
        n = this[e.type](e);
        if (t.right) {
          this.opcode("strip");
        }
        return n;
      },
      program: function (e) {
        var t = e.statements;
        for (var n = 0, r = t.length; n < r; n++) {
          this.accept(t[n]);
        }
        this.isSimple = r === 1;
        this.depths.list = this.depths.list.sort(function (e, t) {
          return e - t;
        });
        return this;
      },
      compileProgram: function (e) {
        var t = new this.compiler().compile(e, this.options);
        var n = this.guid++,
          r;
        this.usePartial = this.usePartial || t.usePartial;
        this.children[n] = t;
        for (var i = 0, s = t.depths.list.length; i < s; i++) {
          r = t.depths.list[i];
          if (r < 2) {
            continue;
          } else {
            this.addDepth(r - 1);
          }
        }
        return n;
      },
      block: function (e) {
        var t = e.mustache,
          n = e.program,
          r = e.inverse;
        if (n) {
          n = this.compileProgram(n);
        }
        if (r) {
          r = this.compileProgram(r);
        }
        var i = t.sexpr;
        var s = this.classifySexpr(i);
        if (s === "helper") {
          this.helperSexpr(i, n, r);
        } else if (s === "simple") {
          this.simpleSexpr(i);
          this.opcode("pushProgram", n);
          this.opcode("pushProgram", r);
          this.opcode("emptyHash");
          this.opcode("blockValue");
        } else {
          this.ambiguousSexpr(i, n, r);
          this.opcode("pushProgram", n);
          this.opcode("pushProgram", r);
          this.opcode("emptyHash");
          this.opcode("ambiguousBlockValue");
        }
        this.opcode("append");
      },
      hash: function (e) {
        var t = e.pairs,
          n,
          r;
        this.opcode("pushHash");
        for (var i = 0, s = t.length; i < s; i++) {
          n = t[i];
          r = n[1];
          if (this.options.stringParams) {
            if (r.depth) {
              this.addDepth(r.depth);
            }
            this.opcode("getContext", r.depth || 0);
            this.opcode("pushStringParam", r.stringModeValue, r.type);
            if (r.type === "sexpr") {
              this.sexpr(r);
            }
          } else {
            this.accept(r);
          }
          this.opcode("assignToHash", n[0]);
        }
        this.opcode("popHash");
      },
      partial: function (e) {
        var t = e.partialName;
        this.usePartial = true;
        if (e.context) {
          this.ID(e.context);
        } else {
          this.opcode("push", "depth0");
        }
        this.opcode("invokePartial", t.name);
        this.opcode("append");
      },
      content: function (e) {
        this.opcode("appendContent", e.string);
      },
      mustache: function (e) {
        this.sexpr(e.sexpr);
        if (e.escaped && !this.options.noEscape) {
          this.opcode("appendEscaped");
        } else {
          this.opcode("append");
        }
      },
      ambiguousSexpr: function (e, t, n) {
        var r = e.id,
          i = r.parts[0],
          s = t != null || n != null;
        this.opcode("getContext", r.depth);
        this.opcode("pushProgram", t);
        this.opcode("pushProgram", n);
        this.opcode("invokeAmbiguous", i, s);
      },
      simpleSexpr: function (e) {
        var t = e.id;
        if (t.type === "DATA") {
          this.DATA(t);
        } else if (t.parts.length) {
          this.ID(t);
        } else {
          this.addDepth(t.depth);
          this.opcode("getContext", t.depth);
          this.opcode("pushContext");
        }
        this.opcode("resolvePossibleLambda");
      },
      helperSexpr: function (e, t, r) {
        var i = this.setupFullMustacheParams(e, t, r),
          s = e.id.parts[0];
        if (this.options.knownHelpers[s]) {
          this.opcode("invokeKnownHelper", i.length, s);
        } else if (this.options.knownHelpersOnly) {
          throw new n("You specified knownHelpersOnly, but used the unknown helper " + s, e);
        } else {
          this.opcode("invokeHelper", i.length, s, e.isRoot);
        }
      },
      sexpr: function (e) {
        var t = this.classifySexpr(e);
        if (t === "simple") {
          this.simpleSexpr(e);
        } else if (t === "helper") {
          this.helperSexpr(e);
        } else {
          this.ambiguousSexpr(e);
        }
      },
      ID: function (e) {
        this.addDepth(e.depth);
        this.opcode("getContext", e.depth);
        var t = e.parts[0];
        if (!t) {
          this.opcode("pushContext");
        } else {
          this.opcode("lookupOnContext", e.parts[0]);
        }
        for (var n = 1, r = e.parts.length; n < r; n++) {
          this.opcode("lookup", e.parts[n]);
        }
      },
      DATA: function (e) {
        this.options.data = true;
        if (e.id.isScoped || e.id.depth) {
          throw new n("Scoped data references are not supported: " + e.original, e);
        }
        this.opcode("lookupData");
        var t = e.id.parts;
        for (var r = 0, i = t.length; r < i; r++) {
          this.opcode("lookup", t[r]);
        }
      },
      STRING: function (e) {
        this.opcode("pushString", e.string);
      },
      INTEGER: function (e) {
        this.opcode("pushLiteral", e.integer);
      },
      BOOLEAN: function (e) {
        this.opcode("pushLiteral", e.bool);
      },
      comment: function () {},
      opcode: function (e) {
        this.opcodes.push({ opcode: e, args: [].slice.call(arguments, 1) });
      },
      declare: function (e, t) {
        this.opcodes.push({ opcode: "DECLARE", name: e, value: t });
      },
      addDepth: function (e) {
        if (e === 0) {
          return;
        }
        if (!this.depths[e]) {
          this.depths[e] = true;
          this.depths.list.push(e);
        }
      },
      classifySexpr: function (e) {
        var t = e.isHelper;
        var n = e.eligibleHelper;
        var r = this.options;
        if (n && !t) {
          var i = e.id.parts[0];
          if (r.knownHelpers[i]) {
            t = true;
          } else if (r.knownHelpersOnly) {
            n = false;
          }
        }
        if (t) {
          return "helper";
        } else if (n) {
          return "ambiguous";
        } else {
          return "simple";
        }
      },
      pushParams: function (e) {
        var t = e.length,
          n;
        while (t--) {
          n = e[t];
          if (this.options.stringParams) {
            if (n.depth) {
              this.addDepth(n.depth);
            }
            this.opcode("getContext", n.depth || 0);
            this.opcode("pushStringParam", n.stringModeValue, n.type);
            if (n.type === "sexpr") {
              this.sexpr(n);
            }
          } else {
            this[n.type](n);
          }
        }
      },
      setupFullMustacheParams: function (e, t, n) {
        var r = e.params;
        this.pushParams(r);
        this.opcode("pushProgram", t);
        this.opcode("pushProgram", n);
        if (e.hash) {
          this.hash(e.hash);
        } else {
          this.opcode("emptyHash");
        }
        return r;
      },
    };
    t.precompile = i;
    t.compile = s;
    return t;
  })(n);
  var l = (function (e, t) {
    "use strict";
    function u(e) {
      this.value = e;
    }
    function a() {}
    var n;
    var r = e.COMPILER_REVISION;
    var i = e.REVISION_CHANGES;
    var s = e.log;
    var o = t;
    a.prototype = {
      nameLookup: function (e, t) {
        var n, r;
        if (e.indexOf("depth") === 0) {
          n = true;
        }
        if (/^[0-9]+$/.test(t)) {
          r = e + "[" + t + "]";
        } else if (a.isValidJavaScriptVariableName(t)) {
          r = e + "." + t;
        } else {
          r = e + "['" + t + "']";
        }
        if (n) {
          return "(" + e + " && " + r + ")";
        } else {
          return r;
        }
      },
      compilerInfo: function () {
        var e = r,
          t = i[e];
        return "this.compilerInfo = [" + e + ",'" + t + "'];\n";
      },
      appendToBuffer: function (e) {
        if (this.environment.isSimple) {
          return "return " + e + ";";
        } else {
          return {
            appendToBuffer: true,
            content: e,
            toString: function () {
              return "buffer += " + e + ";";
            },
          };
        }
      },
      initializeBuffer: function () {
        return this.quotedString("");
      },
      namespace: "Handlebars",
      compile: function (e, t, n, r) {
        this.environment = e;
        this.options = t || {};
        s("debug", this.environment.disassemble() + "\n\n");
        this.name = this.environment.name;
        this.isChild = !!n;
        this.context = n || { programs: [], environments: [], aliases: {} };
        this.preamble();
        this.stackSlot = 0;
        this.stackVars = [];
        this.registers = { list: [] };
        this.hashes = [];
        this.compileStack = [];
        this.inlineStack = [];
        this.compileChildren(e, t);
        var i = e.opcodes,
          u;
        this.i = 0;
        for (var a = i.length; this.i < a; this.i++) {
          u = i[this.i];
          if (u.opcode === "DECLARE") {
            this[u.name] = u.value;
          } else {
            this[u.opcode].apply(this, u.args);
          }
          if (u.opcode !== this.stripNext) {
            this.stripNext = false;
          }
        }
        this.pushSource("");
        if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
          throw new o("Compile completed with content left on stack");
        }
        return this.createFunctionContext(r);
      },
      preamble: function () {
        var e = [];
        if (!this.isChild) {
          var t = this.namespace;
          var n = "helpers = this.merge(helpers, " + t + ".helpers);";
          if (this.environment.usePartial) {
            n = n + " partials = this.merge(partials, " + t + ".partials);";
          }
          if (this.options.data) {
            n = n + " data = data || {};";
          }
          e.push(n);
        } else {
          e.push("");
        }
        if (!this.environment.isSimple) {
          e.push(", buffer = " + this.initializeBuffer());
        } else {
          e.push("");
        }
        this.lastContext = 0;
        this.source = e;
      },
      createFunctionContext: function (e) {
        var t = this.stackVars.concat(this.registers.list);
        if (t.length > 0) {
          this.source[1] = this.source[1] + ", " + t.join(", ");
        }
        if (!this.isChild) {
          for (var n in this.context.aliases) {
            if (this.context.aliases.hasOwnProperty(n)) {
              this.source[1] = this.source[1] + ", " + n + "=" + this.context.aliases[n];
            }
          }
        }
        if (this.source[1]) {
          this.source[1] = "var " + this.source[1].substring(2) + ";";
        }
        if (!this.isChild) {
          this.source[1] += "\n" + this.context.programs.join("\n") + "\n";
        }
        if (!this.environment.isSimple) {
          this.pushSource("return buffer;");
        }
        var r = this.isChild
          ? ["depth0", "data"]
          : ["Handlebars", "depth0", "helpers", "partials", "data"];
        for (var i = 0, o = this.environment.depths.list.length; i < o; i++) {
          r.push("depth" + this.environment.depths.list[i]);
        }
        var u = this.mergeSource();
        if (!this.isChild) {
          u = this.compilerInfo() + u;
        }
        if (e) {
          r.push(u);
          return Function.apply(this, r);
        } else {
          var a = "function " + (this.name || "") + "(" + r.join(",") + ") {\n  " + u + "}";
          s("debug", a + "\n\n");
          return a;
        }
      },
      mergeSource: function () {
        var e = "",
          t;
        for (var n = 0, r = this.source.length; n < r; n++) {
          var i = this.source[n];
          if (i.appendToBuffer) {
            if (t) {
              t = t + "\n    + " + i.content;
            } else {
              t = i.content;
            }
          } else {
            if (t) {
              e += "buffer += " + t + ";\n  ";
              t = undefined;
            }
            e += i + "\n  ";
          }
        }
        return e;
      },
      blockValue: function () {
        this.context.aliases.blockHelperMissing = "helpers.blockHelperMissing";
        var e = ["depth0"];
        this.setupParams(0, e);
        this.replaceStack(function (t) {
          e.splice(1, 0, t);
          return "blockHelperMissing.call(" + e.join(", ") + ")";
        });
      },
      ambiguousBlockValue: function () {
        this.context.aliases.blockHelperMissing = "helpers.blockHelperMissing";
        var e = ["depth0"];
        this.setupParams(0, e);
        var t = this.topStack();
        e.splice(1, 0, t);
        this.pushSource(
          "if (!" +
            this.lastHelper +
            ") { " +
            t +
            " = blockHelperMissing.call(" +
            e.join(", ") +
            "); }",
        );
      },
      appendContent: function (e) {
        if (this.pendingContent) {
          e = this.pendingContent + e;
        }
        if (this.stripNext) {
          e = e.replace(/^\s+/, "");
        }
        this.pendingContent = e;
      },
      strip: function () {
        if (this.pendingContent) {
          this.pendingContent = this.pendingContent.replace(/\s+$/, "");
        }
        this.stripNext = "strip";
      },
      append: function () {
        this.flushInline();
        var e = this.popStack();
        this.pushSource("if(" + e + " || " + e + " === 0) { " + this.appendToBuffer(e) + " }");
        if (this.environment.isSimple) {
          this.pushSource("else { " + this.appendToBuffer("''") + " }");
        }
      },
      appendEscaped: function () {
        this.context.aliases.escapeExpression = "this.escapeExpression";
        this.pushSource(this.appendToBuffer("escapeExpression(" + this.popStack() + ")"));
      },
      getContext: function (e) {
        if (this.lastContext !== e) {
          this.lastContext = e;
        }
      },
      lookupOnContext: function (e) {
        this.push(this.nameLookup("depth" + this.lastContext, e, "context"));
      },
      pushContext: function () {
        this.pushStackLiteral("depth" + this.lastContext);
      },
      resolvePossibleLambda: function () {
        this.context.aliases.functionType = '"function"';
        this.replaceStack(function (e) {
          return "typeof " + e + " === functionType ? " + e + ".apply(depth0) : " + e;
        });
      },
      lookup: function (e) {
        this.replaceStack(function (t) {
          return (
            t + " == null || " + t + " === false ? " + t + " : " + this.nameLookup(t, e, "context")
          );
        });
      },
      lookupData: function () {
        this.pushStackLiteral("data");
      },
      pushStringParam: function (e, t) {
        this.pushStackLiteral("depth" + this.lastContext);
        this.pushString(t);
        if (t !== "sexpr") {
          if (typeof e === "string") {
            this.pushString(e);
          } else {
            this.pushStackLiteral(e);
          }
        }
      },
      emptyHash: function () {
        this.pushStackLiteral("{}");
        if (this.options.stringParams) {
          this.push("{}");
          this.push("{}");
        }
      },
      pushHash: function () {
        if (this.hash) {
          this.hashes.push(this.hash);
        }
        this.hash = { values: [], types: [], contexts: [] };
      },
      popHash: function () {
        var e = this.hash;
        this.hash = this.hashes.pop();
        if (this.options.stringParams) {
          this.push("{" + e.contexts.join(",") + "}");
          this.push("{" + e.types.join(",") + "}");
        }
        this.push("{\n    " + e.values.join(",\n    ") + "\n  }");
      },
      pushString: function (e) {
        this.pushStackLiteral(this.quotedString(e));
      },
      push: function (e) {
        this.inlineStack.push(e);
        return e;
      },
      pushLiteral: function (e) {
        this.pushStackLiteral(e);
      },
      pushProgram: function (e) {
        if (e != null) {
          this.pushStackLiteral(this.programExpression(e));
        } else {
          this.pushStackLiteral(null);
        }
      },
      invokeHelper: function (e, t, n) {
        this.context.aliases.helperMissing = "helpers.helperMissing";
        this.useRegister("helper");
        var r = (this.lastHelper = this.setupHelper(e, t, true));
        var i = this.nameLookup("depth" + this.lastContext, t, "context");
        var s = "helper = " + r.name + " || " + i;
        if (r.paramsInit) {
          s += "," + r.paramsInit;
        }
        this.push(
          "(" +
            s +
            ",helper " +
            "? helper.call(" +
            r.callParams +
            ") " +
            ": helperMissing.call(" +
            r.helperMissingParams +
            "))",
        );
        if (!n) {
          this.flushInline();
        }
      },
      invokeKnownHelper: function (e, t) {
        var n = this.setupHelper(e, t);
        this.push(n.name + ".call(" + n.callParams + ")");
      },
      invokeAmbiguous: function (e, t) {
        this.context.aliases.functionType = '"function"';
        this.useRegister("helper");
        this.emptyHash();
        var n = this.setupHelper(0, e, t);
        var r = (this.lastHelper = this.nameLookup("helpers", e, "helper"));
        var i = this.nameLookup("depth" + this.lastContext, e, "context");
        var s = this.nextStack();
        if (n.paramsInit) {
          this.pushSource(n.paramsInit);
        }
        this.pushSource(
          "if (helper = " + r + ") { " + s + " = helper.call(" + n.callParams + "); }",
        );
        this.pushSource(
          "else { helper = " +
            i +
            "; " +
            s +
            " = typeof helper === functionType ? helper.call(" +
            n.callParams +
            ") : helper; }",
        );
      },
      invokePartial: function (e) {
        var t = [
          this.nameLookup("partials", e, "partial"),
          "'" + e + "'",
          this.popStack(),
          "helpers",
          "partials",
        ];
        if (this.options.data) {
          t.push("data");
        }
        this.context.aliases.self = "this";
        this.push("self.invokePartial(" + t.join(", ") + ")");
      },
      assignToHash: function (e) {
        var t = this.popStack(),
          n,
          r;
        if (this.options.stringParams) {
          r = this.popStack();
          n = this.popStack();
        }
        var i = this.hash;
        if (n) {
          i.contexts.push("'" + e + "': " + n);
        }
        if (r) {
          i.types.push("'" + e + "': " + r);
        }
        i.values.push("'" + e + "': (" + t + ")");
      },
      compiler: a,
      compileChildren: function (e, t) {
        var n = e.children,
          r,
          i;
        for (var s = 0, o = n.length; s < o; s++) {
          r = n[s];
          i = new this.compiler();
          var u = this.matchExistingProgram(r);
          if (u == null) {
            this.context.programs.push("");
            u = this.context.programs.length;
            r.index = u;
            r.name = "program" + u;
            this.context.programs[u] = i.compile(r, t, this.context);
            this.context.environments[u] = r;
          } else {
            r.index = u;
            r.name = "program" + u;
          }
        }
      },
      matchExistingProgram: function (e) {
        for (var t = 0, n = this.context.environments.length; t < n; t++) {
          var r = this.context.environments[t];
          if (r && r.equals(e)) {
            return t;
          }
        }
      },
      programExpression: function (e) {
        this.context.aliases.self = "this";
        if (e == null) {
          return "self.noop";
        }
        var t = this.environment.children[e],
          n = t.depths.list,
          r;
        var i = [t.index, t.name, "data"];
        for (var s = 0, o = n.length; s < o; s++) {
          r = n[s];
          if (r === 1) {
            i.push("depth0");
          } else {
            i.push("depth" + (r - 1));
          }
        }
        return (n.length === 0 ? "self.program(" : "self.programWithDepth(") + i.join(", ") + ")";
      },
      register: function (e, t) {
        this.useRegister(e);
        this.pushSource(e + " = " + t + ";");
      },
      useRegister: function (e) {
        if (!this.registers[e]) {
          this.registers[e] = true;
          this.registers.list.push(e);
        }
      },
      pushStackLiteral: function (e) {
        return this.push(new u(e));
      },
      pushSource: function (e) {
        if (this.pendingContent) {
          this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)));
          this.pendingContent = undefined;
        }
        if (e) {
          this.source.push(e);
        }
      },
      pushStack: function (e) {
        this.flushInline();
        var t = this.incrStack();
        if (e) {
          this.pushSource(t + " = " + e + ";");
        }
        this.compileStack.push(t);
        return t;
      },
      replaceStack: function (e) {
        var t = "",
          n = this.isInline(),
          r,
          i,
          s;
        if (n) {
          var o = this.popStack(true);
          if (o instanceof u) {
            r = o.value;
            s = true;
          } else {
            i = !this.stackSlot;
            var a = !i ? this.topStackName() : this.incrStack();
            t = "(" + this.push(a) + " = " + o + "),";
            r = this.topStack();
          }
        } else {
          r = this.topStack();
        }
        var f = e.call(this, r);
        if (n) {
          if (!s) {
            this.popStack();
          }
          if (i) {
            this.stackSlot--;
          }
          this.push("(" + t + f + ")");
        } else {
          if (!/^stack/.test(r)) {
            r = this.nextStack();
          }
          this.pushSource(r + " = (" + t + f + ");");
        }
        return r;
      },
      nextStack: function () {
        return this.pushStack();
      },
      incrStack: function () {
        this.stackSlot++;
        if (this.stackSlot > this.stackVars.length) {
          this.stackVars.push("stack" + this.stackSlot);
        }
        return this.topStackName();
      },
      topStackName: function () {
        return "stack" + this.stackSlot;
      },
      flushInline: function () {
        var e = this.inlineStack;
        if (e.length) {
          this.inlineStack = [];
          for (var t = 0, n = e.length; t < n; t++) {
            var r = e[t];
            if (r instanceof u) {
              this.compileStack.push(r);
            } else {
              this.pushStack(r);
            }
          }
        }
      },
      isInline: function () {
        return this.inlineStack.length;
      },
      popStack: function (e) {
        var t = this.isInline(),
          n = (t ? this.inlineStack : this.compileStack).pop();
        if (!e && n instanceof u) {
          return n.value;
        } else {
          if (!t) {
            if (!this.stackSlot) {
              throw new o("Invalid stack pop");
            }
            this.stackSlot--;
          }
          return n;
        }
      },
      topStack: function (e) {
        var t = this.isInline() ? this.inlineStack : this.compileStack,
          n = t[t.length - 1];
        if (!e && n instanceof u) {
          return n.value;
        } else {
          return n;
        }
      },
      quotedString: function (e) {
        return (
          '"' +
          e
            .replace(/\\/g, "\\\\")
            .replace(/"/g, '\\"')
            .replace(/\n/g, "\\n")
            .replace(/\r/g, "\\r")
            .replace(/\u2028/g, "\\u2028")
            .replace(/\u2029/g, "\\u2029") +
          '"'
        );
      },
      setupHelper: function (e, t, n) {
        var r = [],
          i = this.setupParams(e, r, n);
        var s = this.nameLookup("helpers", t, "helper");
        return {
          params: r,
          paramsInit: i,
          name: s,
          callParams: ["depth0"].concat(r).join(", "),
          helperMissingParams: n && ["depth0", this.quotedString(t)].concat(r).join(", "),
        };
      },
      setupOptions: function (e, t) {
        var n = [],
          r = [],
          i = [],
          s,
          o,
          u;
        n.push("hash:" + this.popStack());
        if (this.options.stringParams) {
          n.push("hashTypes:" + this.popStack());
          n.push("hashContexts:" + this.popStack());
        }
        o = this.popStack();
        u = this.popStack();
        if (u || o) {
          if (!u) {
            this.context.aliases.self = "this";
            u = "self.noop";
          }
          if (!o) {
            this.context.aliases.self = "this";
            o = "self.noop";
          }
          n.push("inverse:" + o);
          n.push("fn:" + u);
        }
        for (var a = 0; a < e; a++) {
          s = this.popStack();
          t.push(s);
          if (this.options.stringParams) {
            i.push(this.popStack());
            r.push(this.popStack());
          }
        }
        if (this.options.stringParams) {
          n.push("contexts:[" + r.join(",") + "]");
          n.push("types:[" + i.join(",") + "]");
        }
        if (this.options.data) {
          n.push("data:data");
        }
        return n;
      },
      setupParams: function (e, t, n) {
        var r = "{" + this.setupOptions(e, t).join(",") + "}";
        if (n) {
          this.useRegister("options");
          t.push("options");
          return "options=" + r;
        } else {
          t.push(r);
          return "";
        }
      },
    };
    var f = (
      "break else new var" +
      " case finally return void" +
      " catch for switch while" +
      " continue function this with" +
      " default if throw" +
      " delete in try" +
      " do instanceof typeof" +
      " abstract enum int short" +
      " boolean export interface static" +
      " byte extends long super" +
      " char final native synchronized" +
      " class float package throws" +
      " const goto private transient" +
      " debugger implements protected volatile" +
      " double import public let yield"
    ).split(" ");
    var l = (a.RESERVED_WORDS = {});
    for (var c = 0, h = f.length; c < h; c++) {
      l[f[c]] = true;
    }
    a.isValidJavaScriptVariableName = function (e) {
      if (!a.RESERVED_WORDS[e] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e)) {
        return true;
      }
      return false;
    };
    n = a;
    return n;
  })(r, n);
  var c = (function (e, t, n, r, i) {
    "use strict";
    var s;
    var o = e;
    var u = t;
    var a = n.parser;
    var f = n.parse;
    var l = r.Compiler;
    var c = r.compile;
    var h = r.precompile;
    var p = i;
    var d = o.create;
    var v = function () {
      var e = d();
      e.compile = function (t, n) {
        return c(t, n, e);
      };
      e.precompile = function (t, n) {
        return h(t, n, e);
      };
      e.AST = u;
      e.Compiler = l;
      e.JavaScriptCompiler = p;
      e.Parser = a;
      e.parse = f;
      return e;
    };
    o = v();
    o.create = v;
    s = o;
    return s;
  })(s, o, a, f, l);
  return c;
})();
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function () {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: "POST",
    url: "/cart/update.js",
    data: "note=" + attributeToString(note),
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (data.message) {
    alert(data.message + "(" + data.status + "): " + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var formData = new FormData(form);
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: formData,
    processData: false,
    contentType: false,
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === "function") {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    },
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON("/cart.js", function (cart) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
  "use strict";

  // Public functions
  var init, loadCart, addItemToCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  // Private functions
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    qtySelectors,
    validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector: "[data-product-form]",
      cartContainer: "#CartContainer",
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: "${{amount}}",
      disableAjaxCart: false,
      enableQtySelectors: true,
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $("body");

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass("drawer--is-loading");
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass("hidden-count");

      if (cart.item_count === 0) {
        $cartCountSelector.addClass("hidden-count");
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(theme.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on("submit", function (evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass("is-added").addClass("is-adding");

      // Remove any previous quantity errors
      $(".qty-error").remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function () {
    $addToCart.removeClass("is-adding").addClass("is-added");

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    $addToCart.removeClass("is-adding is-added");

    if (data.message) {
      if (data.status === 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + "</div>");
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = async function (cart) {
    const newTemplate = await fetch("/?section_id=ajax-cart-template");
    const templateData = await newTemplate.text();
    const templateHTML = new DOMParser()
      .parseFromString(templateData, "text/html")
      .querySelector("#CartTemplate").innerHTML;
    const currentTemplate = document.querySelector("#CartTemplate");
    currentTemplate.innerHTML = templateHTML;

    // Start with a fresh cart div
    $cartContainer.empty();

    // Update Cart Count Here
    if (document.querySelector(".drawer__count")) {
      document.querySelector(".drawer__count").innerText = `(${cart.item_count})`;
    }

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.append(
        '<p class="cart--empty-message">' +
          theme.strings.cartEmpty +
          "</p>\n" +
          '<p class="cookie-message">' +
          theme.strings.cartCookies +
          "</p>",
      );
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      var prodImg;
      var unitPrice = null;
      if (cartItem.image !== null) {
        prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace("http:", "");
      } else {
        prodImg =
          "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key.charAt(0) === "_" || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key.charAt(0) === "_" || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount = cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[discount].formattedAmount =
            theme.Currency.formatMoney(amount, settings.moneyFormat);
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount =
            cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;

          cart.cart_level_discount_applications[cartDiscount].formattedAmount =
            theme.Currency.formatMoney(cartAmount, settings.moneyFormat);
        }
      }

      if (cartItem.unit_price_measurement) {
        unitPrice = {
          addRefererenceValue: cartItem.unit_price_measurement.reference_value !== 1,
          price: theme.Currency.formatMoney(cartItem.unit_price, settings.moneyFormat),
          reference_value: cartItem.unit_price_measurement.reference_value,
          reference_unit: cartItem.unit_price_measurement.reference_unit,
        };
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        sellingPlanAllocation: cartItem.selling_plan_allocation,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discountedPrice: theme.Currency.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat,
        ),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied: cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor,
        unitPrice: unitPrice,
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: theme.Currency.formatMoney(cart.total_price, settings.moneyFormat),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
    };

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function (cart) {
    $body.removeClass("drawer--is-loading");
    $body.trigger("ajaxCart.afterCartLoad", cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on("click", ".ajaxcart__qty-adjust", function () {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data("line"),
        $qtySelector = $el.siblings(".ajaxcart__qty-num"),
        qty = parseInt($qtySelector.val().replace(/\D/g, ""));

      qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on("click", ".ajax__cart-remove", function () {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data("line"),
        qty = 0;
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Update quantity based on input on change
    $body.on("change", ".ajaxcart__qty-num", function () {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));

      qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on("submit", "form.ajaxcart", function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on("focus", ".ajaxcart__qty-adjust", function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass("is-loading");

      if (qty === 0) {
        $row.parent().addClass("is-removed");
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on("change", 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function () {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
      isUpdating = false;
    }, 150);
  };

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var $numInputs = $('input[type="number"]:not([name^="filter.v.price"]');

    if ($numInputs.length) {
      $numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr("name"),
          inputId = $el.attr("id");

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $(".js-qty__adjust").on("click", function () {
        var $el = $(this),
          $qtySelector = $el.siblings(".js-qty__num"),
          qty = parseInt($qtySelector.val().replace(/\D/g, ""));

        qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass("js-qty__adjust--plus")) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  addItemToCart = async function (e) {
    e.preventDefault();
    const container = e.target.closest(".ajaxcart__complementary-container");
    const id = e.target.closest("button").dataset.id;
    const item = {
      id: parseInt(id),
      quantity: 1,
    };

    const formData = new FormData();
    for (const key in item) {
      formData.append(key, item[key]);
    }

    try {
      const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHTTPRequest",
        },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.message);
      }
      ajaxCart.load();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  module = {
    init: init,
    load: loadCart,
    add: addItemToCart,
  };

  return module;
})(ajaxCart || {}, jQuery);

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
window.timber = window.timber || {};
window.theme = window.theme || {};

timber.initCache = function () {
  timber.cache = {
    // General
    $html: $("html"),
    $body: $("body"),
    $window: $(window),

    // Navigation
    $navigation: $("#AccessibleNav"),

    // Product Page
    $optionSelector: $(".single-option-selector"),

    // Customer Pages
    $recoverPasswordLink: $("#RecoverPassword"),
    $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
    $recoverPasswordForm: $("#RecoverPasswordForm"),
    $customerLoginForm: $("#CustomerLoginForm"),
    $passwordResetSuccess: $("#ResetSuccess"),
  };
};

timber.init = function () {
  timber.initCache();
  timber.accessibleNav();
  timber.drawersInit();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var classes = {
    active: "nav-hover",
    focus: "nav-focus",
    outside: "nav-outside",
    hasDropdown: "site-nav--has-dropdown",
    link: "site-nav__link",
  };
  var selectors = {
    active: "." + classes.active,
    hasDropdown: "." + classes.hasDropdown,
    dropdown: "[data-meganav-dropdown]",
    link: "a",
    nextLink: "> a",
    parentLink: '[data-meganav-type="parent"]',
    childLink: '[data-meganav-type="child"]',
  };

  var $nav = timber.cache.$navigation,
    $allLinks = $nav.find(selectors.link),
    $parents = $nav.find(selectors.hasDropdown),
    $childLinks = $nav.find(selectors.childLink),
    $topLevel = $parents.find(selectors.nextLink),
    $dropdowns = $nav.find(selectors.dropdown),
    $subMenuLinks = $dropdowns.find(selectors.link);

  // Mouseenter
  $parents.on("mouseenter touchstart", function (evt) {
    var $el = $(this);
    var evtType = evt.type;
    var $dropdowns = $nav.find(selectors.active);

    if (!$el.hasClass(classes.active)) {
      // force stop the click from happening
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }

    // Make sure we close any opened same level dropdown before opening a new one
    if (evtType === "touchstart" && $dropdowns.length > 0) {
      hideDropdown($el);
    }

    showDropdown($el);
  });

  $childLinks.on("touchstart", function (evt) {
    evt.stopImmediatePropagation();
  });

  $parents.on("mouseleave", function () {
    hideDropdown($(this));
  });

  $allLinks.on("focus", function () {
    handleFocus($(this));
  });

  $allLinks.on("blur", function () {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus($el) {
    var $newFocus = null,
      $previousItem = $el.parent().prev();

    // Always put tabindex -1 on previous element just in case the user is going backward.
    // In that case, we want to focus on the previous parent and not the previous parent childs

    $allLinks.attr("tabindex", "");

    if ($previousItem.hasClass(classes.hasDropdown)) {
      $previousItem.find(selectors.dropdown + " a").attr("tabindex", -1);
    }

    $newFocus = $el.parents(selectors.hasDropdown).find("> a");
    addFocus($newFocus);
  }

  function showDropdown($el) {
    var $toplevel = $el.find(selectors.nextLink);

    $toplevel.attr("aria-expanded", true);

    $el.addClass(classes.active);

    setTimeout(function () {
      timber.cache.$body.on("touchstart.MegaNav", function () {
        hideDropdowns();
      });
    }, 250);
  }

  function hideDropdown($el) {
    var $dropdowns = $el.parent().find(selectors.active);
    var $parentLink = $dropdowns.find(selectors.nextLink);

    $parentLink.attr("aria-expanded", false);

    $dropdowns.removeClass(classes.active);

    timber.cache.$body.off("touchstart.MegaNav");
  }

  function hideDropdowns() {
    var $dropdowns = $nav.find(selectors.active);
    $.each($dropdowns, function () {
      hideDropdown($(this));
    });
  }

  function addFocus($el) {
    $el.addClass(classes.focus);

    if ($el.attr("aria-expanded") !== undefined) {
      $el.attr("aria-expanded", true);
    }
  }

  function removeFocus($el) {
    $el.removeClass(classes.focus);

    $subMenuLinks.attr("tabindex", -1);

    if ($el.attr("aria-expanded") !== undefined) {
      $el.attr("aria-expanded", false);
    }
  }

  // Check if dropdown is outside of viewport
  function handleDropdownOffset($dropdowns) {
    var viewportSize = $(window).width();
    $dropdowns.removeClass(classes.outside);

    $.each($dropdowns, function () {
      var $dropdown = $(this);
      var dropdownOffset = $dropdown.offset().left + $dropdown.width();
      if (dropdownOffset > viewportSize) {
        $dropdown.addClass(classes.outside);
      }
    });
  }

  timber.cache.$window.load(function () {
    handleDropdownOffset($dropdowns);
  });

  timber.cache.$window.resize(function () {
    afterResize(function () {
      handleDropdownOffset($dropdowns);
    }, 250);
  });
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers("NavDrawer", "left");
  if (theme.settings.cartType === "drawer") {
    timber.RightDrawer = new timber.Drawers("CartDrawer", "right", {
      onDrawerOpen: ajaxCart.load,
    });
  }
};

timber.getHash = function () {
  return window.location.hash;
};

timber.loginForms = function () {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on("click", function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on("click", function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() === "#recover") {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function () {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: ".js-drawer-close",
      open: ".js-drawer-open-button-" + position,
      openButtonLeftClass: "js-drawer-open-button-left",
      drawerLeftClass: "drawer--left",
      drawerRightClass: "drawer--right",
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position,
    };

    this.nodes = {
      $parent: $("body, html"),
      $page: $("#PageContainer"),
      $moved: $(".page-container"),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr("aria-expanded", "false");

    $openBtn.on("click", $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Other drawers that might be open (will be closed later)
    var $otherDrawers = $(".drawer").not(this.$drawer);

    // don't open an opened drawer
    if (this.drawerIsOpen) {
      if (evt) {
        evt.preventDefault();
      }
      return;
    }

    // Close other drawers if they are open
    var self = this;
    $otherDrawers.each(function () {
      if (!$(this).hasClass(self.config.openClass)) {
        return;
      }

      if ($(this).hasClass(self.config.drawerLeftClass)) {
        timber.LeftDrawer.close();
      }

      if ($(this).hasClass(self.config.drawerRightClass)) {
        timber.RightDrawer.close();
      }
    });

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.nodes.$moved.addClass("is-transitioning");
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass);
    this.$drawer.addClass(this.config.openClass);

    this.drawerIsOpen = true;

    // Set focus on drawer
    Drawer.prototype.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    // Run function when drawer opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === "function") {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();
  };

  Drawer.prototype.close = function (evt) {
    // don't close a closed drawer
    if (!this.drawerIsOpen) {
      return;
    }

    if (evt?.keyCode !== 27) {
      evt.preventDefault();
    }
    // deselect any focused form elements
    $(document.activeElement).trigger("blur");

    // Ensure closing transition is applied to moved elements, like the nav
    this.nodes.$moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass);
    this.$drawer.removeClass(this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    Drawer.prototype.removeTrapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus",
    });

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "false");
    }

    this.unbindEvents();
  };

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.trapFocus = function (options) {
    var eventName = options.namespace ? "focusin." + options.namespace : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
      options.$container.attr("tabindex", "-1");
    }

    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function (options) {
    var eventName = options.namespace ? "focusin." + options.namespace : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  };

  Drawer.prototype.bindEvents = function () {
    // Lock scrolling on mobile
    this.nodes.$page.on("touchmove.drawer", function () {
      return false;
    });

    this.$drawer.on("click.drawer", function (event) {
      if ($(this).hasClass("drawer--left")) {
        event.stopPropagation();
      }
    });

    $(".page-container, .drawer__header-container").on("click.drawer", this.close.bind(this));

    // Pressing escape closes drawer
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function (evt) {
        // The hamburger 'open' button changes to a 'close' button when the drawer
        // is open. Clicking on it will close the drawer.
        if (this.$activeSource !== undefined) {
          this.$activeSource.on(
            "click.drawer",
            $.proxy(function () {
              if (!this.$activeSource.hasClass(this.config.openButtonLeftClass)) {
                return;
              }
              this.close();
            }, this),
          );
        }
        if (evt.keyCode === 27) {
          this.close(evt);
        }
      }, this),
    );
  };

  Drawer.prototype.unbindEvents = function () {
    if (this.$activeSource !== undefined) {
      this.$activeSource.off(".drawer");
    }
    this.nodes.$page.off(".drawer");
    this.nodes.$parent.off(".drawer");
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);

theme.Disclosure = (function () {
  var selectors = {
    disclosureList: "[data-disclosure-list]",
    disclosureToggle: "[data-disclosure-toggle]",
    disclosureInput: "[data-disclosure-input]",
    disclosureOptions: "[data-disclosure-option]",
  };

  var classes = {
    listVisible: "disclosure-list--visible",
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};
    this._cacheSelectors();
    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }

  Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
    _cacheSelectors: function () {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions),
      };
    },

    _connectToggle: function () {
      this.cache.$disclosureToggle.on(
        "click",
        function (evt) {
          var ariaExpanded = $(evt.currentTarget).attr("aria-expanded") === "true";
          $(evt.currentTarget).attr("aria-expanded", !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this),
      );
    },

    _connectOptions: function () {
      this.cache.$disclosureOptions.on(
        "click",
        function (evt) {
          evt.preventDefault();
          this._submitForm($(evt.currentTarget).data("value"));
        }.bind(this),
      );
    },

    _onFocusOut: function () {
      this.cache.$disclosureToggle.on(
        "focusout",
        function (evt) {
          var disclosureLostFocus = this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this._hideList();
          }
        }.bind(this),
      );

      this.cache.$disclosureList.on(
        "focusout",
        function (evt) {
          var childInFocus = $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(classes.listVisible);

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        }.bind(this),
      );

      this.$container.on(
        "keyup",
        function (evt) {
          if (evt.which !== slate.utils.keyboardKeys.ESCAPE) return;
          this._hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this),
      );

      $("body").on(
        "click",
        function (evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(classes.listVisible);

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this),
      );
    },

    _submitForm: function (value) {
      this.cache.$disclosureInput.val(value);
      this.$container.parents("form").submit();
    },

    _hideList: function () {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureToggle.attr("aria-expanded", false);
    },

    unload: function () {
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    },
  });

  return Disclosure;
})();

/* ================ Sections ================ */
window.theme = window.theme || {};

theme.FeaturedContentSection = (function () {
  function FeaturedContent() {
    theme.styleTextLinks();
  }

  return FeaturedContent;
})();

window.theme = window.theme || {};

theme.NewsletterSection = (function () {
  function Newsletter() {
    theme.styleTextLinks();
  }

  return Newsletter;
})();

window.theme = window.theme || {};

theme.PasswordHeader = (function () {
  function PasswordHeader() {
    this.init();
  }

  PasswordHeader.prototype = _.assignIn({}, PasswordHeader.prototype, {
    init: function () {
      $(".js-toggle-login-modal").magnificPopup({
        type: "inline",
        mainClass: "mfp-fade",
        closeOnBgClick: false,
        closeBtnInside: false,
        closeOnContentClick: false,
        tClose: password.strings.pageClose,
        removalDelay: 500,
        callbacks: {
          open: function () {
            window.setTimeout(function () {
              document.getElementById("password").focus();
            }, 50);
          },
          close: function () {
            window.setTimeout(function () {
              document.getElementById("email").focus();
            }, 50);
          },
        },
      });
      if ($(".storefront-password-form .errors").size()) {
        $(".js-toggle-login-modal").click();
      }
    },
  });

  return PasswordHeader;
})();

window.theme = window.theme || {};

theme.PasswordContent = (function () {
  function PasswordContent() {
    theme.styleTextLinks();
  }

  return PasswordContent;
})();

var selectors = {
  disclosureLocale: "[data-disclosure-locale]",
  disclosureCurrency: "[data-disclosure-currency]",
};

theme.FooterSection = (function () {
  function Footer(container) {
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new theme.Disclosure(this.cache.$localeDisclosure);
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new theme.Disclosure(this.cache.$currencyDisclosure);
    }
  }

  Footer.prototype = _.assignIn({}, Footer.prototype, {
    cacheSelectors: function () {
      this.cache = {
        $localeDisclosure: this.$container.find(selectors.disclosureLocale),
        $currencyDisclosure: this.$container.find(selectors.disclosureCurrency),
      };
    },

    onUnload: function () {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    },
  });

  return Footer;
})();

theme.variables = {
  productPageLoad: false,
  productPageSticky: true,

  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  mediaQuerySmall: "screen and (max-width: 590px)",
  mediaQueryMedium: "screen and (min-width: 591px) and (max-width: 768px)",
  mediaQueryMediumUp: "screen and (min-width: 591px)",
  mediaQueryLarge: "screen and (min-width: 769px)",
  bpSmall: false,
};

theme.initCache = function () {
  theme.cache = {
    $window: $(window),
    $html: $("html"),
    $body: $("body"),
    $drawerRight: $(".drawer--right"),

    $hero: $("#Hero"),
    $customSelect: $(".js-selector"),

    $collectionImage: $(".collection-hero__image"),

    $siteHeader: $(".site-header"),
    $siteNav: $(".site-nav"),
    $siteNavOpen: $(".site-nav--open"),
    $cartBuggle: $(".mphus-cart__bubble"),
    $logoWrapper: $(".site-header__logo"),
    $logo: $(".site-header__logo img"),
    $toggleSearchModal: $(".js-toggle-search-modal"),
    $searchBox: $(".site-nav--search__bar"),

    $indentedRteImages: $(".rte--indented-images"),

    $productGridRows: $(".collage-grid__row"),
    $productGridPhotosLarge: $(".grid__item--large .grid-product__image-link"),

    // Equal height elements
    $productGridImages: $(".grid-uniform .grid-product__image-wrapper"),

    $returnLink: $(".return-link"),
  };
};

theme.init = function () {
  theme.initCache();
  theme.setBreakpoints();
  theme.fitNav();
  theme.cartInit();
  theme.afterCartLoad();
  theme.checkoutIndicator();
  theme.returnLink();
  theme.styleTextLinks();
  theme.searchModal();
  theme.productCardImageLoadingAnimation();

  // Functions to run on load so image sizes can be calculated
  theme.cache.$window.on("load", theme.resizeLogo);
  theme.cache.$window.on("load", theme.articleImages);

  // Functions to re-run on resize
  theme.cache.$window.on("resize", theme.debounce(theme.resizeLogo, 150));
};

theme.returnLink = function () {
  if (!document.referrer || !theme.cache.$returnLink.length || !window.history.length) {
    return;
  }

  theme.cache.$returnLink.on("click", theme.backButton);
};

theme.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var a = document.createElement("a");
    a.href = url;
    return a.hostname;
  }
};

theme.setBreakpoints = function () {
  enquire.register(theme.variables.mediaQuerySmall, {
    match: function () {
      if (theme.settings.gridType === "collage") {
        theme.clearCollageGridHeights();
      }

      theme.variables.bpSmall = true;
    },
    unmatch: function () {
      theme.variables.bpSmall = false;
    },
  });
};

theme.fitNav = function () {
  // Measure children of site nav on load and resize.
  // If wider than parent, switch to mobile nav.
  controlNav();
  theme.cache.$window.on("load", controlNav);
  theme.cache.$window.on("resize", theme.debounce(controlNav, 150));

  function controlNav() {
    // Subtract 20 from width to account for inline-block spacing
    var navWidth = theme.cache.$siteNav.parent().outerWidth() - 20;
    var navItemWidth = 0;
    theme.cache.$siteNav.find("> li").each(function () {
      var $el = $(this);
      // Round up to be safe
      navItemWidth += Math.ceil($(this).width());
    });

    if (navItemWidth > navWidth) {
      theme.cache.$siteNav.addClass("site-nav--compress");
      theme.cache.$siteNav.parent().removeClass("large--two-thirds").addClass("large--one-sixth");
      theme.cache.$siteNavOpen.addClass("site-nav--open__display");
      theme.cache.$siteNavOpen.parent().removeClass("large--hide");
      theme.cache.$logoWrapper
        .parent()
        .removeClass("large--one-third")
        .addClass("large--two-thirds");
      theme.cache.$logoWrapper.removeClass("large--left").addClass("text-center");
      theme.cache.$searchBox.hide();
    } else {
      theme.cache.$siteNav.removeClass("site-nav--compress");
      theme.cache.$siteNavOpen.removeClass("site-nav--open__display");
      theme.cache.$siteNavOpen.parent().addClass("large--hide");
      theme.cache.$searchBox.show();
    }

    theme.cache.$siteNav.addClass("site-nav--init");
    theme.cache.$siteNavOpen.addClass("site-nav--init");
  }
};

theme.resizeLogo = function () {
  // Using .each() as there can be a reversed logo too
  theme.cache.$logo.each(function () {
    var $el = $(this),
      logoWidthOnScreen = $el.width(),
      containerWidth = $el.closest(".grid__item").width();
    // If image exceeds container, let's make it smaller
    if (logoWidthOnScreen > containerWidth) {
      $el.css("maxWidth", containerWidth);
    } else {
      $el.removeAttr("style");
    }
  });
};

theme.afterCartLoad = function () {
  theme.cache.$body.on("ajaxCart.afterCartLoad", function (evt, cart) {
    // Open cart drawer
    timber.RightDrawer.open();

    /* Zapiet | Store Pickup + Delivery */
    if (window.Zapiet && window.ZapietCachedSettings) {
      Zapiet.start(ZapietCachedSettings);
    }
    /* Zapiet | Store Pickup + Delivery */

    theme.cache.$cartBuggle.text(cart.item_count);

    // Show cart bubble in nav if items exist
    if (cart.items.length > 0) {
      theme.cache.$cartBuggle.addClass("mphus-cart__bubble--visible");
    } else {
      theme.cache.$cartBuggle.removeClass("mphus-cart__bubble--visible");
    }
  });
};

theme.checkoutIndicator = function () {
  // Add a loading indicator on the cart checkout button (/cart and drawer)
  theme.cache.$body.on("click", ".cart__checkout", function () {
    $(this).addClass("btn--loading");
  });
};

theme.searchModal = function () {
  if (!theme.cache.$toggleSearchModal.length) {
    return;
  }

  theme.cache.$toggleSearchModal.magnificPopup({
    type: "inline",
    mainClass: "mfp-fade",
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: false,
    tClose: theme.strings.zoomClose,
    alignTop: true,
    removalDelay: 500,
    focus: ".search-bar > input",
  });
};

theme.clearCollageGridHeights = function () {
  if (!theme.cache.$productGridRows.length) {
    return;
  }

  theme.cache.$productGridPhotosLarge.removeAttr("style");
};

theme.articleImages = function () {
  if (!theme.cache.$indentedRteImages.length) {
    return;
  }

  theme.cache.$indentedRteImages.find("img").each(function () {
    var $el = $(this);
    var attr = $el.attr("style");

    // Check if undefined or float: none
    if (!attr || attr == "float: none;") {
      // Remove grid-breaking styles if image isn't wider than parent
      if ($el.width() < theme.cache.$indentedRteImages.width()) {
        $el.addClass("rte__no-indent");
      }
    }
  });
};

theme.styleTextLinks = function () {
  $(".rte").find("a:not(:has(img))").addClass("text-link");
};

theme.equalHeights = function () {
  var self = this;
  theme.cache.$window.on("load", resizeElements());

  theme.cache.$window.on(
    "resize",
    afterResize(
      function () {
        resizeElements();
      },
      250,
      "equal-heights",
    ),
  );

  function resizeElements() {
    self.cache.$productGridImages.css("height", "auto").equalHeights();
  }
};

theme.cartInit = function () {
  if (!theme.cookiesEnabled()) {
    theme.cache.$body.addClass("cart--no-cookies");
  }
};

theme.cookiesEnabled = function () {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled) {
    document.cookie = "testcookie";
    cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
  }
  return cookieEnabled;
};

theme.productCardImageLoadingAnimation = function () {
  var selectors = {
    image: "[data-image]",
    imageLink: "[data-image-link]",
  };

  var classes = {
    loadingAnimation: "grid-product__image-link--loading",
  };
};

$(document).ready(function () {
  theme.init();
  var sections = new theme.Sections();
  sections.register("featured-content-section", theme.FeaturedContentSection);
  sections.register("newsletter-section", theme.NewsletterSection);
  sections.register("password-header", theme.PasswordHeader);
  sections.register("password-content", theme.PasswordContent);
  sections.register("footer-section", theme.FooterSection);
});

/*
 * Run function after window resize
 * http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed
 */
var afterResize = (function () {
  var t = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (t[uniqueId]) {
      clearTimeout(t[uniqueId]);
    }
    t[uniqueId] = setTimeout(callback, ms);
  };
})();

class SiteHeader extends HTMLElement {
  constructor() {
    super();

    this.section_wrapper = this.closest("header");
    this.outer_wrapper = this.closest(".site-header__outer");
    this.padding =
      parseInt(window.getComputedStyle(this).getPropertyValue("padding-left").replace("px", "")) *
      2;

    this.nav_track = this.querySelector(".main-navigation__inner");
    this.nav_items = this.querySelectorAll(".main-navigation__parent-item");

    this.min_track_width = 0;
    this.nav_items.forEach((item) => {
      const width = item.getBoundingClientRect().width;
      this.min_track_width = this.min_track_width + width;
    });
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    window.addEventListener("scroll", this.stickyNavigation.bind(this));
    window.addEventListener("resize", this.collapseNavigation.bind(this));
    window.addEventListener("DOMContentLoaded", this.collapseNavigation.bind(this));
  }

  stickyNavigation() {
    const wrapper = this.section_wrapper.getBoundingClientRect();
    if (window.scrollY > wrapper.top) {
      this.outer_wrapper.classList.add("site-header__sticky");
    } else {
      this.outer_wrapper.classList.remove("site-header__sticky");
    }
  }

  collapseNavigation() {
    if (window.innerWidth - this.padding < this.min_track_width) {
      this.outer_wrapper.classList.add("site-header__collapse");
    } else {
      this.outer_wrapper.classList.remove("site-header__collapse");
    }
  }
}

customElements.define("site-header", SiteHeader);

class DropdownMenu extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.is_touch = true;
    }
  }

  connectedCallback() {
    this.toggle_button = this.querySelector("[aria-expanded]");
    this.addEventListeners();
  }

  addEventListeners() {
    if (this.is_touch) {
      this.addEventListener("click", this.clickHandler.bind(this));
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    } else {
      this.addEventListener("mouseenter", this.mouseHandler.bind(this));
      this.addEventListener("mouseleave", this.mouseHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest('[dropdown-action="toggle"]')) {
      this.toggleMenu();
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("dropdown-menu") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
      }
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseenter") {
      this.setVisible();
    } else if (e.type === "mouseleave") {
      this.toggle_button.blur();
      this.setHidden();
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      this.toggleMenu();
    }
    if (e.key === "Escape") {
      this.setHidden();
    }
  }

  toggleMenu() {
    if (this.getAttribute("dropdown-view") === "hidden") {
      this.setVisible();
    } else if (this.getAttribute("dropdown-view") === "visible") {
      this.setHidden();
    }
  }

  setHidden() {
    this.is_open = false;
    this.setAttribute("dropdown-view", "hidden");
    this.toggle_button.setAttribute("aria-expanded", "false");
  }

  setVisible() {
    this.is_open = true;
    this.setAttribute("dropdown-view", "visible");
    this.toggle_button.setAttribute("aria-expanded", "true");
  }
}

customElements.define("dropdown-menu", DropdownMenu);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.toggle_button = this.querySelector("[aria-expanded]");
    this.addEventListeners();
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.renderCart.bind(this));
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber();
  }
  addEventListeners() {
    document.addEventListener("cart:add:success", this.setVisible.bind(this));
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("click", this.outsideClickHandler.bind(this));

    document.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest('[drawer-action="toggle"]')) {
      this.toggleMenu();
    }
    if (e.target.closest('[drawer-action="close"]')) {
      this.setHidden();
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("cart-drawer") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
      }
    }
  }

  keyboardHandler(e) {
    if (e.key === "Escape") {
      if (this.is_open) {
        this.setHidden();
      }
    }
  }

  renderCart({ data }) {
    const { source, response, sections } = data;
    if (!sections.header) return;
    if (response.items.length > 0) {
      this.classList.remove("site-header__cart-empty");
    } else {
      this.classList.add("site-header__cart-empty");
    }
    for (const node of this.nodesToRender) {
      const target = node.id || node.selector;
      if (!target) continue;
      const original_node = this.querySelector(target);
      const new_node = sections.header.querySelector(target);
      if (!original_node || !new_node) continue;
      original_node.parentNode.insertBefore(new_node, original_node);
      original_node.style.display = "none";

      setTimeout(() => original_node.remove(), 500);
    }
    this.setVisible();
  }

  // updateCart(e) {
  //   this.updateTotals(e);
  //   this.updateCount(e);
  //   const item_count = e.detail.data.item_count;
  //
  //   if (item_count <= 0) {
  //     this.classList.add("site-header__cart-empty");
  //   } else {
  //     this.classList.remove("site-header__cart-empty");
  //   }
  // }

  toggleMenu() {
    if (this.getAttribute("drawer-view") === "hidden") {
      this.setVisible();
    } else if (this.getAttribute("drawer-view") === "visible") {
      this.setHidden();
    }
  }

  setHidden() {
    this.is_open = false;
    this.setAttribute("drawer-view", "hidden");
    this.toggle_button.setAttribute("aria-expanded", "false");
  }

  setVisible() {
    this.is_open = true;
    this.setAttribute("drawer-view", "visible");
    this.toggle_button.setAttribute("aria-expanded", "true");
  }

  get nodesToRender() {
    return [
      {
        selector: ".cart-count",
      },
      {
        selector: "basket-builder",
      },
      {
        selector: ".cart-drawer__header-text .cart-count",
      },
      {
        selector: ".cart-drawer__total",
      },
    ];
  }
}
customElements.define("cart-drawer", CartDrawer);

class MainNavigation extends HTMLElement {
  constructor() {
    super();

    this.parents = this.querySelectorAll(".main-navigation__parent-item");
    this.extended_children = this.querySelectorAll(".type--extended .main-navigation__child-item");
    this.is_touch = false;
    if (window.matchMedia("(pointer: coarse)").matches) {
      this.is_touch = true;
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.parents.forEach((parent) => {
      if (this.is_touch) {
        parent.addEventListener("click", this.clickHandler.bind(this));
      } else {
        parent.addEventListener("mouseenter", this.mouseHandler.bind(this));
        parent.addEventListener("mouseleave", this.mouseHandler.bind(this));
      }
    });
    this.extended_children.forEach((child) => {
      if (this.is_touch) {
        child.addEventListener("click", this.clickHandler.bind(this));
      } else {
        child.addEventListener("mouseenter", this.mouseHandler.bind(this));
        child.addEventListener("mouseleave", this.mouseHandler.bind(this));
      }
    });

    if (this.is_touch) {
      document.addEventListener("click", this.outsideClickHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (
      e.target.classList.contains("main-navigation__parent-button") &&
      e.target.getAttribute("aria-expanded") === "false"
    ) {
      e.preventDefault();
      this.closeAllMenus();
      e.target.setAttribute("aria-expanded", "true");
    }
    if (
      e.target.classList.contains("main-navigation__child-button") &&
      e.target.getAttribute("aria-expanded") === "false" &&
      e.target.closest(".type--extended")
    ) {
      e.preventDefault();
      this.closeAllChildMenus();
      e.target.setAttribute("aria-expanded", "true");
    }
  }

  outsideClickHandler(e) {
    if (e.target.closest("main-navigation") !== this) {
      this.closeAllMenus();
    }
  }

  mouseHandler(e) {
    if (e.type === "mouseleave") {
      if (
        e.target.classList.contains("main-navigation__parent-item") ||
        e.target.classList.contains("main-navigation__child-item")
      ) {
        e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
      }
      if (e.target.classList.contains("main-navigation__parent-item")) {
        const child = e.target.querySelector(".main-navigation__child-item").firstElementChild;

        child?.setAttribute("aria-expanded", "true");
      }
    } else if (e.type === "mouseenter") {
      if (
        e.target.classList.contains("main-navigation__parent-item") ||
        e.target.classList.contains("main-navigation__child-item")
      ) {
        e.target.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "true");
      }
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      if (e.target.getAttribute("aria-expanded") === "false") {
        e.preventDefault();
        this.closeAllMenus();
        e.target.setAttribute("aria-expanded", "true");
      }
    }
    if (e.key === "Escape") {
      this.parents.forEach((parent) => {
        parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
      });
    }
  }

  closeAllMenus() {
    this.parents.forEach((parent) => {
      parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }

  closeAllChildMenus() {
    this.extended_children.forEach((child) => {
      child.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }
}
customElements.define("main-navigation", MainNavigation);

class DrawerNavigation extends DropdownMenu {
  constructor() {
    super();

    this.menu_parents = this.querySelectorAll(".drawer-navigation__parent-item");
    this.menu_children = this.querySelectorAll(".drawer-navigation__child-item");
    this.menu_grandchildren = this.querySelectorAll(".drawer-navigation__grandchild-item");
  }

  connectedCallback() {
    this.toggle_button = this.querySelector("[aria-expanded]");
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("click", this.outsideClickHandler.bind(this));
    if (!this.is_touch) {
      this.addEventListener("mouseenter", this.mouseHandler.bind(this));
      this.addEventListener("mouseleave", this.mouseHandler.bind(this));
    }

    this.addEventListener("keydown", this.keyboardHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest(".drawer-navigation__button")) {
      const btn = e.target.closest(".drawer-navigation__button");
      this.scrollToTop(btn);
    }
    if (e.target.closest(".drawer-navigation__backlink")) {
      const btn = e.target.closest(".drawer-navigation__backlink");
      this.scrollToTop(btn);
    }
    if (e.target.closest('.menu__button[dropdown-action="toggle"]')) {
      this.toggleMenu();
    }
    if (
      e.target.getAttribute("aria-expanded") ||
      e.target.parentElement.getAttribute("aria-expanded")
    ) {
      e.preventDefault();
      e.target.getAttribute("aria-expanded")
        ? e.target.setAttribute("aria-expanded", "true")
        : e.target.parentElement.setAttribute("aria-expanded", "true");
    }
    if (e.target.closest(".drawer-navigation__child-backlink-wrapper")) {
      e.preventDefault();
      const parent = e.target.closest(".drawer-navigation__parent-menu");
      parent.previousElementSibling.setAttribute("aria-expanded", "false");
    }
    if (e.target.closest(".drawer-navigation__grandchild-backlink-wrapper")) {
      e.preventDefault();
      const parent = e.target.closest(".drawer-navigation__child-menu");
      parent.previousElementSibling.setAttribute("aria-expanded", "false");
    }
    if (e.target.closest(".drawer-navigation__greatgrandchild-backlink-wrapper")) {
      e.preventDefault();
      const parent = e.target.closest(".drawer-navigation__grandchild-menu");
      parent.previousElementSibling.setAttribute("aria-expanded", "false");
    }
  }

  scrollToTop(btn) {
    btn.closest("#drawer-menu").scrollTop = 0;
  }

  outsideClickHandler(e) {
    if (e.target.closest("drawer-navigation") !== this) {
      if (this.is_open) {
        e.preventDefault();
        this.setHidden();
        this.closeAllMenus();
      }
    }
  }

  keyboardHandler(e) {
    if (e.key === "Enter" || e.key === "Return") {
      if (e.target.getAttribute("aria-expanded")) {
        e.preventDefault();
        e.target.setAttribute("aria-expanded", "true");
      }
    }
    if (e.key === "Escape") {
      this.closeAllMenus();
    }
  }

  toggleMenu() {
    super.toggleMenu();
    if (this.getAttribute("dropdown-view") === "visible") {
      this.closeAllMenus();
    }
  }

  closeAllMenus() {
    this.menu_parents.forEach((parent) => {
      parent.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
    this.menu_children.forEach((child) => {
      child.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "false");
    });
  }
}
customElements.define("drawer-navigation", DrawerNavigation);

class UnitDisclosure extends HTMLElement {
  constructor() {
    super();

    this.productUnitType = this.getAttribute("product-unit-type");
    this.productUnitMeasure = this.getAttribute("product-unit-measure");

    this.unitObj = {
      weight: [
        { metric: "kg", imperial: "lb", conversion: 2.2046228 },
        { metric: "g", imperial: "oz", conversion: 0.035274 },
      ],
      volume: [
        { metric: "L", imperial: "pt", conversion: 1.75975 },
        { metric: "mL", imperial: "floz", conversion: 0.0351951 },
      ],
      dimension: [
        { metric: "m", imperial: "ft", conversion: 3.28084 },
        { metric: "cm", imperial: "in", conversion: 0.393701 },
      ],
      custom: [{ custom: this.productUnitMeasure, conversion: 0 }],
    };

    this.setProductSystem();

    this.setAttribute("product-system", this.productSystem);
    this.productPrice = this.getAttribute("product-price");
    this.productUnitSize = this.getAttribute("product-unit-size");
    this.preferences = JSON.parse(localStorage.getItem("unitPreferences")) || {
      system: this.productSystem,
    };
    this.selectedSystem = this.preferences.system;
    localStorage.setItem("unitPreferences", JSON.stringify(this.preferences));
  }

  addEventListeners() {
    document.addEventListener("click", this.handleOutsideClick.bind(this));
    this.shadowRoot.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(e) {
    if (e.target.classList.contains("unit-disclosure__button")) {
      this.openToggle();
    }
    if (e.target.classList.contains("unit-disclosure__option")) {
      this.setAttribute("selected-system", e.target.dataset.value);
      this.closeToggle();
    }
  }
  handleOutsideClick(e) {
    if (e.target !== this && !e.target.closest(".unit-disclosure__wrapper")) {
      this.closeToggle();
    }
  }

  openToggle() {
    this.shadowRoot.querySelector(".unit-disclosure__button").setAttribute("aria-expanded", true);
    this.shadowRoot.querySelector(".unit-disclosure__wrapper").classList.add("toggle-active");
  }

  closeToggle() {
    this.shadowRoot.querySelector(".unit-disclosure__button").setAttribute("aria-expanded", false);
    this.shadowRoot.querySelector(".unit-disclosure__wrapper").classList.remove("toggle-active");
  }

  connectedCallback() {
    const shadow = this.attachShadow({ mode: "open" });

    const wrapper = document.createElement("div");
    wrapper.classList.add(
      "unit-disclosure__wrapper",
      this.productSystem === "custom" ? "hide-toggle" : null,
    );

    const container = document.createElement("div");
    container.classList.add("unit-disclosure__container");

    const price = document.createElement("span");
    price.classList.add("unit-disclosure__price");

    const measure = document.createElement("span");
    measure.classList.add("unit-disclosure__measure");

    container.innerHTML = `${price.outerHTML} per ${measure.outerHTML}`;

    const toggle = document.createElement("div");
    toggle.classList.add("unit-disclosure__toggle");

    const toggleButton = document.createElement("button");
    toggleButton.classList.add("unit-disclosure__button");
    toggleButton.setAttribute("aria-expanded", false);
    toggleButton.textContent = "...";

    const toggleOptions = document.createElement("div");
    toggleOptions.classList.add("unit-disclosure__options");
    toggleOptions.innerHTML = `
      <button class="unit-disclosure__option" data-value="metric">Metric</button>
      <button class="unit-disclosure__option" data-value="imperial">Imperial</button>
    `;

    toggle.appendChild(toggleButton);
    toggle.appendChild(toggleOptions);

    const style = document.createElement("style");

    style.textContent = `
      * {font-family:Open Sans,sans-serif}
      :host{font-size:16px}
      button {-webkit-appearance:none;appearance:none;border:0;background:transparent;display:block;}
      .unit-disclosure__wrapper{display:flex;align-items:center;gap:10px;user-select:none;font-weight:700}
      .unit-disclosure__container{font-size:.875rem}
      .unit-disclosure__button{width:1.5rem;height:1.5rem;border-radius:50%;font-weight:700;background-color:#f5f7fe;cursor:pointer}
      .unit-disclosure__toggle{opacity:0;visibility:hidden;transition:opacity .2s ease;position:relative;z-index:1}
      .unit-disclosure__options{position:absolute;top:0;left:100%;opacity:0;visibility:hidden;transition:opacity .2s ease;display:flex;flex-direction:column;border-radius:0 5px 5px 5px;z-index:1;overflow:hidden}
      .unit-disclosure__option{cursor:pointer;transition:background-color .2s ease;padding:0 12px 0 10px;font-size:.875rem;background-color:#f5f7fe;font-weight:700;display:grid;justify-content:start;align-items:center;height:1.5rem}
      .unit-disclosure__button:hover,.unit-disclosure__wrapper.toggle-active .unit-disclosure__button,.unit-disclosure__option:hover{background-color:#eaedf8;}
      .unit-disclosure__button[aria-expanded="true"]{border-radius:50% 0 0 50%}
      .unit-disclosure__wrapper:hover .unit-disclosure__toggle,.unit-disclosure__wrapper.toggle-active .unit-disclosure__toggle,.unit-disclosure__button[aria-expanded="true"] + .unit-disclosure__options{opacity:1;visibility:visible}
      .unit-disclosure__wrapper.hide-toggle .unit-disclosure__button{display:none}
    `;
    wrapper.appendChild(container);
    wrapper.appendChild(toggle);
    shadow.appendChild(style);
    shadow.appendChild(wrapper);

    this.setAttribute("selected-system", this.selectedSystem);

    this.addEventListeners();
  }

  static get observedAttributes() {
    return ["selected-system"];
  }

  attributeChangedCallback(name, prev, next) {
    this.selectedSystem = next;
    if (this.productSystem === "custom" || next === this.productSystem) {
      this.convertedUnitSize = this.productUnitSize;
      this.convertedUnitMeasure = this.productUnitMeasure;
      this.getPricePerUnit(this.productUnitMeasure);
    } else {
      this.handleUnitType();
    }
  }

  setProductSystem() {
    this.unitObj[this.productUnitType].forEach((obj) => {
      for (const [key, value] of Object.entries(obj)) {
        if (value === this.productUnitMeasure) {
          this.productSystem = key;
        }
      }
    });
  }

  handleUnitType() {
    const measureObj = this.unitObj[this.productUnitType].filter((obj) => {
      return obj[this.productSystem] === this.productUnitMeasure;
    });
    this.productSystem === "metric"
      ? (this.convertedUnitSize = this.productUnitSize * measureObj[0].conversion)
      : (this.convertedUnitSize = this.productUnitSize / measureObj[0].conversion);

    this.convertedUnitMeasure = measureObj[0][this.selectedSystem];
    this.getPricePerUnit();
  }

  getPricePerUnit() {
    const priceContainer = this.shadowRoot.querySelector(".unit-disclosure__price");
    const unitContainer = this.shadowRoot.querySelector(".unit-disclosure__measure");
    const calculatedPrice = this.productPrice / this.convertedUnitSize;
    priceContainer.textContent =
      calculatedPrice / 100 < 1
        ? `${calculatedPrice.toFixed(2)} cents`
        : theme.Currency.formatMoney(calculatedPrice, theme.strings.moneyFormat);
    unitContainer.textContent = this.convertedUnitMeasure;
  }
}

customElements.define("unit-disclosure", UnitDisclosure);

class RangeSlider extends HTMLElement {
  constructor() {
    super();

    this.mouseDown = false;
    this.startX = 0;
    this.handle = null;
    this.minHandle = null;
    this.maxHandle = null;
  }

  addEventListeners() {
    this.addEventListener("mousemove", this.dragHandler.bind(this));
    this.addEventListener("touchmove", this.dragHandler.bind(this));

    this.addEventListener("mousedown", this.startHandler.bind(this));
    this.addEventListener("touchstart", this.startHandler.bind(this));

    this.addEventListener("mouseup", this.endHandler.bind(this));
    this.addEventListener("touchend", this.endHandler.bind(this));
    this.addEventListener("mouseleave", this.endHandler.bind(this));

    document.addEventListener("range:set", this.setHandlePositions.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("mousemove", this.dragHandler.bind(this));
    this.removeEventListener("touchmove", this.dragHandler.bind(this));

    this.removeEventListener("mousedown", this.startHandler.bind(this));
    this.removeEventListener("touchstart", this.startHandler.bind(this));

    this.removeEventListener("mouseup", this.endHandler.bind(this));
    this.removeEventListener("touchend", this.endHandler.bind(this));
    this.removeEventListener("mouseleave", this.endHandler.bind(this));

    document.removeEventListener("range:set", this.setHandlePositions.bind(this));
  }

  connectedCallback() {
    this.minHandle = this.querySelector("#range-slider-min");
    this.maxHandle = this.querySelector("#range-slider-max");
    this.handleWidth = this.minHandle.offsetWidth;
    this.trackSize = this.offsetWidth - this.handleWidth;
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  dragHandler(e) {
    if (!this.mouseDown) return;
    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    const x = pageX - e.currentTarget.offsetLeft;
    let percentage = 0;
    if (this.handle.id === "range-slider-min" && x < this.handleWidth / 2) {
      this.handle.style.left = `${this.handleWidth / 2}px`;
      percentage = 0;
    } else if (
      this.handle.id === "range-slider-max" &&
      x > this.offsetWidth - this.handleWidth / 2
    ) {
      this.handle.style.left = `${this.offsetWidth - this.handleWidth / 2}px`;
      percentage = 100;
    } else {
      if (
        this.handle.id === "range-slider-min" &&
        x >= this.maxHandle.offsetLeft - this.handleWidth / 2
      ) {
        this.handle.style.left = `${this.maxHandle.offsetLeft - this.handleWidth / 2}px`;
      } else if (
        this.handle.id === "range-slider-max" &&
        x <= this.minHandle.offsetLeft + this.handleWidth * 1.5
      ) {
        this.handle.style.left = `${this.minHandle.offsetLeft + this.handleWidth * 1.5}px`;
      } else {
        this.handle.style.left = `${x}px`;
      }
      percentage = (this.handle.offsetLeft / this.trackSize) * 100;
    }

    // event to update the min and max values as percentages
    this.sendUpdatedHandleValue(this.handle.id, percentage);
  }

  startHandler(e) {
    if (!e.target.classList.contains("range-slider__handle")) return;

    this.mouseDown = true;
    let pageX = 0;
    if (e.pageX) {
      pageX = e.pageX;
    } else {
      pageX = e.touches[0].pageX;
    }
    this.startX = pageX - e.target.offsetLeft;
    this.handle = e.target;
  }

  endHandler(e) {
    if (this.mouseDown) {
      const event = new CustomEvent("range:complete");
      document.dispatchEvent(event);
    }
    this.mouseDown = false;
  }

  setHandlePositions(e) {
    const {
      detail: { min, max },
    } = e;

    const maxPosition = (max.current / max.limit) * 100;
    const minPosition = (min.current / max.limit) * 100;

    this.maxHandle.style.left = `${(this.trackSize / 100) * maxPosition + this.handleWidth / 2}px`;
    this.minHandle.style.left = `${(this.trackSize / 100) * minPosition + this.handleWidth / 2}px`;
  }

  sendUpdatedHandleValue(id, percentage) {
    const event = new CustomEvent("range:update", {
      detail: {
        id,
        percentage,
      },
    });
    document.dispatchEvent(event);
  }
}

customElements.define("range-slider", RangeSlider);

class ResultsGrid extends HTMLElement {
  constructor() {
    super();

    this.showCount = this.getAttribute("count-active") === "true" ? true : false;
    this.showSorting = this.getAttribute("sorting-active") === "true" ? true : false;
    this.showFilters = this.getAttribute("filters-active") === "true" ? true : false;
    this.layout = this.dataset.layout ? this.dataset.layout : null;
    this.cards = this.querySelectorAll("product-card");
    this.transition = this.dataset.transition === "true" ? true : false;
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("results:refresh:start", this.changeHandler.bind(this));
    window.addEventListener("popstate", () => {
      window.location.reload();
    });
    document.addEventListener("DOMContentLoaded", () => {
      const topBar = document.querySelector("#shopify-section-topbar");
      const header = document.querySelector("#shopify-section-header");
      this.headerHeight = topBar
        ? header?.offsetHeight + topBar.offsetHeight
        : header?.offsetHeight;
    });
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    document.removeEventListener("results:refresh:start", this.changeHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.closest(".main-pagination__wrapper")) {
      this.paginationClick(e);
      return;
    }
    if (e.target.dataset.clear && e.target.closest(".results-grid__empty")) {
      const event = new CustomEvent("filters:clear", {
        detail: {
          changeFilter: e.target,
        },
      });
      document.dispatchEvent(event);
    }
    if (this.layout && e.target.closest(".layout-button")?.dataset.layoutType) {
      this.toggleLayout(e.target.closest(".layout-button"));
    }
  }

  changeHandler(e) {
    this.createSearchString(e);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  paginationClick(e) {
    e.preventDefault();
    const url = e.target.href;
    if (!url) return;
    const paginationUrl = new URL(e.target.href);
    const filteredParams = Array.from(paginationUrl.searchParams.entries()).filter((param) => {
      return param[0].indexOf("page") === 0;
    });
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: new URLSearchParams(filteredParams),
        type: "page",
      },
    });
    document.dispatchEvent(event);
  }

  createSearchString(e) {
    const type = e.detail.type;
    const currentSearchParams = Array.from(new URLSearchParams(window.location.search).entries());
    const newSearchParams = new URLSearchParams(e.detail.params);
    const filteredParams = currentSearchParams.filter((param) => {
      if (type !== "page") {
        return param[0].indexOf(type) === -1 && param[0].indexOf("page") === -1;
      } else {
        return param[0].indexOf(type) === -1;
      }
    });
    const searchString = new URLSearchParams([...filteredParams, ...newSearchParams]).toString();
    this.refreshResults(`${window.location.pathname}?${searchString}`);
  }

  updateHistory(url) {
    const currentUrl = new URL(`${window.location.origin}${url}`);
    history.pushState(null, null, currentUrl);
  }

  async refreshResults(url) {
    this.classList.add("results-grid--loading");
    let thisTop = this.offsetTop;
    if (window.innerWidth <= 767) {
      thisTop = this.offsetTop - this.headerHeight;
    }
    if (window.scrollY > thisTop) {
      window.scrollTo({
        top: thisTop,
        behavior: "smooth",
      });
    }
    try {
      const response = await fetch(`${url}`);
      const data = await response.text();
      const dataHtml = document.createElement("div");
      dataHtml.innerHTML = data;

      const products = dataHtml.querySelector(".results-grid__products");
      const pagination = dataHtml.querySelector(".results-grid__pagination");

      const productElement = this.querySelector(".results-grid__products");
      const paginationElement = this.querySelector(".results-grid__pagination");

      productElement.innerHTML = products.innerHTML;
      paginationElement.innerHTML = pagination.innerHTML;

      if (this.showCount) {
        const productsCount = dataHtml.querySelector(".results-grid__count");
        const productsCountElement = this.querySelector(".results-grid__count");
        productsCountElement.innerHTML = productsCount.innerHTML;
      }
      if (this.showFilters) {
        const dataFiltersElem = dataHtml.querySelector(".results-grid__filters");
        const currentFiltersElem = this.querySelector(".results-grid__filters");

        if (
          !dataFiltersElem.classList.contains("results-grid__filters--hide") &&
          currentFiltersElem.classList.contains("results-grid__filters--hide")
        ) {
          // if refreshed doesnt have hide class and current page has hide, indicates a matching search so insert filters
          currentFiltersElem.innerHTML = dataFiltersElem.innerHTML;
          currentFiltersElem.classList.remove("results-grid__filters--hide");
        }
        if (!currentFiltersElem.classList.contains("results-grid__filters--hide")) {
          const filters = dataHtml.querySelector(
            ".results-grid__filters .results-filters__form .form__content",
          ).outerHTML;
          const mobileButtonCount = dataHtml.querySelector(".results-filters__footer-buttons");
          const mobileButtonCountElement = this.querySelector(".results-filters__footer-buttons");
          productElement.classList.remove("results-grid__products--full");
          mobileButtonCountElement.innerHTML = mobileButtonCount.innerHTML;

          const event = new CustomEvent("results:refresh:success", {
            detail: {
              filter_data: filters,
            },
          });
          document.dispatchEvent(event);
        }
      }

      this.updateHistory(url);
    } catch (error) {
      console.log(error);
    } finally {
      this.classList.remove("results-grid--loading");
    }
  }

  toggleLayout(target) {
    if (!document.startViewTransition || !this.transition) {
      this.dataset.layout = target.dataset.layoutType;
      return;
    }
    for (const card of this.cards) {
      card.style.viewTransitionName = `pid--${card.dataset.productId}`;
    }
    document.startViewTransition(() => {
      this.dataset.layout = target.dataset.layoutType;
    });
    setTimeout(() => {
      for (const card of this.cards) {
        card.removeAttribute("style");
      }
    }, 200);
    this.layout = target.dataset.layoutType;
  }
}

customElements.define("results-grid", ResultsGrid);

class ResultsFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListeners();
    this.windowWidth = 0;
    this.detectDevice();

    if (!this.querySelector(".price__range")) return;

    this.minPriceElem = this.querySelector('.price__range-from input[type="number"]');
    this.maxPriceElem = this.querySelector('.price__range-to input[type="number"]');
    this.minPrice = parseInt(this.minPriceElem.getAttribute("min"));
    this.maxPrice = parseInt(this.maxPriceElem.getAttribute("max"));

    this.setRangeHandles();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  detectDevice() {
    if (window.innerWidth !== this.windowWidth) {
      if (window.innerWidth <= 768) {
        this.setAttribute("aria-expanded", "false");
        this.resetDrawerState();
      } else {
        this.setAttribute("aria-expanded", "true");
      }
      this.windowWidth = window.innerWidth;
    }
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    window.addEventListener("resize", this.detectDevice.bind(this));
    document.addEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.addEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.addEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.addEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.addEventListener('input', this.inputHandler.bind(this));
    // document.addEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    window.removeEventListener("resize", this.detectDevice.bind(this));
    document.removeEventListener("results:refresh:success", this.eventHandler.bind(this));
    document.removeEventListener("filters:clear", this.clickHandler.bind(this));

    // custom event listener for detatched filter drawer button
    document.removeEventListener("filters:open", this.openFilterDrawer.bind(this));
    // custom event listeners for range slider
    document.removeEventListener("range:update", this.updatePriceRange.bind(this));

    // auto price change grid refresh
    // this.removeEventListener('input', this.inputHandler.bind(this));
    // document.removeEventListener('range:complete', this.applyPriceRange.bind(this));
  }

  clickHandler(e) {
    if (e.detail?.changeFilter || e.target.dataset.filter || e.target.dataset.clear) {
      const target = e.detail.changeFilter ? e.detail.changeFilter : e.target;
      if (target.dataset.active) {
        e.preventDefault();
        // uncheck if active filter is clicked
        if (target.dataset.filter !== "price") {
          this.querySelector(
            `[type="checkbox"][data-filter="${target.dataset.filter}"][value="${target.dataset.value}"]`,
          ).checked = false;
        } else {
          this.querySelectorAll(`[type="number"]`).forEach((filter) => {
            filter.value = "";
            filter.setAttribute("name", "");
          });
        }
      }
      if (target.dataset.clear) {
        e.preventDefault();
        this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
          filter.checked = false;
        });
        this.querySelectorAll(`[type="number"]`).forEach((filter) => {
          filter.value = "";
          filter.setAttribute("name", "");
        });
      }
      this.checkPriceFilters();
      this.debounce(() => this.changeFilter());
      return;
    }
    if (e.target.closest(".btn-elem--price")) {
      e.preventDefault();
      this.applyPriceRange();
    }
    if (e.target.classList.contains("filter__header") || e.target.closest(".filter-option__back")) {
      // toggle filter list dropdown
      const target = e.target.closest(".filter").querySelector(".filter__header");
      const toggle = target.ariaExpanded === "true" ? true : false;
      target.ariaExpanded = !toggle;
      return;
    }
    if (e.target.classList.contains("filter__more")) {
      e.preventDefault();
      const toggle = e.target.ariaExpanded === "true" ? true : false;
      e.target.ariaExpanded = !toggle;
      e.target.textContent.trim() === theme.strings.show_more
        ? (e.target.textContent = theme.strings.show_less)
        : (e.target.textContent = theme.strings.show_more);
      return;
    }
    if (e.target.dataset.action === "open-filter-drawer") {
      this.openFilterDrawer();
      return;
    }
    if (e.target.dataset.action === "close-filter-drawer") {
      this.closeFilterDrawer();
      return;
    }
  }

  inputHandler(e) {
    if (!e.target.dataset.priceFilter) return;
    this.debounce(() => {
      this.applyPriceRange();
    }, 1000);
  }

  eventHandler(e) {
    const fragment = document.createElement("div");
    fragment.innerHTML = e.detail.filter_data;
    const filters = fragment.querySelectorAll("[data-filter]");
    filters.forEach((filter) => {
      const element = this.querySelector(
        `[data-filter="${filter.dataset.filter}"][value="${filter.value}"]`,
      );
      const parent = element.parentElement;
      element.dataset.count = filter.dataset.count;
      filter.dataset.count <= 0
        ? parent.classList.add("filter-option--nocount")
        : parent.classList.remove("filter-option--nocount");
      element.nextElementSibling.querySelector(".filter-option__count").textContent =
        `(${filter.dataset.count})`;
    });
  }

  openFilterDrawer() {
    this.setAttribute("aria-expanded", "true");
  }

  closeFilterDrawer() {
    this.setAttribute("aria-expanded", "false");
    this.debounce(() => {
      this.resetDrawerState();
    });
  }

  checkPriceFilters(e) {
    this.minPriceElem.value === "" ? (this.minPriceElem.value = this.minPrice) : null;
    this.maxPriceElem.value === "" ? (this.maxPriceElem.value = this.maxPrice) : null;

    const minElemValue = parseInt(this.minPriceElem.value);
    const maxElemValue = parseInt(this.maxPriceElem.value);

    minElemValue < this.minPrice ? (this.minPriceElem.value = this.minPrice) : null;
    minElemValue > this.maxPrice ? (this.minPriceElem.value = this.maxPrice) : null;
    maxElemValue < this.minPrice ? (this.maxPriceElem.value = this.minPrice) : null;
    maxElemValue > this.maxPrice ? (this.maxPriceElem.value = this.maxPrice) : null;

    minElemValue > maxElemValue ? (this.maxPriceElem.value = this.minPriceElem.value) : null;

    if (minElemValue === this.minPrice && maxElemValue === this.maxPrice) {
      this.minPriceElem.setAttribute("name", "");
      this.maxPriceElem.setAttribute("name", "");
    } else {
      this.minPriceElem.setAttribute("name", this.minPriceElem.dataset.priceFilter);
      this.maxPriceElem.setAttribute("name", this.maxPriceElem.dataset.priceFilter);
    }
    this.setRangeHandles();
  }

  setRangeHandles() {
    const event = new CustomEvent("range:set", {
      detail: {
        min: {
          current:
            this.minPriceElem.value !== "" ? parseInt(this.minPriceElem.value) : this.minPrice,
          limit: this.minPrice,
        },
        max: {
          current:
            this.maxPriceElem.value !== "" ? parseInt(this.maxPriceElem.value) : this.maxPrice,
          limit: this.maxPrice,
        },
      },
    });
    document.dispatchEvent(event);
  }

  updatePriceRange(e) {
    const { id, percentage } = e.detail;
    if (!this.querySelector(".filter-option--price")) return;

    const filter = this.querySelector(
      id === "range-slider-min"
        ? '.price__range-from input[type="number"]'
        : '.price__range-to input[type="number"]',
    );
    const maxValue = filter.getAttribute("max");

    filter.value = Math.round((percentage / 100) * maxValue);
  }

  applyPriceRange() {
    this.checkPriceFilters();
    this.changeFilter();
  }

  changeFilter() {
    const filtersForm = new FormData(this.querySelector("form"));
    const searchParamsArr = [];
    for (const [key, value] of filtersForm) {
      if (key.indexOf("filter") !== -1) {
        searchParamsArr.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
    const searchParamsStr = searchParamsArr.join("&");
    // emit custom event with search string as payload
    const filterChangeEvent = new CustomEvent("results:refresh:start", {
      detail: {
        params: searchParamsStr,
        type: "filter",
      },
    });
    document.dispatchEvent(filterChangeEvent);
    this.updateActiveFilters(filtersForm);
  }

  createActiveFilterButton(filter) {
    const button = document.createElement("button");
    let attributes = {};
    let label = "";
    if (typeof filter[0] === "object") {
      // is price filter
      attributes = {
        "data-filter": "price",
        "data-active": "true",
        "aria-label": "Remove filter: Price range",
      };
      for (const priceGroup of filter) {
        if (priceGroup[0].indexOf("gte") !== -1) {
          attributes["data-filter-from"] = priceGroup[0];
          attributes["data-value-from"] = priceGroup[1];
        } else if (priceGroup[0].indexOf("lte") !== -1) {
          attributes["data-filter-to"] = priceGroup[0];
          attributes["data-value-to"] = priceGroup[1];
        }
      }
      label = `Price: ${theme.Currency.formatMoney(attributes["data-value-from"] * 100, theme.strings.moneyFormat)} - ${theme.Currency.formatMoney(attributes["data-value-to"] * 100, theme.strings.moneyFormat)}`;
    } else {
      // is normal filter
      attributes = {
        "data-filter": filter[0],
        "data-value": filter[1],
        "data-active": "true",
        "aria-label": `Remove filter: ${decodeURIComponent(filter[1].replace(/\+/g, " "))}`,
      };
      label = decodeURIComponent(filter[1].replace(/\+/g, " "));
    }
    for (const key in attributes) {
      button.setAttribute(key, attributes[key]);
    }
    button.classList.add("active-filters__button");
    button.innerHTML = `${label}<span class="active-filters__cross" aria-hidden="true"></span>`;
    return button;
  }

  updateActiveFilters(filters = []) {
    const buttons = document.createDocumentFragment();
    let count = 0;
    let priceFilter = [];
    for (const filter of filters) {
      if (filter[0].indexOf("filter") !== -1) {
        if (filter[0].indexOf("filter.v.price") !== -1) {
          filter[1] !== "" ? priceFilter.push(filter) : null;
        } else {
          count++;
          const button = this.createActiveFilterButton(filter);
          buttons.appendChild(button);
        }
      }
    }
    if (priceFilter.length !== 0) {
      count++;
      const button = this.createActiveFilterButton(priceFilter);
      buttons.appendChild(button);
    }
    if (count > 0) {
      const clearButton = document.createElement("button");
      clearButton.classList.add("active-filters__clear");
      clearButton.setAttribute("data-clear", "true");
      clearButton.textContent = "Clear all";
      buttons.appendChild(clearButton);
    } else {
      this.querySelectorAll(`[type="checkbox"]`).forEach((filter) => {
        filter.checked = false;
      });
      this.querySelectorAll(`[type="number"]`).forEach((filter) => {
        filter.value = null;
      });
    }
    const activeFilters = this.querySelector(".active-filters");
    activeFilters.replaceChildren(buttons);
    this.querySelectorAll(".active-filters").forEach((container, index) => {
      if (index !== 0) {
        container.innerHTML = activeFilters.innerHTML;
      }
    });
  }

  resetDrawerState() {
    this.querySelectorAll(".filter__header").forEach((header) => {
      header.setAttribute("aria-expanded", "false");
    });
  }

  debounce(fn, wait = 300) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}
customElements.define("results-filters", ResultsFilters);

class ResultsSorting extends HTMLElement {
  constructor() {
    super();
  }

  addEventListeners() {
    this.addEventListener("input", this.changeHandler.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("input", this.changeHandler.bind(this));
  }

  changeHandler(e) {
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: `sort_by=${e.target.value}`,
        type: "sort_by",
      },
    });
    document.dispatchEvent(event);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

customElements.define("results-sorting", ResultsSorting);

class SearchRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.recentlyViewedHandles = JSON.parse(localStorage.getItem("recentlyViewedItems"));
    this.currentProduct = this.getAttribute("current-product");

    if (this.currentProduct && this.recentlyViewedHandles) {
      this.recentlyViewedHandles = this.recentlyViewedHandles.filter((handle) => {
        return handle != this.currentProduct;
      });
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    if (!this.recentlyViewedHandles) return;
    document.addEventListener("DOMContentLoaded", this.fetchRecentlyViewed.bind(this));
  }

  async fetchRecentlyViewed() {
    if (!this.recentlyViewedHandles) return;

    try {
      const res = await fetch(
        `/search?view=search-recently-viewed-items&q=${this.recentlyViewedHandles.join(",")}`,
      );
      const data = await res.text();
      if (!data) return;
      this.renderRecentlyViewed(data);
    } catch (error) {
      console.log(error);
    }
  }

  renderRecentlyViewed(data) {
    const items = new DOMParser()
      .parseFromString(data, "text/html")
      .querySelector(".site-predictive-search__list").innerHTML;
    const item_wrapper = this.querySelector(".site-predictive-search__list");
    item_wrapper.innerHTML = items;
    this.classList.add("recently-viewed--loaded");
  }
}
customElements.define("search-recently-viewed", SearchRecentlyViewed);

class StaticSearch extends HTMLElement {
  constructor() {
    super();
    this.search = {
      query: this.getAttribute("search-query"),
    };
    this.inputWrapper = this.querySelector(".input-wrapper");
  }

  connectedCallback() {
    this.addEventListeners();
    this.init();
  }

  addEventListeners() {
    this.input = this.querySelector('input[type="search"]');
    this.input.addEventListener("focusin", this.setActive.bind(this));
    this.input.addEventListener("input", (event) => {
      this.inputChange(event);
    });
    this.querySelector("form").addEventListener("submit", this.triggerResultsRefresh.bind(this));

    document.addEventListener("click", this.clickHandler.bind(this));
    this.clear = this.querySelector(".input-clear");
  }

  clickHandler(e) {
    if (e.target === this.clear || e.target.closest(".input-clear")) {
      e.preventDefault();
      this.clearResults();
      return;
    }
    if (!e.target.closest("static-search")) {
      this.unsetActive();
      return;
    }
  }

  inputChange() {
    const query = this.input.value.trim();
    this.search.query = query;
    this.toggleClearButton();
    this.setAttribute("search-query", query);
  }

  triggerResultsRefresh(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const searchParams = new URLSearchParams(formData).toString();
    const event = new CustomEvent("results:refresh:start", {
      detail: {
        params: searchParams,
        type: "q",
      },
    });
    document.dispatchEvent(event);
  }

  toggleClearButton() {
    if (this.input.value !== "") {
      this.querySelector(".input-clear").classList.add("input-clear--visible");
    } else {
      this.querySelector(".input-clear").classList.remove("input-clear--visible");
    }
  }

  clearResults() {
    this.input.value = "";
    this.input.dispatchEvent(new Event("input"));
    this.input.focus();
  }

  setActive() {
    this.inputWrapper.classList.add("input-wrapper--active");
  }

  unsetActive() {
    if (this.input.value === "") {
      this.inputWrapper.classList.remove("input-wrapper--active");
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  init() {
    if (this.input.value !== "") {
      this.inputWrapper.classList.add("input-wrapper--active");
    }
  }
}

customElements.define("static-search", StaticSearch);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.reload = this.getAttribute("needs-reload") === "true" ? true : false;
    this.events = [
      {
        type: "click",
        el: this,
        callback: this.clickHandler.bind(this),
      },
      {
        type: "click",
        el: document,
        callback: this.outsideClickHandler.bind(this),
      },
      {
        type: "change",
        el: this,
        callback: this.changeVariantSelect.bind(this),
      },
      {
        type: "submit",
        el: this,
        callback: this.submitHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    this.quickAdd = this.querySelector(".product-card__quick-add");
    this.quickAddForm = this.querySelector(".product-card__quick-add form");
    this.quickAddOptions = this.querySelector(".quick-add__options");
    if (!this.quickAdd) return;
    handleEventListeners(this.events, "add");
  }

  disconnectedCallback() {
    if (!this.quickAdd) return;
    handleEventListeners(this.events, "remove");
  }

  outsideClickHandler(e) {
    if (e.target.closest("product-card") !== this) {
      this.quickAdd.setAttribute("quick-add-view", "hidden");
      return;
    }
  }

  clickHandler(e) {
    if (this.quickAddOptions) {
      const trigger = e.target.closest("[quick-add-action]");
      const target = e.target.closest("[quick-add-action-target]");
      if (!trigger && !target) {
        this.closeQuickAdd();
        return;
      }
      if (trigger) {
        const action = trigger.getAttribute("quick-add-action");
        if (!action) return;
        if (action === "open") {
          this.openQuickAdd();
        } else {
          this.closeQuickAdd();
        }
      }
    }
  }

  submitHandler(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const items = [];
    const item = {};

    for (const [key, value] of formData.entries()) {
      item[key] = value;
    }

    item.product_id = this.dataset.productId;
    items.push(item);

    const data = {
      type: "add",
      source: "product-card",
      sections: ["announcement-banner"],
      sections_url: "/",
      items,
      submitter: e.submitter,
      reload: this.reload,
    };
    updateCart(data);
  }

  openQuickAdd() {
    this.quickAdd.setAttribute("quick-add-view", "visible");
  }

  closeQuickAdd() {
    this.quickAdd.setAttribute("quick-add-view", "hidden");
  }

  changeVariantSelect(e) {
    const options = this.querySelector(".quick-add__options");
    const selected = [];
    for (const select of options.querySelectorAll("select")) {
      selected.push(select.value);
    }
    const variants = this.querySelectorAll(".quick-add__master-select option");
    const matchedVariant = Array.from(variants).filter((variant) => {
      return variant.dataset.variantOptions === selected.join(",");
    });

    this.updateSelectedProduct(matchedVariant);
    this.updateDisplayPrice(matchedVariant);
  }

  updateSelectedProduct(variant) {
    const matched = variant[0];
    const cartButton = this.quickAddOptions.querySelector('button[type="submit"]');

    if (variant.length <= 0) {
      cartButton.classList.add("btn-style__nostock");
      cartButton.innerHTML = "<span>Unavailable</span>";
      return;
    } else if (matched.dataset.available === "false") {
      cartButton.classList.add("btn-style__nostock");
      cartButton.innerHTML = "<span>Sold Out</span>";
      return;
    } else {
      cartButton.classList.remove("btn-style__nostock");
      cartButton.innerHTML = "<span>Add To Cart</span>";
      this.querySelector(".quick-add__master-select").value = matched.value;
    }
  }

  updateDisplayPrice(variant) {
    const matched = variant[0];
    if (variant.length <= 0) return;
    const displayPrice = this.querySelector(".product-display__price");
    const comparePrice = this.querySelector(".product-display__price--compare-at");
    const compareWrapper = this.querySelector(".product-display__compare-wrapper");
    if (parseInt(matched.dataset.variantCompare) > parseInt(matched.dataset.variantPrice)) {
      compareWrapper.classList.add("visible");
      displayPrice.classList.add("on-sale");
      comparePrice.innerHTML = `RRP ${theme.Currency.formatMoney(matched.dataset.variantCompare, theme.strings.moneyFormat)}`;
    } else {
      compareWrapper.classList.remove("visible");
      displayPrice.classList.remove("on-sale");
    }
    displayPrice.innerHTML = theme.Currency.formatMoney(
      matched.dataset.variantPrice,
      theme.strings.moneyFormat,
    );
    displayPrice.setAttribute("content", matched.dataset.variantPrice / 100);
  }
}

customElements.define("product-card", ProductCard);

class CustomModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("click", this.outsideClick.bind(this));
  }

  removeEventListeners() {
    this.removeEventListener("click", this.clickHandler.bind(this));
    document.removeEventListener("click", this.outsideClick.bind(this));
  }

  outsideClick(e) {
    if (e.target.closest("custom-modal") !== this) {
      this.setAttribute("modal-view", "hidden");
      return;
    }
  }

  clickHandler(e) {
    e.preventDefault();
    const trigger = e.target.closest("[modal-action]");
    const target = e.target.closest("[modal-action-target]");
    if (!trigger && !target) {
      this.closeModal();
      return;
    }
    if (trigger) {
      const action = trigger.getAttribute("modal-action");
      if (!action) return;
      if (action === "open") {
        this.openModal();
      } else {
        this.closeModal();
      }
    }
  }

  openModal() {
    this.setAttribute("modal-view", "visible");
  }

  closeModal() {
    this.setAttribute("modal-view", "hidden");
  }
}

customElements.define("custom-modal", CustomModal);

class FlexifiWidget extends HTMLElement {
  constructor() {
    super();

    this.price = this.getAttribute("data-price");
    this.term = this.getAttribute("data-term");
  }

  connectedCallback() {
    if (this.term === "0") {
      return;
    }
    const script = document.createElement("script");
    script.src = `https://d3v2ir16k1una.cloudfront.net/content/scripts/flexifi-widget.js?id=0011n00001urbBgAAI&productPrice=${this.price}&term=${this.term}`;
    this.appendChild(script);
  }
}

customElements.define("flexifi-widget", FlexifiWidget);

class CartLines extends HTMLElement {
  constructor() {
    super();

    this.changing_lines = [];
    this.items_wrapper = this.querySelector(".cart-lines__items");
    this.updating = false;
  }

  connectedCallback() {
    this.addEventListeners();
    this.quantityChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.updateQuantity.bind(this),
    );
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.renderLines.bind(this));
    this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, this.handleError.bind(this));
  }

  disconnectedCallback() {
    this.quantityChangeUnsubscriber();
    this.cartUpdateUnsubscriber();
    this.cartErrorUnsubscriber();
  }

  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  handleError({ data: message }) {
    this.updating = false;
    this.toggleInteraction();
  }

  clickHandler(e) {
    if (e.target.classList.contains("cart-line__remove")) {
      e.preventDefault();
      this.removeLine(e);
    }
    if (e.target.classList.contains("cart-upsell__add")) {
      e.preventDefault();
      this.addComplementaryProduct(e);
    }
  }

  updateQuantity({ data }) {
    const { quantity, target } = data;

    if (this.contains(target)) {
      const line = target.closest("[data-line]");
      if (!line) return;
      this.querySelector(
        `[data-line="${line.dataset.line}"] quantity-selector [name="quantity"]`,
      ).value = quantity;
      this.updateCartLine(line, quantity);
    }
  }

  updateCartLine(line, quantity) {
    const data = {
      items: [
        {
          id: `${line.dataset.line}`,
          quantity,
          product_id: line.querySelector("quantity-selector").dataset.productId,
        },
      ],
      source: "cart-lines",
      sections: ["announcement-banner"],
      sections_url: "/",
      type: "update",
    };
    updateCart(data);
  }

  renderLines({ data }) {
    const { source, response, sections, submitter } = data;
    this.updating = false;
    if (
      source.toUpperCase() !== this.nodeName ||
      this.querySelector(".cart-lines__items").children.length !== response.items.length ||
      (submitter && submitter.classList.contains("cart-line__remove"))
    ) {
      this.updateLinesHTML(data);
    } else {
      for (const line of response.items) {
        const selector = `[data-line="${line.key}"] .cart-line__price .cart-line__price-display`;
        if (
          !this.querySelector(selector) ||
          line.quantity !== +this.querySelector(`[data-line="${line.key}"] .quantity__input`).value
        ) {
          this.updateLinesHTML(data);
          break;
        } else {
          this.querySelector(selector).innerHTML =
            sections.header.querySelector(selector).innerHTML;
        }
      }
    }
  }

  updateLinesHTML(data) {
    const { source, response, sections } = data;
    if (!sections.header) return;
    if (response.items.length > 0) {
      const lines = sections.header.querySelector(".cart-lines__items");
      const old_lines = this.querySelector(".cart-lines__items");
      old_lines.innerHTML = lines.innerHTML;
    } else {
      this.querySelector(".cart-lines__items").innerHTML = "";
    }
    this.toggleInteraction();
  }

  removeLine(e) {
    e.target.classList.add("btn-elem--loading");
    this.updating = true;
    this.toggleInteraction();
    const line = e.target.closest("[data-line]");
    const data = {
      items: [
        {
          id: `${line.dataset.line}`,
          quantity: 0,
          product_id: line.querySelector("quantity-selector").dataset.productId,
        },
      ],
      source: "cart-lines",
      submitter: e.target,
      sections: ["announcement-banner"],
      sections_url: "/",
      type: "update",
    };
    line.classList.add("cart-line__removing");
    setTimeout(() => {
      line.remove();
      updateCart(data);
    }, 1000);
  }

  addComplementaryProduct(e) {
    e.preventDefault();
    e.target.classList.add("btn-elem__loading");
    this.updating = true;
    this.toggleInteraction();
    const items = [];
    const item = {};
    const id = e.target.dataset.id;
    item.id = id;
    item.quantity = 1;
    item.product_id = e.target.dataset.productId;
    items.push(item);

    const data = {
      type: "add",
      source: "incart-upsell",
      items,
      sections: ["announcement-banner"],
      sections_url: "/",
      submitter: e.target,
      reload: false,
    };
    updateCart(data);
  }

  toggleInteraction() {
    if (this.updating) {
      this.classList.add("cart-lines__updating");
    } else {
      this.classList.remove("cart-lines__updating");
    }
  }
}

customElements.define("cart-lines", CartLines);

class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: false,
    };

    this.defaultThumbsOptions = {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 4,
      watchSlidesProgress: true,
    };

    this.elements = {
      swiper: this.querySelector(".media-gallery"),
      slides: this.querySelectorAll(".media-gallery__slide"),
      pagination: this.querySelector(".media-gallery__pagination"),
      prevButton: this.querySelector(".media-gallery__button-prev"),
      nextButton: this.querySelector(".media-gallery__button-next"),
      thumbs: this.querySelector(".media-gallery__thumbs"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };

    if (this.elements.swiper.dataset.galleryOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.galleryOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      this.swiperOptions.navigation = {
        nextEl: this.elements.nextButton,
        prevEl: this.elements.prevButton,
      };
    }

    if (this.elements.pagination) {
      this.swiperOptions.pagination = {
        el: this.elements.pagination,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      };
    }

    if (this.elements.thumbs) {
      this.thumbsSwiperOptions = {
        ...this.defaultThumbsOptions,
      };
      if (this.elements.thumbs.dataset.galleryOptions) {
        this.thumbsSwiperOptions = {
          ...this.defaultThumbsOptions,
          ...JSON.parse(this.elements.thumbs.dataset.galleryOptions),
        };
      }
      this.swiperOptions.thumbs = {
        swiper: this.elements.thumbs,
      };
    }

    for (const [index, slide] of this.elements.slides.entries()) {
      if (slide.dataset.mediaPrimary != null) {
        this.mediaPrimary = this.elements.swiper.querySelector("[data-media-primary]");
        this.mediaPrimaryImg = this.mediaPrimary.querySelector("img");
        this.mediaPrimaryPosition = index;
        this.swiperOptions.initialSlide = index;
        if (this.elements.thumbs) {
          this.thumbsPrimary = this.elements.thumbs.querySelector("[data-media-primary]");
          this.thumbsPrimaryImg = this.thumbsPrimary.querySelector("img");
          this.thumbsPrimaryPosition = index;
          this.thumbsSwiperOptions.initialSlide = index;
        }
      }
    }

    this.activeVideo = null;

    this.variantImages = JSON.parse(
      this.querySelector('script[type="application/json"]').innerHTML,
    );

    this.mediaZoom = this.querySelector("media-zoom");
  }
  connectedCallback() {
    this.addEventListeners();
    this.handleZoom(this.elements.slides[0]);
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
    this.addEventListener("click", this.clickHandler.bind(this));
  }

  clickHandler(e) {
    if (e.target.classList.contains("media-gallery__play")) {
      this.videoSlide = e.target.closest(".media-gallery__slide-video");
      this.videoSlideMedia = this.videoSlide.querySelector("video");
      if (this.videoSlideMedia) {
        this.playMedia(e);
      }
    }
  }

  playMedia() {
    this.videoSlide.classList.add("video-playing");
    this.activeVideo = this.videoSlideMedia;
    this.videoSlideMedia.play();
  }

  handleZoom(activeSlide) {
    if (!this.mediaZoom) return;
    if (activeSlide.querySelector(".media-gallery__slide-video")) {
      this.mediaZoom.classList.add("hide-zoom");
    } else {
      this.mediaZoom.classList.remove("hide-zoom");
    }
    if (!activeSlide.querySelector(".luc-media img")) return;
    const max_zoom = activeSlide.dataset.original;
    if (parseInt(max_zoom) >= 1000) {
      const slideMediaURL = new URL(activeSlide.querySelector(".luc-media img").src);
      slideMediaURL.searchParams.set("width", max_zoom);
      this.mediaZoom.classList.remove("hide-zoom");
      this.mediaZoom.querySelector("[data-zoom-image]").dataset.zoomImage = slideMediaURL;
    } else {
      this.mediaZoom.classList.add("hide-zoom");
    }
  }

  init() {
    if (!this.elements.swiper) return;
    if (this.elements.thumbs) {
      this.thumbsSwiper = new Swiper(this.elements.thumbs, this.thumbsSwiperOptions);
    }
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);

    this.swiper.on("slideChange", (swiper) => {
      if (this.activeVideo) {
        this.activeVideo.pause();
        this.activeVideo.currentTime = 0;
        this.videoSlide.classList.remove("video-playing");
      }

      let activeSlide;
      for (const [index, slide] of swiper.slides.entries()) {
        if (swiper.activeIndex === index) {
          activeSlide = slide;
        }
      }

      this.handleZoom(activeSlide);
    });
  }
}
customElements.define("media-gallery", MediaGallery);

// Carousels

class MainCarousel extends HTMLElement {
  constructor() {
    super();

    this.defaultOptions = {
      loop: true,
    };

    this.elements = {
      swiper: this.querySelector(".main-carousel"),
      pagination: this.querySelector(".main-carousel__pagination"),
      prevButton: this.querySelector(".main-carousel__button-prev"),
      nextButton: this.querySelector(".main-carousel__button-next"),
    };

    this.swiperOptions = {
      ...this.defaultOptions,
    };
    if (this.elements.swiper.dataset.carouselOptions) {
      this.swiperOptions = {
        ...this.defaultOptions,
        ...JSON.parse(this.elements.swiper.dataset.carouselOptions),
      };
    }

    if (this.elements.prevButton && this.elements.nextButton) {
      if (!this.swiperOptions.navigation) {
        this.swiperOptions.navigation = {
          nextEl: this.elements.nextButton,
          prevEl: this.elements.prevButton,
        };
      }
    }

    if (this.elements.pagination) {
      if (!this.swiperOptions.pagination) {
        this.swiperOptions.pagination = {
          el: this.elements.pagination,
        };
      }
    }
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
  }

  init() {
    if (!this.elements.swiper) return;
    this.swiper = new Swiper(this.elements.swiper, this.swiperOptions);
  }
}
customElements.define("main-carousel", MainCarousel);

class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
    this.recentlyViewedHandles = JSON.parse(localStorage.getItem("recentlyViewedItems"));
    this.currentProduct = this.getAttribute("current-product");

    this.limit = +this.dataset.limit;

    if (this.currentProduct && this.recentlyViewedHandles) {
      this.recentlyViewedHandles = this.recentlyViewedHandles.filter((handle) => {
        return handle != this.currentProduct;
      });
    }

    this.events = [
      {
        el: window,
        evt: "scroll",
        callback: this.checkPosition.bind(this),
      },
    ];
    this.load_more = this.querySelector('[data-action="load"]');
    if (this.load_more) {
      if (this.recentlyViewedHandles.length > this.limit) {
        this.load_more.classList.remove("hidden");
      }
      this.events.push({
        el: this.load_more,
        evt: "click",
        callback: () => {
          this.fetchRecentlyViewed(false);
        },
      });
    }
  }

  connectedCallback() {
    this.handleEventListeners();
    this.checkPosition();
  }
  disconnectedCallback() {
    this.handleEventListeners("remove");
  }

  handleEventListeners(type = "add") {
    for (const event of this.events) {
      if (type === "add") {
        event.el.addEventListener(event.evt, event.callback);
      } else {
        event.el.removeEventListener(event.evt, event.callback);
      }
    }
  }

  checkPosition() {
    if (this.loaded) return;
    const container = this.getBoundingClientRect();
    if (
      (container.top > 0 && container.top <= window.innerHeight) ||
      (container.bottom > 0 && container.bottom <= window.innerHeight)
    ) {
      this.loaded = true;
      this.fetchRecentlyViewed();
    }
  }

  async fetchRecentlyViewed(initial = true) {
    if (!initial) {
      this.load_more.classList.add("btn--loading");
    }
    if (!this.recentlyViewedHandles) return;

    let handles = [...this.recentlyViewedHandles];
    if (this.limit) {
      if (initial) {
        handles = handles.slice(0, this.limit);
      } else {
        handles = handles.slice(this.limit + 1, handles.length - 1);
      }
    }

    try {
      const res = await fetch(`/search?view=recently-viewed-items&q=${handles.join(",")}`);
      const data = await res.text();
      if (!data) return;
      this.renderRecentlyViewed(data, initial);
    } catch (error) {
      console.log(error);
    }
    this.load_more.classList.remove("btn--loading");
  }

  renderRecentlyViewed(data, initial) {
    const items = new DOMParser()
      .parseFromString(data, "text/html")
      .querySelector(".recently-viewed__items");
    const item_wrapper = this.querySelector(".recently-viewed__items");
    if (initial) {
      item_wrapper.innerHTML = items.innerHTML;
      this.closest(".recently-viewed-section").classList.add("recently-viewed__loaded");
    } else {
      item_wrapper.innerHTML += items.innerHTML;
      this.load_more.classList.add("hidden");
    }
  }
}
customElements.define("recently-viewed", RecentlyViewed);

// Global event functions

function cartOpenCheck() {
  const params = new URLSearchParams(location.search);
  if (params.get("reloaded") === "true") {
    const drawer = document.querySelector("cart-drawer");
    drawer.setVisible();
    const url = new URL(location.href);
    url.searchParams.toString();
    url.searchParams.delete("reloaded", "true");
    history.replaceState("", "", url);
  }
}

document.addEventListener("DOMContentLoaded", cartOpenCheck);

// Hero Slideshow
class USPSlider extends HTMLElement {
  constructor() {
    super();

    this.options = JSON.parse(this.querySelector(".usp-slider__init").dataset.carouselOptions);
    this.wrapper = this.querySelector(".usp-slider__init");
  }
  connectedCallback() {
    this.buildSlideShow();
  }
  addEventListeners() {}

  buildSlideShow() {
    new Swiper(this.wrapper, this.options);
  }
}
customElements.define("usp-slider", USPSlider);

class ExtraOptions extends HTMLElement {
  constructor() {
    super();

    this.events = [
      {
        type: "input",
        el: this,
        callback: this.inputHandler.bind(this),
      },
    ];
  }
  connectedCallback() {
    handleEventListeners(this.events, "add");
  }

  inputHandler(e) {
    const value = e.target.value.trim();
    if (value.length > 0) {
      this.valid = true;
    } else {
      this.valid = false;
    }

    const data = {
      type: "personalise",
      state: {
        personalise: { accept: this.valid },
      },
    };
    publish(PUB_SUB_EVENTS.productState, data);
  }
}

customElements.define("extra-options", ExtraOptions);

class ShippingValidator extends HTMLElement {
  constructor() {
    super();

    this.active_option = "local";

    this.eligible = ["F12", "F31", "F23", "F35", "H54", "F45"];
    this.code_input = this.querySelector("input.shipping-option__code");
    this.message = this.querySelector(".shipping-option__message");

    this.events = [
      {
        type: "input",
        el: this,
        callback: this.inputHandler.bind(this),
      },
    ];
  }
  connectedCallback() {
    handleEventListeners(this.events, "add");
  }

  codeHandler(e) {
    const value = e.target.value.trim().toUpperCase().slice(0, 3);
    if (value.length < 3) {
      this.message.style.display = "none";
    } else {
      this.message.style.display = "block";
    }
    if (this.eligible.includes(value)) {
      this.message.innerHTML =
        "<div class='stock-levels__message'><span class='stock-icon green-stock'></span> This product can be delivered to your address!</div>";
      this.message.style.color = "green";
      this.valid = true;
    } else {
      this.message.innerHTML =
        "<div class='stock-levels__message'><span class='stock-icon red-stock'></span>Sorry, your address is not eligible for local delivery.</div>";
      this.message.style.color = "#d5333c";
      this.valid = false;
    }
  }

  inputHandler(e) {
    if (e.target.tagName === "INPUT" && e.target.getAttribute("type") === "radio") {
      this.active_option = e.target.dataset.option;
      this.active_option === "pickup" ? (this.valid = true) : (this.valid = false);
    } else if (e.target.tagName === "INPUT" && e.target.getAttribute("type") === "checkbox") {
      this.active_option === "local" && e.target.checked
        ? ((this.valid = true), (this.code_input.disabled = true))
        : ((this.valid = false), (this.code_input.disabled = false));
    } else {
      this.codeHandler(e);
    }
    this.handleButtons();
  }

  handleButtons() {
    const data = {
      type: "shipping",
      state: {
        shipping: { accept: this.valid },
      },
    };
    publish(PUB_SUB_EVENTS.productState, data);
  }
}

customElements.define("shipping-validator", ShippingValidator);

class PromotionBanner extends HTMLElement {
  constructor() {
    super();

    this.startDate = this.parseDate(this.dataset.startDate);
    this.endDate = this.parseDate(this.dataset.endDate);
  }

  connectedCallback() {
    this.checkVisibility();
    this._interval = setInterval(this.checkVisibility.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  parseDate(value) {
    if (!value) return null;
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  isActive(now) {
    if (this.startDate && now < this.startDate) return false;
    if (this.endDate && now >= this.endDate) return false;
    return true;
  }

  isFinished(now) {
    return this.endDate ? now >= this.endDate : false;
  }

  checkVisibility() {
    const now = new Date();

    this.classList.toggle("hidden", !this.isActive(now));

    // Only tear down once the end date has passed, not while waiting to start
    if (this.isFinished(now)) {
      this.disconnectedCallback();
      this.remove();
    }
  }
}

customElements.define("promotion-banner", PromotionBanner);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.is_open = false;
  }
  connectedCallback() {
    this.addEventListeners();
  }
  addEventListeners() {
    this.addEventListener("click", this.clickHandler.bind(this));
    document.addEventListener("keydown", this.keyboardHandler.bind(this));
  }
  clickHandler(e) {
    const action_target =
      e.target.closest("[modal-dialog-action]")?.getAttribute("modal-dialog-action") || null;
    if (action_target === "open") {
      e.preventDefault();
      this.openModal();
    } else if (action_target === "close" || !e.target.closest(".modal-main__inner")) {
      e.preventDefault();
      this.closeModal();
    }
  }
  keyboardHandler(e) {
    if ((e.key === "Escape" || e.keyCode === 27) && this.is_open === true) {
      this.closeModal();
    }
  }
  openModal() {
    this.is_open = true;
    this.setAttribute("aria-hidden", "false");
    this.setAttribute("modal-dialog-view", "visible");
  }
  closeModal() {
    this.is_open = false;
    this.setAttribute("aria-hidden", "true");
    this.setAttribute("modal-dialog-view", "hidden");
  }
}

customElements.define("modal-dialog", ModalDialog);

class MediaZoom extends ModalDialog {
  constructor() {
    super();
    this.x = 50;
    this.y = 50;
    this.s = 100;
    this.cartridge = this.querySelector("[data-zoom-image]");

    this.eventCache = [];
    this.previousDiff = -1;
    this.current_index = 0;
    this.images = this.dataset.images?.split(",");
  }

  addEventListeners() {
    super.addEventListeners();
    this.cartridge.addEventListener("wheel", this.coarseHandler.bind(this));
    this.cartridge.addEventListener("mousedown", this.panStartHandler.bind(this));
    this.cartridge.addEventListener("mouseup", this.panEndHandler.bind(this));
    this.cartridge.addEventListener("mouseleave", this.panEndHandler.bind(this));
    this.cartridge.addEventListener("mousemove", this.panHandler.bind(this));

    this.cartridge.addEventListener("pointerdown", this.pointerDownHandler.bind(this));
    this.cartridge.addEventListener("pointermove", this.pointerMoveHandler.bind(this));
    this.cartridge.addEventListener("pointerup", this.pointerUpHandler.bind(this));
    this.cartridge.addEventListener("pointercancel", this.pointerUpHandler.bind(this));
    this.cartridge.addEventListener("pointerout", this.pointerUpHandler.bind(this));
    this.cartridge.addEventListener("pointerleave", this.pointerUpHandler.bind(this));
  }

  openModal() {
    super.openModal();
    this.cartridgeWidth = this.cartridge.offsetWidth;
    this.cartridgeHeight = this.cartridge.offsetHeight;
    for (const [index, image] of this.images.entries()) {
      const image_path = image.split("/shop/files/")[1].split("?")[0];
      if (this.cartridge.dataset.zoomImage.includes(image_path)) {
        this.current_index = index;
      }
    }

    this.loadImage();
  }

  closeModal() {
    super.closeModal();
    this.resetZoom();
    this.current_index = 0;
  }

  clickHandler(e) {
    super.clickHandler(e);
    if (e.target.dataset.navigation === "next" || e.target.dataset.navigation === "prev") {
      this.refreshMedia(e.target.dataset.navigation);
    }
  }

  keyboardHandler(e) {
    super.keyboardHandler(e);
    if (e.key === "ArrowRight" || e.keyCode === 39) {
      this.refreshMedia("next");
    }
    if (e.key === "ArrowLeft" || e.keyCode === 37) {
      this.refreshMedia("prev");
    }
  }

  setZoom(delta) {
    this.s -= delta;
    this.s = Math.min(Math.max(this.s, 100), 200);
    if (this.cartridgeWidth > this.cartridgeHeight) {
      this.cartridge.style.backgroundSize = `auto ${this.s}%`;
    } else if (this.cartridgeWidth < this.cartridgeHeight) {
      this.cartridge.style.backgroundSize = `${this.s}% auto`;
    } else {
      this.cartridge.style.backgroundSize = `${this.s}% ${this.s}%`;
    }
  }

  coarseHandler(e) {
    e.preventDefault();
    if (e.type === "wheel") {
      this.setZoom(e.deltaY);
    }
  }

  panStartHandler(e) {
    if (
      typeof this.y == "undefined" ||
      typeof this.x == "undefined" ||
      typeof this.s == "undefined"
    ) {
      this.x = 50;
      this.y = 50;
      this.s = 100;
    }
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.cartridge.classList.add("panning");
    this.mouseDown = true;
  }

  panEndHandler(e) {
    this.cartridge.classList.remove("panning");
    this.x = this.deltaX;
    this.y = this.deltaY;
    this.mouseDown = false;
  }

  panHandler(e) {
    if (!this.mouseDown) return;
    const deltaX = e.x - this.startX;
    const deltaY = e.y - this.startY;
    const deltaXPercentage = (deltaX / this.cartridgeWidth) * 100;
    const deltaYPercentage = (deltaY / this.cartridgeHeight) * 100;
    if (this.cartridgeWidth < this.cartridgeHeight) {
      this.deltaX = Math.min(Math.max(this.x - deltaXPercentage * (this.s / 100), 0), 100);
    } else {
      this.deltaX = Math.min(Math.max(this.x + deltaXPercentage * (this.s / 100), 0), 100);
    }
    this.deltaY = Math.min(Math.max(this.y - deltaYPercentage * (this.s / 100), 0), 100);
    this.cartridge.style.backgroundPosition = `${this.deltaX}% ${this.deltaY}%`;
  }

  pointerDownHandler(e) {
    this.eventCache.push(e);
    if (this.eventCache.length === 1) {
      this.panStartHandler(e);
    } else {
      this.panEndHandler(e);
    }
  }

  pointerMoveHandler(e) {
    const index = this.eventCache.findIndex((cachedEvent) => cachedEvent.pointerId === e.pointerId);
    this.eventCache[index] = e;

    if (this.eventCache.length === 2) {
      const currentDiff = Math.abs(this.eventCache[0].clientX - this.eventCache[1].clientX);

      if (this.previousDiff > 0) {
        const delta = this.previousDiff - currentDiff;
        this.setZoom(delta);
      }

      this.previousDiff = currentDiff;
    } else {
      this.panHandler(e);
    }
  }

  pointerUpHandler(e) {
    const index = this.eventCache.findIndex((cachedEvent) => cachedEvent.pointerId === e.pointerId);
    this.eventCache.splice(index, 1);
    if (this.eventCache.length < 2) {
      this.previousDiff = -1;
    }
    if (this.eventCache.length <= 0) {
      this.x = this.deltaX;
      this.y = this.deltaY;
      this.mouseDown = false;
    }
  }

  loadImage() {
    this.cartridge.style.backgroundImage = `url(${this.cartridge.dataset.zoomImage})`;
  }

  resetZoom() {
    this.x = 50;
    this.y = 50;
    this.s = 100;
    this.cartridge.removeAttribute("style");
  }
  refreshMedia(navigation) {
    if (navigation === "next") {
      this.current_index = this.current_index + 1;
    } else {
      this.current_index = this.current_index - 1;
    }
    if (this.current_index > this.images.length - 1) {
      this.current_index = 0;
    }
    if (this.current_index < 0) {
      this.current_index = this.images.length - 1;
    }
    this.resetZoom();
    this.cartridge.style.backgroundImage = `url(${this.images[this.current_index]})`;
  }
}

customElements.define("media-zoom", MediaZoom);

class SizeGuideModal extends ModalDialog {
  constructor() {
    super();
    this.x = 50;
    this.y = 50;
    this.s = 100;
    this.cartridge = this.querySelector("[data-zoom-image]");

    this.eventCache = [];
    this.previousDiff = -1;
  }

  addEventListeners() {
    super.addEventListeners();
    this.cartridge.addEventListener("wheel", this.coarseHandler.bind(this));
    this.cartridge.addEventListener("mousedown", this.panStartHandler.bind(this));
    this.cartridge.addEventListener("mouseup", this.panEndHandler.bind(this));
    this.cartridge.addEventListener("mouseleave", this.panEndHandler.bind(this));
    this.cartridge.addEventListener("mousemove", this.panHandler.bind(this));

    this.cartridge.addEventListener("pointerdown", this.pointerDownHandler.bind(this));
    this.cartridge.addEventListener("pointermove", this.pointerMoveHandler.bind(this));
    this.cartridge.addEventListener("pointerup", this.pointerUpHandler.bind(this));
    this.cartridge.addEventListener("pointercancel", this.pointerUpHandler.bind(this));
    this.cartridge.addEventListener("pointerout", this.pointerUpHandler.bind(this));
    this.cartridge.addEventListener("pointerleave", this.pointerUpHandler.bind(this));
  }

  openModal() {
    super.openModal();
    this.cartridgeWidth = this.cartridge.offsetWidth;
    this.cartridgeHeight = this.cartridge.offsetHeight;
    this.loadImage();
  }

  closeModal() {
    super.closeModal();
    this.resetZoom();
  }

  setZoom(delta) {
    this.s -= delta;
    this.s = Math.min(Math.max(this.s, 100), 200);
    if (this.cartridgeWidth > this.cartridgeHeight) {
      this.cartridge.style.backgroundSize = `auto ${this.s}%`;
    } else if (this.cartridgeWidth < this.cartridgeHeight) {
      this.cartridge.style.backgroundSize = `${this.s}% auto`;
    } else {
      this.cartridge.style.backgroundSize = `${this.s}% ${this.s}%`;
    }
  }

  coarseHandler(e) {
    e.preventDefault();
    if (e.type === "wheel") {
      this.setZoom(e.deltaY);
    }
  }

  panStartHandler(e) {
    if (
      typeof this.y == "undefined" ||
      typeof this.x == "undefined" ||
      typeof this.s == "undefined"
    ) {
      this.x = 50;
      this.y = 50;
      this.s = 100;
    }
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.cartridge.classList.add("panning");
    this.mouseDown = true;
  }

  panEndHandler(e) {
    this.cartridge.classList.remove("panning");
    this.x = this.deltaX;
    this.y = this.deltaY;
    this.mouseDown = false;
  }

  panHandler(e) {
    if (!this.mouseDown) return;

    const deltaX = e.x - this.startX;
    const deltaY = e.y - this.startY;
    const deltaXPercentage = (deltaX / this.cartridgeWidth) * 100;
    const deltaYPercentage = (deltaY / this.cartridgeHeight) * 100;
    if (this.cartridgeWidth < this.cartridgeHeight) {
      this.deltaX = Math.min(Math.max(this.x - deltaXPercentage * (this.s / 100), 0), 100);
    } else {
      this.deltaX = Math.min(Math.max(this.x + deltaXPercentage * (this.s / 100), 0), 100);
    }
    this.deltaY = Math.min(Math.max(this.y - deltaYPercentage * (this.s / 100), 0), 100);
    this.cartridge.style.backgroundPosition = `${this.deltaX}% ${this.deltaY}%`;
  }

  pointerDownHandler(e) {
    this.eventCache.push(e);
    if (this.eventCache.length === 1) {
      this.panStartHandler(e);
    } else {
      this.panEndHandler(e);
    }
  }

  pointerMoveHandler(e) {
    const index = this.eventCache.findIndex((cachedEvent) => cachedEvent.pointerId === e.pointerId);
    this.eventCache[index] = e;

    if (this.eventCache.length === 2) {
      const currentDiff = Math.abs(this.eventCache[0].clientX - this.eventCache[1].clientX);

      if (this.previousDiff > 0) {
        const delta = this.previousDiff - currentDiff;
        this.setZoom(delta);
      }

      this.previousDiff = currentDiff;
    } else {
      this.panHandler(e);
    }
  }

  pointerUpHandler(e) {
    const index = this.eventCache.findIndex((cachedEvent) => cachedEvent.pointerId === e.pointerId);
    this.eventCache.splice(index, 1);
    if (this.eventCache.length < 2) {
      this.previousDiff = -1;
    }
    if (this.eventCache.length <= 0) {
      this.x = this.deltaX;
      this.y = this.deltaY;
      this.mouseDown = false;
    }
  }

  loadImage() {
    this.cartridge.style.backgroundImage = `url(${this.cartridge.dataset.zoomImage})`;
  }

  resetZoom() {
    this.x = 50;
    this.y = 50;
    this.s = 100;
    this.cartridge.removeAttribute("style");
  }
}

customElements.define("size-guide-modal", SizeGuideModal);

class PromotionAccordions extends HTMLElement {
  constructor() {
    super();

    this.startDate1 = this.parseDate(this.dataset["startDate1"]);
    this.endDate1 = this.parseDate(this.dataset["endDate1"]);
    this.startDate2 = this.parseDate(this.dataset["startDate2"]);
    this.endDate2 = this.parseDate(this.dataset["endDate2"]);

    this.promo1Elements = this.querySelectorAll(".promo-offer-1");
    this.promo2Elements = this.querySelectorAll(".promo-offer-2");

    this.hasPromo1 = this.promo1Elements.length > 0;
    this.hasPromo2 = this.promo2Elements.length > 0;
  }

  connectedCallback() {
    this.checkVisibility();
    this._interval = setInterval(this.checkVisibility.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  parseDate(value) {
    if (!value) return null;
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  // Live now: started (or no start set) and not yet ended (or no end set)
  isActive(start, end, now) {
    if (start && now < start) return false;
    if (end && now >= end) return false;
    return true;
  }

  // Finished for good. No end date means it never finishes.
  isFinished(end, now) {
    return end ? now >= end : false;
  }

  toggleElements(elements, active) {
    elements.forEach((elem) => {
      elem.classList.toggle("hidden", !active);
    });
  }

  checkVisibility() {
    const now = new Date();

    const promo1Active = this.hasPromo1 && this.isActive(this.startDate1, this.endDate1, now);
    const promo2Active = this.hasPromo2 && this.isActive(this.startDate2, this.endDate2, now);

    this.toggleElements(this.promo1Elements, promo1Active);
    this.toggleElements(this.promo2Elements, promo2Active);

    // Hide the whole accordion whenever neither promo is running
    this.classList.toggle("hidden", !promo1Active && !promo2Active);

    // Only tear down once every promo has actually ended, not while waiting to start
    const promo1Done = !this.hasPromo1 || this.isFinished(this.endDate1, now);
    const promo2Done = !this.hasPromo2 || this.isFinished(this.endDate2, now);

    if (promo1Done && promo2Done) {
      this.disconnectedCallback();
      this.remove();
    }
  }
}

customElements.define("promotion-accordions", PromotionAccordions);

class CustomPopover extends HTMLElement {
  constructor() {
    super();

    this.timeout = 0;
    this.popover_button = this.querySelector("button");
    this.popover_target = this.querySelector(
      `#${this.popover_button.getAttribute("popovertarget")}`,
    );

    this.events = [
      {
        type: "mouseenter",
        el: this.popover_button,
        callback: this.handleMouseEnter.bind(this),
      },
      {
        type: "mouseleave",
        el: this,
        callback: this.handleMouseLeave.bind(this),
      },
      {
        type: "click",
        el: this.popover_button,
        callback: this.clickHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    handleEventListeners(this.events, "add");
    this.handleAnchors();
  }
  disconnectedCallback() {
    handleEventListeners(this.events, "remove");
  }

  handleAnchors() {
    const anchor = this.dataset.anchor;
    this.popover_button.style.anchorName = anchor;
    this.popover_target.style.positionAnchor = anchor;
  }

  clickHandler(e) {
    // Prevents popover open from submitting within a form
    e.preventDefault();
  }

  handleMouseEnter(e) {
    this.timeout = setTimeout(() => {
      this.popover_target.showPopover();
    }, 500);
  }
  handleMouseLeave(e) {
    clearTimeout(this.timeout);
    this.popover_target.hidePopover();
  }
}

customElements.define("custom-popover", CustomPopover);

class AnnouncementBanner extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      this.renderAnnouncement.bind(this),
    );
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber();
  }

  renderAnnouncement({ data }) {
    if (!data.sections["announcement-banner"]) return;
    const new_node = data.sections["announcement-banner"].querySelector("announcement-banner");
    if (!new_node) return;
    this.innerHTML = new_node.innerHTML;
  }
}
customElements.define("announcement-banner", AnnouncementBanner);
